// Auto-generated emoji data
// Total: 3781 emojis across 100 categories
const embeddedData = {
    version: '1.0.0',
    totalEmojis: 3781,
    totalCategories: 100,
    data: {
        'face-smiling': [
            { code: '1F600', emoji: '😀' },
            { code: '1F603', emoji: '😃' },
            { code: '1F604', emoji: '😄' },
            { code: '1F601', emoji: '😁' },
            { code: '1F606', emoji: '😆' },
            { code: '1F605', emoji: '😅' },
            { code: '1F923', emoji: '🤣' },
            { code: '1F602', emoji: '😂' },
            { code: '1F642', emoji: '🙂' },
            { code: '1F643', emoji: '🙃' },
            { code: '1FAE0', emoji: '🫠' },
            { code: '1F609', emoji: '😉' },
            { code: '1F60A', emoji: '😊' },
            { code: '1F607', emoji: '😇' },
        ],
        'face-affection': [
            { code: '1F970', emoji: '🥰' },
            { code: '1F60D', emoji: '😍' },
            { code: '1F929', emoji: '🤩' },
            { code: '1F618', emoji: '😘' },
            { code: '1F617', emoji: '😗' },
            { code: '263A FE0F', emoji: '☺️' },
            { code: '1F61A', emoji: '😚' },
            { code: '1F619', emoji: '😙' },
            { code: '1F972', emoji: '🥲' },
        ],
        'face-tongue': [
            { code: '1F60B', emoji: '😋' },
            { code: '1F61B', emoji: '😛' },
            { code: '1F61C', emoji: '😜' },
            { code: '1F92A', emoji: '🤪' },
            { code: '1F61D', emoji: '😝' },
            { code: '1F911', emoji: '🤑' },
        ],
        'face-hand': [
            { code: '1F917', emoji: '🤗' },
            { code: '1F92D', emoji: '🤭' },
            { code: '1FAE2', emoji: '🫢' },
            { code: '1FAE3', emoji: '🫣' },
            { code: '1F92B', emoji: '🤫' },
            { code: '1F914', emoji: '🤔' },
            { code: '1FAE1', emoji: '🫡' },
        ],
        'face-neutral-skeptical': [
            { code: '1F910', emoji: '🤐' },
            { code: '1F928', emoji: '🤨' },
            { code: '1F610', emoji: '😐' },
            { code: '1F611', emoji: '😑' },
            { code: '1F636', emoji: '😶' },
            { code: '1FAE5', emoji: '🫥' },
            { code: '1F636 200D 1F32B FE0F', emoji: '😶‍🌫️' },
            { code: '1F60F', emoji: '😏' },
            { code: '1F612', emoji: '😒' },
            { code: '1F644', emoji: '🙄' },
            { code: '1F62C', emoji: '😬' },
            { code: '1F62E 200D 1F4A8', emoji: '😮‍💨' },
            { code: '1F925', emoji: '🤥' },
            { code: '1FAE8', emoji: '🫨' },
            { code: '1F642 200D 2194 FE0F', emoji: '🙂‍↔️' },
            { code: '1F642 200D 2195 FE0F', emoji: '🙂‍↕️' },
        ],
        'face-sleepy': [
            { code: '1F60C', emoji: '😌' },
            { code: '1F614', emoji: '😔' },
            { code: '1F62A', emoji: '😪' },
            { code: '1F924', emoji: '🤤' },
            { code: '1F634', emoji: '😴' },
            { code: '1FAE9', emoji: '🫩' },
        ],
        'face-unwell': [
            { code: '1F637', emoji: '😷' },
            { code: '1F912', emoji: '🤒' },
            { code: '1F915', emoji: '🤕' },
            { code: '1F922', emoji: '🤢' },
            { code: '1F92E', emoji: '🤮' },
            { code: '1F927', emoji: '🤧' },
            { code: '1F975', emoji: '🥵' },
            { code: '1F976', emoji: '🥶' },
            { code: '1F974', emoji: '🥴' },
            { code: '1F635', emoji: '😵' },
            { code: '1F635 200D 1F4AB', emoji: '😵‍💫' },
            { code: '1F92F', emoji: '🤯' },
        ],
        'face-hat': [
            { code: '1F920', emoji: '🤠' },
            { code: '1F973', emoji: '🥳' },
            { code: '1F978', emoji: '🥸' },
        ],
        'face-glasses': [
            { code: '1F60E', emoji: '😎' },
            { code: '1F913', emoji: '🤓' },
            { code: '1F9D0', emoji: '🧐' },
        ],
        'face-concerned': [
            { code: '1F615', emoji: '😕' },
            { code: '1FAE4', emoji: '🫤' },
            { code: '1F61F', emoji: '😟' },
            { code: '1F641', emoji: '🙁' },
            { code: '2639 FE0F', emoji: '☹️' },
            { code: '1F62E', emoji: '😮' },
            { code: '1F62F', emoji: '😯' },
            { code: '1F632', emoji: '😲' },
            { code: '1F633', emoji: '😳' },
            { code: '1F97A', emoji: '🥺' },
            { code: '1F979', emoji: '🥹' },
            { code: '1F626', emoji: '😦' },
            { code: '1F627', emoji: '😧' },
            { code: '1F628', emoji: '😨' },
            { code: '1F630', emoji: '😰' },
            { code: '1F625', emoji: '😥' },
            { code: '1F622', emoji: '😢' },
            { code: '1F62D', emoji: '😭' },
            { code: '1F631', emoji: '😱' },
            { code: '1F616', emoji: '😖' },
            { code: '1F623', emoji: '😣' },
            { code: '1F61E', emoji: '😞' },
            { code: '1F613', emoji: '😓' },
            { code: '1F629', emoji: '😩' },
            { code: '1F62B', emoji: '😫' },
            { code: '1F971', emoji: '🥱' },
        ],
        'face-negative': [
            { code: '1F624', emoji: '😤' },
            { code: '1F621', emoji: '😡' },
            { code: '1F620', emoji: '😠' },
            { code: '1F92C', emoji: '🤬' },
            { code: '1F608', emoji: '😈' },
            { code: '1F47F', emoji: '👿' },
            { code: '1F480', emoji: '💀' },
            { code: '2620 FE0F', emoji: '☠️' },
        ],
        'face-costume': [
            { code: '1F4A9', emoji: '💩' },
            { code: '1F921', emoji: '🤡' },
            { code: '1F479', emoji: '👹' },
            { code: '1F47A', emoji: '👺' },
            { code: '1F47B', emoji: '👻' },
            { code: '1F47D', emoji: '👽' },
            { code: '1F47E', emoji: '👾' },
            { code: '1F916', emoji: '🤖' },
        ],
        'cat-face': [
            { code: '1F63A', emoji: '😺' },
            { code: '1F638', emoji: '😸' },
            { code: '1F639', emoji: '😹' },
            { code: '1F63B', emoji: '😻' },
            { code: '1F63C', emoji: '😼' },
            { code: '1F63D', emoji: '😽' },
            { code: '1F640', emoji: '🙀' },
            { code: '1F63F', emoji: '😿' },
            { code: '1F63E', emoji: '😾' },
        ],
        'monkey-face': [
            { code: '1F648', emoji: '🙈' },
            { code: '1F649', emoji: '🙉' },
            { code: '1F64A', emoji: '🙊' },
        ],
        'heart': [
            { code: '1F48C', emoji: '💌' },
            { code: '1F498', emoji: '💘' },
            { code: '1F49D', emoji: '💝' },
            { code: '1F496', emoji: '💖' },
            { code: '1F497', emoji: '💗' },
            { code: '1F493', emoji: '💓' },
            { code: '1F49E', emoji: '💞' },
            { code: '1F495', emoji: '💕' },
            { code: '1F49F', emoji: '💟' },
            { code: '2763 FE0F', emoji: '❣️' },
            { code: '1F494', emoji: '💔' },
            { code: '2764 FE0F 200D 1F525', emoji: '❤️‍🔥' },
            { code: '2764 FE0F 200D 1FA79', emoji: '❤️‍🩹' },
            { code: '2764 FE0F', emoji: '❤️' },
            { code: '1FA77', emoji: '🩷' },
            { code: '1F9E1', emoji: '🧡' },
            { code: '1F49B', emoji: '💛' },
            { code: '1F49A', emoji: '💚' },
            { code: '1F499', emoji: '💙' },
            { code: '1FA75', emoji: '🩵' },
            { code: '1F49C', emoji: '💜' },
            { code: '1F90E', emoji: '🤎' },
            { code: '1F5A4', emoji: '🖤' },
            { code: '1FA76', emoji: '🩶' },
            { code: '1F90D', emoji: '🤍' },
        ],
        'emotion': [
            { code: '1F48B', emoji: '💋' },
            { code: '1F4AF', emoji: '💯' },
            { code: '1F4A2', emoji: '💢' },
            { code: '1F4A5', emoji: '💥' },
            { code: '1F4AB', emoji: '💫' },
            { code: '1F4A6', emoji: '💦' },
            { code: '1F4A8', emoji: '💨' },
            { code: '1F573 FE0F', emoji: '🕳️' },
            { code: '1F4AC', emoji: '💬' },
            { code: '1F441 FE0F 200D 1F5E8 FE0F', emoji: '👁️‍🗨️' },
            { code: '1F5E8 FE0F', emoji: '🗨️' },
            { code: '1F5EF FE0F', emoji: '🗯️' },
            { code: '1F4AD', emoji: '💭' },
            { code: '1F4A4', emoji: '💤' },
        ],
        'hand-fingers-open': [
            { code: '1F44B', emoji: '👋' },
            { code: '1F44B 1F3FB', emoji: '👋🏻' },
            { code: '1F44B 1F3FC', emoji: '👋🏼' },
            { code: '1F44B 1F3FD', emoji: '👋🏽' },
            { code: '1F44B 1F3FE', emoji: '👋🏾' },
            { code: '1F44B 1F3FF', emoji: '👋🏿' },
            { code: '1F91A', emoji: '🤚' },
            { code: '1F91A 1F3FB', emoji: '🤚🏻' },
            { code: '1F91A 1F3FC', emoji: '🤚🏼' },
            { code: '1F91A 1F3FD', emoji: '🤚🏽' },
            { code: '1F91A 1F3FE', emoji: '🤚🏾' },
            { code: '1F91A 1F3FF', emoji: '🤚🏿' },
            { code: '1F590 FE0F', emoji: '🖐️' },
            { code: '1F590 1F3FB', emoji: '🖐🏻' },
            { code: '1F590 1F3FC', emoji: '🖐🏼' },
            { code: '1F590 1F3FD', emoji: '🖐🏽' },
            { code: '1F590 1F3FE', emoji: '🖐🏾' },
            { code: '1F590 1F3FF', emoji: '🖐🏿' },
            { code: '270B', emoji: '✋' },
            { code: '270B 1F3FB', emoji: '✋🏻' },
            { code: '270B 1F3FC', emoji: '✋🏼' },
            { code: '270B 1F3FD', emoji: '✋🏽' },
            { code: '270B 1F3FE', emoji: '✋🏾' },
            { code: '270B 1F3FF', emoji: '✋🏿' },
            { code: '1F596', emoji: '🖖' },
            { code: '1F596 1F3FB', emoji: '🖖🏻' },
            { code: '1F596 1F3FC', emoji: '🖖🏼' },
            { code: '1F596 1F3FD', emoji: '🖖🏽' },
            { code: '1F596 1F3FE', emoji: '🖖🏾' },
            { code: '1F596 1F3FF', emoji: '🖖🏿' },
            { code: '1FAF1', emoji: '🫱' },
            { code: '1FAF1 1F3FB', emoji: '🫱🏻' },
            { code: '1FAF1 1F3FC', emoji: '🫱🏼' },
            { code: '1FAF1 1F3FD', emoji: '🫱🏽' },
            { code: '1FAF1 1F3FE', emoji: '🫱🏾' },
            { code: '1FAF1 1F3FF', emoji: '🫱🏿' },
            { code: '1FAF2', emoji: '🫲' },
            { code: '1FAF2 1F3FB', emoji: '🫲🏻' },
            { code: '1FAF2 1F3FC', emoji: '🫲🏼' },
            { code: '1FAF2 1F3FD', emoji: '🫲🏽' },
            { code: '1FAF2 1F3FE', emoji: '🫲🏾' },
            { code: '1FAF2 1F3FF', emoji: '🫲🏿' },
            { code: '1FAF3', emoji: '🫳' },
            { code: '1FAF3 1F3FB', emoji: '🫳🏻' },
            { code: '1FAF3 1F3FC', emoji: '🫳🏼' },
            { code: '1FAF3 1F3FD', emoji: '🫳🏽' },
            { code: '1FAF3 1F3FE', emoji: '🫳🏾' },
            { code: '1FAF3 1F3FF', emoji: '🫳🏿' },
            { code: '1FAF4', emoji: '🫴' },
            { code: '1FAF4 1F3FB', emoji: '🫴🏻' },
            { code: '1FAF4 1F3FC', emoji: '🫴🏼' },
            { code: '1FAF4 1F3FD', emoji: '🫴🏽' },
            { code: '1FAF4 1F3FE', emoji: '🫴🏾' },
            { code: '1FAF4 1F3FF', emoji: '🫴🏿' },
            { code: '1FAF7', emoji: '🫷' },
            { code: '1FAF7 1F3FB', emoji: '🫷🏻' },
            { code: '1FAF7 1F3FC', emoji: '🫷🏼' },
            { code: '1FAF7 1F3FD', emoji: '🫷🏽' },
            { code: '1FAF7 1F3FE', emoji: '🫷🏾' },
            { code: '1FAF7 1F3FF', emoji: '🫷🏿' },
            { code: '1FAF8', emoji: '🫸' },
            { code: '1FAF8 1F3FB', emoji: '🫸🏻' },
            { code: '1FAF8 1F3FC', emoji: '🫸🏼' },
            { code: '1FAF8 1F3FD', emoji: '🫸🏽' },
            { code: '1FAF8 1F3FE', emoji: '🫸🏾' },
            { code: '1FAF8 1F3FF', emoji: '🫸🏿' },
        ],
        'hand-fingers-partial': [
            { code: '1F44C', emoji: '👌' },
            { code: '1F44C 1F3FB', emoji: '👌🏻' },
            { code: '1F44C 1F3FC', emoji: '👌🏼' },
            { code: '1F44C 1F3FD', emoji: '👌🏽' },
            { code: '1F44C 1F3FE', emoji: '👌🏾' },
            { code: '1F44C 1F3FF', emoji: '👌🏿' },
            { code: '1F90C', emoji: '🤌' },
            { code: '1F90C 1F3FB', emoji: '🤌🏻' },
            { code: '1F90C 1F3FC', emoji: '🤌🏼' },
            { code: '1F90C 1F3FD', emoji: '🤌🏽' },
            { code: '1F90C 1F3FE', emoji: '🤌🏾' },
            { code: '1F90C 1F3FF', emoji: '🤌🏿' },
            { code: '1F90F', emoji: '🤏' },
            { code: '1F90F 1F3FB', emoji: '🤏🏻' },
            { code: '1F90F 1F3FC', emoji: '🤏🏼' },
            { code: '1F90F 1F3FD', emoji: '🤏🏽' },
            { code: '1F90F 1F3FE', emoji: '🤏🏾' },
            { code: '1F90F 1F3FF', emoji: '🤏🏿' },
            { code: '270C FE0F', emoji: '✌️' },
            { code: '270C 1F3FB', emoji: '✌🏻' },
            { code: '270C 1F3FC', emoji: '✌🏼' },
            { code: '270C 1F3FD', emoji: '✌🏽' },
            { code: '270C 1F3FE', emoji: '✌🏾' },
            { code: '270C 1F3FF', emoji: '✌🏿' },
            { code: '1F91E', emoji: '🤞' },
            { code: '1F91E 1F3FB', emoji: '🤞🏻' },
            { code: '1F91E 1F3FC', emoji: '🤞🏼' },
            { code: '1F91E 1F3FD', emoji: '🤞🏽' },
            { code: '1F91E 1F3FE', emoji: '🤞🏾' },
            { code: '1F91E 1F3FF', emoji: '🤞🏿' },
            { code: '1FAF0', emoji: '🫰' },
            { code: '1FAF0 1F3FB', emoji: '🫰🏻' },
            { code: '1FAF0 1F3FC', emoji: '🫰🏼' },
            { code: '1FAF0 1F3FD', emoji: '🫰🏽' },
            { code: '1FAF0 1F3FE', emoji: '🫰🏾' },
            { code: '1FAF0 1F3FF', emoji: '🫰🏿' },
            { code: '1F91F', emoji: '🤟' },
            { code: '1F91F 1F3FB', emoji: '🤟🏻' },
            { code: '1F91F 1F3FC', emoji: '🤟🏼' },
            { code: '1F91F 1F3FD', emoji: '🤟🏽' },
            { code: '1F91F 1F3FE', emoji: '🤟🏾' },
            { code: '1F91F 1F3FF', emoji: '🤟🏿' },
            { code: '1F918', emoji: '🤘' },
            { code: '1F918 1F3FB', emoji: '🤘🏻' },
            { code: '1F918 1F3FC', emoji: '🤘🏼' },
            { code: '1F918 1F3FD', emoji: '🤘🏽' },
            { code: '1F918 1F3FE', emoji: '🤘🏾' },
            { code: '1F918 1F3FF', emoji: '🤘🏿' },
            { code: '1F919', emoji: '🤙' },
            { code: '1F919 1F3FB', emoji: '🤙🏻' },
            { code: '1F919 1F3FC', emoji: '🤙🏼' },
            { code: '1F919 1F3FD', emoji: '🤙🏽' },
            { code: '1F919 1F3FE', emoji: '🤙🏾' },
            { code: '1F919 1F3FF', emoji: '🤙🏿' },
        ],
        'hand-single-finger': [
            { code: '1F448', emoji: '👈' },
            { code: '1F448 1F3FB', emoji: '👈🏻' },
            { code: '1F448 1F3FC', emoji: '👈🏼' },
            { code: '1F448 1F3FD', emoji: '👈🏽' },
            { code: '1F448 1F3FE', emoji: '👈🏾' },
            { code: '1F448 1F3FF', emoji: '👈🏿' },
            { code: '1F449', emoji: '👉' },
            { code: '1F449 1F3FB', emoji: '👉🏻' },
            { code: '1F449 1F3FC', emoji: '👉🏼' },
            { code: '1F449 1F3FD', emoji: '👉🏽' },
            { code: '1F449 1F3FE', emoji: '👉🏾' },
            { code: '1F449 1F3FF', emoji: '👉🏿' },
            { code: '1F446', emoji: '👆' },
            { code: '1F446 1F3FB', emoji: '👆🏻' },
            { code: '1F446 1F3FC', emoji: '👆🏼' },
            { code: '1F446 1F3FD', emoji: '👆🏽' },
            { code: '1F446 1F3FE', emoji: '👆🏾' },
            { code: '1F446 1F3FF', emoji: '👆🏿' },
            { code: '1F595', emoji: '🖕' },
            { code: '1F595 1F3FB', emoji: '🖕🏻' },
            { code: '1F595 1F3FC', emoji: '🖕🏼' },
            { code: '1F595 1F3FD', emoji: '🖕🏽' },
            { code: '1F595 1F3FE', emoji: '🖕🏾' },
            { code: '1F595 1F3FF', emoji: '🖕🏿' },
            { code: '1F447', emoji: '👇' },
            { code: '1F447 1F3FB', emoji: '👇🏻' },
            { code: '1F447 1F3FC', emoji: '👇🏼' },
            { code: '1F447 1F3FD', emoji: '👇🏽' },
            { code: '1F447 1F3FE', emoji: '👇🏾' },
            { code: '1F447 1F3FF', emoji: '👇🏿' },
            { code: '261D FE0F', emoji: '☝️' },
            { code: '261D 1F3FB', emoji: '☝🏻' },
            { code: '261D 1F3FC', emoji: '☝🏼' },
            { code: '261D 1F3FD', emoji: '☝🏽' },
            { code: '261D 1F3FE', emoji: '☝🏾' },
            { code: '261D 1F3FF', emoji: '☝🏿' },
            { code: '1FAF5', emoji: '🫵' },
            { code: '1FAF5 1F3FB', emoji: '🫵🏻' },
            { code: '1FAF5 1F3FC', emoji: '🫵🏼' },
            { code: '1FAF5 1F3FD', emoji: '🫵🏽' },
            { code: '1FAF5 1F3FE', emoji: '🫵🏾' },
            { code: '1FAF5 1F3FF', emoji: '🫵🏿' },
        ],
        'hand-fingers-closed': [
            { code: '1F44D', emoji: '👍' },
            { code: '1F44D 1F3FB', emoji: '👍🏻' },
            { code: '1F44D 1F3FC', emoji: '👍🏼' },
            { code: '1F44D 1F3FD', emoji: '👍🏽' },
            { code: '1F44D 1F3FE', emoji: '👍🏾' },
            { code: '1F44D 1F3FF', emoji: '👍🏿' },
            { code: '1F44E', emoji: '👎' },
            { code: '1F44E 1F3FB', emoji: '👎🏻' },
            { code: '1F44E 1F3FC', emoji: '👎🏼' },
            { code: '1F44E 1F3FD', emoji: '👎🏽' },
            { code: '1F44E 1F3FE', emoji: '👎🏾' },
            { code: '1F44E 1F3FF', emoji: '👎🏿' },
            { code: '270A', emoji: '✊' },
            { code: '270A 1F3FB', emoji: '✊🏻' },
            { code: '270A 1F3FC', emoji: '✊🏼' },
            { code: '270A 1F3FD', emoji: '✊🏽' },
            { code: '270A 1F3FE', emoji: '✊🏾' },
            { code: '270A 1F3FF', emoji: '✊🏿' },
            { code: '1F44A', emoji: '👊' },
            { code: '1F44A 1F3FB', emoji: '👊🏻' },
            { code: '1F44A 1F3FC', emoji: '👊🏼' },
            { code: '1F44A 1F3FD', emoji: '👊🏽' },
            { code: '1F44A 1F3FE', emoji: '👊🏾' },
            { code: '1F44A 1F3FF', emoji: '👊🏿' },
            { code: '1F91B', emoji: '🤛' },
            { code: '1F91B 1F3FB', emoji: '🤛🏻' },
            { code: '1F91B 1F3FC', emoji: '🤛🏼' },
            { code: '1F91B 1F3FD', emoji: '🤛🏽' },
            { code: '1F91B 1F3FE', emoji: '🤛🏾' },
            { code: '1F91B 1F3FF', emoji: '🤛🏿' },
            { code: '1F91C', emoji: '🤜' },
            { code: '1F91C 1F3FB', emoji: '🤜🏻' },
            { code: '1F91C 1F3FC', emoji: '🤜🏼' },
            { code: '1F91C 1F3FD', emoji: '🤜🏽' },
            { code: '1F91C 1F3FE', emoji: '🤜🏾' },
            { code: '1F91C 1F3FF', emoji: '🤜🏿' },
        ],
        'hands': [
            { code: '1F44F', emoji: '👏' },
            { code: '1F44F 1F3FB', emoji: '👏🏻' },
            { code: '1F44F 1F3FC', emoji: '👏🏼' },
            { code: '1F44F 1F3FD', emoji: '👏🏽' },
            { code: '1F44F 1F3FE', emoji: '👏🏾' },
            { code: '1F44F 1F3FF', emoji: '👏🏿' },
            { code: '1F64C', emoji: '🙌' },
            { code: '1F64C 1F3FB', emoji: '🙌🏻' },
            { code: '1F64C 1F3FC', emoji: '🙌🏼' },
            { code: '1F64C 1F3FD', emoji: '🙌🏽' },
            { code: '1F64C 1F3FE', emoji: '🙌🏾' },
            { code: '1F64C 1F3FF', emoji: '🙌🏿' },
            { code: '1FAF6', emoji: '🫶' },
            { code: '1FAF6 1F3FB', emoji: '🫶🏻' },
            { code: '1FAF6 1F3FC', emoji: '🫶🏼' },
            { code: '1FAF6 1F3FD', emoji: '🫶🏽' },
            { code: '1FAF6 1F3FE', emoji: '🫶🏾' },
            { code: '1FAF6 1F3FF', emoji: '🫶🏿' },
            { code: '1F450', emoji: '👐' },
            { code: '1F450 1F3FB', emoji: '👐🏻' },
            { code: '1F450 1F3FC', emoji: '👐🏼' },
            { code: '1F450 1F3FD', emoji: '👐🏽' },
            { code: '1F450 1F3FE', emoji: '👐🏾' },
            { code: '1F450 1F3FF', emoji: '👐🏿' },
            { code: '1F932', emoji: '🤲' },
            { code: '1F932 1F3FB', emoji: '🤲🏻' },
            { code: '1F932 1F3FC', emoji: '🤲🏼' },
            { code: '1F932 1F3FD', emoji: '🤲🏽' },
            { code: '1F932 1F3FE', emoji: '🤲🏾' },
            { code: '1F932 1F3FF', emoji: '🤲🏿' },
            { code: '1F91D', emoji: '🤝' },
            { code: '1F91D 1F3FB', emoji: '🤝🏻' },
            { code: '1F91D 1F3FC', emoji: '🤝🏼' },
            { code: '1F91D 1F3FD', emoji: '🤝🏽' },
            { code: '1F91D 1F3FE', emoji: '🤝🏾' },
            { code: '1F91D 1F3FF', emoji: '🤝🏿' },
            { code: '1FAF1 1F3FB 200D 1FAF2 1F3FC', emoji: '🫱🏻‍🫲🏼' },
            { code: '1FAF1 1F3FB 200D 1FAF2 1F3FD', emoji: '🫱🏻‍🫲🏽' },
            { code: '1FAF1 1F3FB 200D 1FAF2 1F3FE', emoji: '🫱🏻‍🫲🏾' },
            { code: '1FAF1 1F3FB 200D 1FAF2 1F3FF', emoji: '🫱🏻‍🫲🏿' },
            { code: '1FAF1 1F3FC 200D 1FAF2 1F3FB', emoji: '🫱🏼‍🫲🏻' },
            { code: '1FAF1 1F3FC 200D 1FAF2 1F3FD', emoji: '🫱🏼‍🫲🏽' },
            { code: '1FAF1 1F3FC 200D 1FAF2 1F3FE', emoji: '🫱🏼‍🫲🏾' },
            { code: '1FAF1 1F3FC 200D 1FAF2 1F3FF', emoji: '🫱🏼‍🫲🏿' },
            { code: '1FAF1 1F3FD 200D 1FAF2 1F3FB', emoji: '🫱🏽‍🫲🏻' },
            { code: '1FAF1 1F3FD 200D 1FAF2 1F3FC', emoji: '🫱🏽‍🫲🏼' },
            { code: '1FAF1 1F3FD 200D 1FAF2 1F3FE', emoji: '🫱🏽‍🫲🏾' },
            { code: '1FAF1 1F3FD 200D 1FAF2 1F3FF', emoji: '🫱🏽‍🫲🏿' },
            { code: '1FAF1 1F3FE 200D 1FAF2 1F3FB', emoji: '🫱🏾‍🫲🏻' },
            { code: '1FAF1 1F3FE 200D 1FAF2 1F3FC', emoji: '🫱🏾‍🫲🏼' },
            { code: '1FAF1 1F3FE 200D 1FAF2 1F3FD', emoji: '🫱🏾‍🫲🏽' },
            { code: '1FAF1 1F3FE 200D 1FAF2 1F3FF', emoji: '🫱🏾‍🫲🏿' },
            { code: '1FAF1 1F3FF 200D 1FAF2 1F3FB', emoji: '🫱🏿‍🫲🏻' },
            { code: '1FAF1 1F3FF 200D 1FAF2 1F3FC', emoji: '🫱🏿‍🫲🏼' },
            { code: '1FAF1 1F3FF 200D 1FAF2 1F3FD', emoji: '🫱🏿‍🫲🏽' },
            { code: '1FAF1 1F3FF 200D 1FAF2 1F3FE', emoji: '🫱🏿‍🫲🏾' },
            { code: '1F64F', emoji: '🙏' },
            { code: '1F64F 1F3FB', emoji: '🙏🏻' },
            { code: '1F64F 1F3FC', emoji: '🙏🏼' },
            { code: '1F64F 1F3FD', emoji: '🙏🏽' },
            { code: '1F64F 1F3FE', emoji: '🙏🏾' },
            { code: '1F64F 1F3FF', emoji: '🙏🏿' },
        ],
        'hand-prop': [
            { code: '270D FE0F', emoji: '✍️' },
            { code: '270D 1F3FB', emoji: '✍🏻' },
            { code: '270D 1F3FC', emoji: '✍🏼' },
            { code: '270D 1F3FD', emoji: '✍🏽' },
            { code: '270D 1F3FE', emoji: '✍🏾' },
            { code: '270D 1F3FF', emoji: '✍🏿' },
            { code: '1F485', emoji: '💅' },
            { code: '1F485 1F3FB', emoji: '💅🏻' },
            { code: '1F485 1F3FC', emoji: '💅🏼' },
            { code: '1F485 1F3FD', emoji: '💅🏽' },
            { code: '1F485 1F3FE', emoji: '💅🏾' },
            { code: '1F485 1F3FF', emoji: '💅🏿' },
            { code: '1F933', emoji: '🤳' },
            { code: '1F933 1F3FB', emoji: '🤳🏻' },
            { code: '1F933 1F3FC', emoji: '🤳🏼' },
            { code: '1F933 1F3FD', emoji: '🤳🏽' },
            { code: '1F933 1F3FE', emoji: '🤳🏾' },
            { code: '1F933 1F3FF', emoji: '🤳🏿' },
        ],
        'body-parts': [
            { code: '1F4AA', emoji: '💪' },
            { code: '1F4AA 1F3FB', emoji: '💪🏻' },
            { code: '1F4AA 1F3FC', emoji: '💪🏼' },
            { code: '1F4AA 1F3FD', emoji: '💪🏽' },
            { code: '1F4AA 1F3FE', emoji: '💪🏾' },
            { code: '1F4AA 1F3FF', emoji: '💪🏿' },
            { code: '1F9BE', emoji: '🦾' },
            { code: '1F9BF', emoji: '🦿' },
            { code: '1F9B5', emoji: '🦵' },
            { code: '1F9B5 1F3FB', emoji: '🦵🏻' },
            { code: '1F9B5 1F3FC', emoji: '🦵🏼' },
            { code: '1F9B5 1F3FD', emoji: '🦵🏽' },
            { code: '1F9B5 1F3FE', emoji: '🦵🏾' },
            { code: '1F9B5 1F3FF', emoji: '🦵🏿' },
            { code: '1F9B6', emoji: '🦶' },
            { code: '1F9B6 1F3FB', emoji: '🦶🏻' },
            { code: '1F9B6 1F3FC', emoji: '🦶🏼' },
            { code: '1F9B6 1F3FD', emoji: '🦶🏽' },
            { code: '1F9B6 1F3FE', emoji: '🦶🏾' },
            { code: '1F9B6 1F3FF', emoji: '🦶🏿' },
            { code: '1F442', emoji: '👂' },
            { code: '1F442 1F3FB', emoji: '👂🏻' },
            { code: '1F442 1F3FC', emoji: '👂🏼' },
            { code: '1F442 1F3FD', emoji: '👂🏽' },
            { code: '1F442 1F3FE', emoji: '👂🏾' },
            { code: '1F442 1F3FF', emoji: '👂🏿' },
            { code: '1F9BB', emoji: '🦻' },
            { code: '1F9BB 1F3FB', emoji: '🦻🏻' },
            { code: '1F9BB 1F3FC', emoji: '🦻🏼' },
            { code: '1F9BB 1F3FD', emoji: '🦻🏽' },
            { code: '1F9BB 1F3FE', emoji: '🦻🏾' },
            { code: '1F9BB 1F3FF', emoji: '🦻🏿' },
            { code: '1F443', emoji: '👃' },
            { code: '1F443 1F3FB', emoji: '👃🏻' },
            { code: '1F443 1F3FC', emoji: '👃🏼' },
            { code: '1F443 1F3FD', emoji: '👃🏽' },
            { code: '1F443 1F3FE', emoji: '👃🏾' },
            { code: '1F443 1F3FF', emoji: '👃🏿' },
            { code: '1F9E0', emoji: '🧠' },
            { code: '1FAC0', emoji: '🫀' },
            { code: '1FAC1', emoji: '🫁' },
            { code: '1F9B7', emoji: '🦷' },
            { code: '1F9B4', emoji: '🦴' },
            { code: '1F440', emoji: '👀' },
            { code: '1F441 FE0F', emoji: '👁️' },
            { code: '1F445', emoji: '👅' },
            { code: '1F444', emoji: '👄' },
            { code: '1FAE6', emoji: '🫦' },
        ],
        'person': [
            { code: '1F476', emoji: '👶' },
            { code: '1F476 1F3FB', emoji: '👶🏻' },
            { code: '1F476 1F3FC', emoji: '👶🏼' },
            { code: '1F476 1F3FD', emoji: '👶🏽' },
            { code: '1F476 1F3FE', emoji: '👶🏾' },
            { code: '1F476 1F3FF', emoji: '👶🏿' },
            { code: '1F9D2', emoji: '🧒' },
            { code: '1F9D2 1F3FB', emoji: '🧒🏻' },
            { code: '1F9D2 1F3FC', emoji: '🧒🏼' },
            { code: '1F9D2 1F3FD', emoji: '🧒🏽' },
            { code: '1F9D2 1F3FE', emoji: '🧒🏾' },
            { code: '1F9D2 1F3FF', emoji: '🧒🏿' },
            { code: '1F466', emoji: '👦' },
            { code: '1F466 1F3FB', emoji: '👦🏻' },
            { code: '1F466 1F3FC', emoji: '👦🏼' },
            { code: '1F466 1F3FD', emoji: '👦🏽' },
            { code: '1F466 1F3FE', emoji: '👦🏾' },
            { code: '1F466 1F3FF', emoji: '👦🏿' },
            { code: '1F467', emoji: '👧' },
            { code: '1F467 1F3FB', emoji: '👧🏻' },
            { code: '1F467 1F3FC', emoji: '👧🏼' },
            { code: '1F467 1F3FD', emoji: '👧🏽' },
            { code: '1F467 1F3FE', emoji: '👧🏾' },
            { code: '1F467 1F3FF', emoji: '👧🏿' },
            { code: '1F9D1', emoji: '🧑' },
            { code: '1F9D1 1F3FB', emoji: '🧑🏻' },
            { code: '1F9D1 1F3FC', emoji: '🧑🏼' },
            { code: '1F9D1 1F3FD', emoji: '🧑🏽' },
            { code: '1F9D1 1F3FE', emoji: '🧑🏾' },
            { code: '1F9D1 1F3FF', emoji: '🧑🏿' },
            { code: '1F471', emoji: '👱' },
            { code: '1F471 1F3FB', emoji: '👱🏻' },
            { code: '1F471 1F3FC', emoji: '👱🏼' },
            { code: '1F471 1F3FD', emoji: '👱🏽' },
            { code: '1F471 1F3FE', emoji: '👱🏾' },
            { code: '1F471 1F3FF', emoji: '👱🏿' },
            { code: '1F468', emoji: '👨' },
            { code: '1F468 1F3FB', emoji: '👨🏻' },
            { code: '1F468 1F3FC', emoji: '👨🏼' },
            { code: '1F468 1F3FD', emoji: '👨🏽' },
            { code: '1F468 1F3FE', emoji: '👨🏾' },
            { code: '1F468 1F3FF', emoji: '👨🏿' },
            { code: '1F9D4', emoji: '🧔' },
            { code: '1F9D4 1F3FB', emoji: '🧔🏻' },
            { code: '1F9D4 1F3FC', emoji: '🧔🏼' },
            { code: '1F9D4 1F3FD', emoji: '🧔🏽' },
            { code: '1F9D4 1F3FE', emoji: '🧔🏾' },
            { code: '1F9D4 1F3FF', emoji: '🧔🏿' },
            { code: '1F9D4 200D 2642 FE0F', emoji: '🧔‍♂️' },
            { code: '1F9D4 1F3FB 200D 2642 FE0F', emoji: '🧔🏻‍♂️' },
            { code: '1F9D4 1F3FC 200D 2642 FE0F', emoji: '🧔🏼‍♂️' },
            { code: '1F9D4 1F3FD 200D 2642 FE0F', emoji: '🧔🏽‍♂️' },
            { code: '1F9D4 1F3FE 200D 2642 FE0F', emoji: '🧔🏾‍♂️' },
            { code: '1F9D4 1F3FF 200D 2642 FE0F', emoji: '🧔🏿‍♂️' },
            { code: '1F9D4 200D 2640 FE0F', emoji: '🧔‍♀️' },
            { code: '1F9D4 1F3FB 200D 2640 FE0F', emoji: '🧔🏻‍♀️' },
            { code: '1F9D4 1F3FC 200D 2640 FE0F', emoji: '🧔🏼‍♀️' },
            { code: '1F9D4 1F3FD 200D 2640 FE0F', emoji: '🧔🏽‍♀️' },
            { code: '1F9D4 1F3FE 200D 2640 FE0F', emoji: '🧔🏾‍♀️' },
            { code: '1F9D4 1F3FF 200D 2640 FE0F', emoji: '🧔🏿‍♀️' },
            { code: '1F468 200D 1F9B0', emoji: '👨‍🦰' },
            { code: '1F468 1F3FB 200D 1F9B0', emoji: '👨🏻‍🦰' },
            { code: '1F468 1F3FC 200D 1F9B0', emoji: '👨🏼‍🦰' },
            { code: '1F468 1F3FD 200D 1F9B0', emoji: '👨🏽‍🦰' },
            { code: '1F468 1F3FE 200D 1F9B0', emoji: '👨🏾‍🦰' },
            { code: '1F468 1F3FF 200D 1F9B0', emoji: '👨🏿‍🦰' },
            { code: '1F468 200D 1F9B1', emoji: '👨‍🦱' },
            { code: '1F468 1F3FB 200D 1F9B1', emoji: '👨🏻‍🦱' },
            { code: '1F468 1F3FC 200D 1F9B1', emoji: '👨🏼‍🦱' },
            { code: '1F468 1F3FD 200D 1F9B1', emoji: '👨🏽‍🦱' },
            { code: '1F468 1F3FE 200D 1F9B1', emoji: '👨🏾‍🦱' },
            { code: '1F468 1F3FF 200D 1F9B1', emoji: '👨🏿‍🦱' },
            { code: '1F468 200D 1F9B3', emoji: '👨‍🦳' },
            { code: '1F468 1F3FB 200D 1F9B3', emoji: '👨🏻‍🦳' },
            { code: '1F468 1F3FC 200D 1F9B3', emoji: '👨🏼‍🦳' },
            { code: '1F468 1F3FD 200D 1F9B3', emoji: '👨🏽‍🦳' },
            { code: '1F468 1F3FE 200D 1F9B3', emoji: '👨🏾‍🦳' },
            { code: '1F468 1F3FF 200D 1F9B3', emoji: '👨🏿‍🦳' },
            { code: '1F468 200D 1F9B2', emoji: '👨‍🦲' },
            { code: '1F468 1F3FB 200D 1F9B2', emoji: '👨🏻‍🦲' },
            { code: '1F468 1F3FC 200D 1F9B2', emoji: '👨🏼‍🦲' },
            { code: '1F468 1F3FD 200D 1F9B2', emoji: '👨🏽‍🦲' },
            { code: '1F468 1F3FE 200D 1F9B2', emoji: '👨🏾‍🦲' },
            { code: '1F468 1F3FF 200D 1F9B2', emoji: '👨🏿‍🦲' },
            { code: '1F469', emoji: '👩' },
            { code: '1F469 1F3FB', emoji: '👩🏻' },
            { code: '1F469 1F3FC', emoji: '👩🏼' },
            { code: '1F469 1F3FD', emoji: '👩🏽' },
            { code: '1F469 1F3FE', emoji: '👩🏾' },
            { code: '1F469 1F3FF', emoji: '👩🏿' },
            { code: '1F469 200D 1F9B0', emoji: '👩‍🦰' },
            { code: '1F469 1F3FB 200D 1F9B0', emoji: '👩🏻‍🦰' },
            { code: '1F469 1F3FC 200D 1F9B0', emoji: '👩🏼‍🦰' },
            { code: '1F469 1F3FD 200D 1F9B0', emoji: '👩🏽‍🦰' },
            { code: '1F469 1F3FE 200D 1F9B0', emoji: '👩🏾‍🦰' },
            { code: '1F469 1F3FF 200D 1F9B0', emoji: '👩🏿‍🦰' },
            { code: '1F9D1 200D 1F9B0', emoji: '🧑‍🦰' },
            { code: '1F9D1 1F3FB 200D 1F9B0', emoji: '🧑🏻‍🦰' },
            { code: '1F9D1 1F3FC 200D 1F9B0', emoji: '🧑🏼‍🦰' },
            { code: '1F9D1 1F3FD 200D 1F9B0', emoji: '🧑🏽‍🦰' },
            { code: '1F9D1 1F3FE 200D 1F9B0', emoji: '🧑🏾‍🦰' },
            { code: '1F9D1 1F3FF 200D 1F9B0', emoji: '🧑🏿‍🦰' },
            { code: '1F469 200D 1F9B1', emoji: '👩‍🦱' },
            { code: '1F469 1F3FB 200D 1F9B1', emoji: '👩🏻‍🦱' },
            { code: '1F469 1F3FC 200D 1F9B1', emoji: '👩🏼‍🦱' },
            { code: '1F469 1F3FD 200D 1F9B1', emoji: '👩🏽‍🦱' },
            { code: '1F469 1F3FE 200D 1F9B1', emoji: '👩🏾‍🦱' },
            { code: '1F469 1F3FF 200D 1F9B1', emoji: '👩🏿‍🦱' },
            { code: '1F9D1 200D 1F9B1', emoji: '🧑‍🦱' },
            { code: '1F9D1 1F3FB 200D 1F9B1', emoji: '🧑🏻‍🦱' },
            { code: '1F9D1 1F3FC 200D 1F9B1', emoji: '🧑🏼‍🦱' },
            { code: '1F9D1 1F3FD 200D 1F9B1', emoji: '🧑🏽‍🦱' },
            { code: '1F9D1 1F3FE 200D 1F9B1', emoji: '🧑🏾‍🦱' },
            { code: '1F9D1 1F3FF 200D 1F9B1', emoji: '🧑🏿‍🦱' },
            { code: '1F469 200D 1F9B3', emoji: '👩‍🦳' },
            { code: '1F469 1F3FB 200D 1F9B3', emoji: '👩🏻‍🦳' },
            { code: '1F469 1F3FC 200D 1F9B3', emoji: '👩🏼‍🦳' },
            { code: '1F469 1F3FD 200D 1F9B3', emoji: '👩🏽‍🦳' },
            { code: '1F469 1F3FE 200D 1F9B3', emoji: '👩🏾‍🦳' },
            { code: '1F469 1F3FF 200D 1F9B3', emoji: '👩🏿‍🦳' },
            { code: '1F9D1 200D 1F9B3', emoji: '🧑‍🦳' },
            { code: '1F9D1 1F3FB 200D 1F9B3', emoji: '🧑🏻‍🦳' },
            { code: '1F9D1 1F3FC 200D 1F9B3', emoji: '🧑🏼‍🦳' },
            { code: '1F9D1 1F3FD 200D 1F9B3', emoji: '🧑🏽‍🦳' },
            { code: '1F9D1 1F3FE 200D 1F9B3', emoji: '🧑🏾‍🦳' },
            { code: '1F9D1 1F3FF 200D 1F9B3', emoji: '🧑🏿‍🦳' },
            { code: '1F469 200D 1F9B2', emoji: '👩‍🦲' },
            { code: '1F469 1F3FB 200D 1F9B2', emoji: '👩🏻‍🦲' },
            { code: '1F469 1F3FC 200D 1F9B2', emoji: '👩🏼‍🦲' },
            { code: '1F469 1F3FD 200D 1F9B2', emoji: '👩🏽‍🦲' },
            { code: '1F469 1F3FE 200D 1F9B2', emoji: '👩🏾‍🦲' },
            { code: '1F469 1F3FF 200D 1F9B2', emoji: '👩🏿‍🦲' },
            { code: '1F9D1 200D 1F9B2', emoji: '🧑‍🦲' },
            { code: '1F9D1 1F3FB 200D 1F9B2', emoji: '🧑🏻‍🦲' },
            { code: '1F9D1 1F3FC 200D 1F9B2', emoji: '🧑🏼‍🦲' },
            { code: '1F9D1 1F3FD 200D 1F9B2', emoji: '🧑🏽‍🦲' },
            { code: '1F9D1 1F3FE 200D 1F9B2', emoji: '🧑🏾‍🦲' },
            { code: '1F9D1 1F3FF 200D 1F9B2', emoji: '🧑🏿‍🦲' },
            { code: '1F471 200D 2640 FE0F', emoji: '👱‍♀️' },
            { code: '1F471 1F3FB 200D 2640 FE0F', emoji: '👱🏻‍♀️' },
            { code: '1F471 1F3FC 200D 2640 FE0F', emoji: '👱🏼‍♀️' },
            { code: '1F471 1F3FD 200D 2640 FE0F', emoji: '👱🏽‍♀️' },
            { code: '1F471 1F3FE 200D 2640 FE0F', emoji: '👱🏾‍♀️' },
            { code: '1F471 1F3FF 200D 2640 FE0F', emoji: '👱🏿‍♀️' },
            { code: '1F471 200D 2642 FE0F', emoji: '👱‍♂️' },
            { code: '1F471 1F3FB 200D 2642 FE0F', emoji: '👱🏻‍♂️' },
            { code: '1F471 1F3FC 200D 2642 FE0F', emoji: '👱🏼‍♂️' },
            { code: '1F471 1F3FD 200D 2642 FE0F', emoji: '👱🏽‍♂️' },
            { code: '1F471 1F3FE 200D 2642 FE0F', emoji: '👱🏾‍♂️' },
            { code: '1F471 1F3FF 200D 2642 FE0F', emoji: '👱🏿‍♂️' },
            { code: '1F9D3', emoji: '🧓' },
            { code: '1F9D3 1F3FB', emoji: '🧓🏻' },
            { code: '1F9D3 1F3FC', emoji: '🧓🏼' },
            { code: '1F9D3 1F3FD', emoji: '🧓🏽' },
            { code: '1F9D3 1F3FE', emoji: '🧓🏾' },
            { code: '1F9D3 1F3FF', emoji: '🧓🏿' },
            { code: '1F474', emoji: '👴' },
            { code: '1F474 1F3FB', emoji: '👴🏻' },
            { code: '1F474 1F3FC', emoji: '👴🏼' },
            { code: '1F474 1F3FD', emoji: '👴🏽' },
            { code: '1F474 1F3FE', emoji: '👴🏾' },
            { code: '1F474 1F3FF', emoji: '👴🏿' },
            { code: '1F475', emoji: '👵' },
            { code: '1F475 1F3FB', emoji: '👵🏻' },
            { code: '1F475 1F3FC', emoji: '👵🏼' },
            { code: '1F475 1F3FD', emoji: '👵🏽' },
            { code: '1F475 1F3FE', emoji: '👵🏾' },
            { code: '1F475 1F3FF', emoji: '👵🏿' },
        ],
        'person-gesture': [
            { code: '1F64D', emoji: '🙍' },
            { code: '1F64D 1F3FB', emoji: '🙍🏻' },
            { code: '1F64D 1F3FC', emoji: '🙍🏼' },
            { code: '1F64D 1F3FD', emoji: '🙍🏽' },
            { code: '1F64D 1F3FE', emoji: '🙍🏾' },
            { code: '1F64D 1F3FF', emoji: '🙍🏿' },
            { code: '1F64D 200D 2642 FE0F', emoji: '🙍‍♂️' },
            { code: '1F64D 1F3FB 200D 2642 FE0F', emoji: '🙍🏻‍♂️' },
            { code: '1F64D 1F3FC 200D 2642 FE0F', emoji: '🙍🏼‍♂️' },
            { code: '1F64D 1F3FD 200D 2642 FE0F', emoji: '🙍🏽‍♂️' },
            { code: '1F64D 1F3FE 200D 2642 FE0F', emoji: '🙍🏾‍♂️' },
            { code: '1F64D 1F3FF 200D 2642 FE0F', emoji: '🙍🏿‍♂️' },
            { code: '1F64D 200D 2640 FE0F', emoji: '🙍‍♀️' },
            { code: '1F64D 1F3FB 200D 2640 FE0F', emoji: '🙍🏻‍♀️' },
            { code: '1F64D 1F3FC 200D 2640 FE0F', emoji: '🙍🏼‍♀️' },
            { code: '1F64D 1F3FD 200D 2640 FE0F', emoji: '🙍🏽‍♀️' },
            { code: '1F64D 1F3FE 200D 2640 FE0F', emoji: '🙍🏾‍♀️' },
            { code: '1F64D 1F3FF 200D 2640 FE0F', emoji: '🙍🏿‍♀️' },
            { code: '1F64E', emoji: '🙎' },
            { code: '1F64E 1F3FB', emoji: '🙎🏻' },
            { code: '1F64E 1F3FC', emoji: '🙎🏼' },
            { code: '1F64E 1F3FD', emoji: '🙎🏽' },
            { code: '1F64E 1F3FE', emoji: '🙎🏾' },
            { code: '1F64E 1F3FF', emoji: '🙎🏿' },
            { code: '1F64E 200D 2642 FE0F', emoji: '🙎‍♂️' },
            { code: '1F64E 1F3FB 200D 2642 FE0F', emoji: '🙎🏻‍♂️' },
            { code: '1F64E 1F3FC 200D 2642 FE0F', emoji: '🙎🏼‍♂️' },
            { code: '1F64E 1F3FD 200D 2642 FE0F', emoji: '🙎🏽‍♂️' },
            { code: '1F64E 1F3FE 200D 2642 FE0F', emoji: '🙎🏾‍♂️' },
            { code: '1F64E 1F3FF 200D 2642 FE0F', emoji: '🙎🏿‍♂️' },
            { code: '1F64E 200D 2640 FE0F', emoji: '🙎‍♀️' },
            { code: '1F64E 1F3FB 200D 2640 FE0F', emoji: '🙎🏻‍♀️' },
            { code: '1F64E 1F3FC 200D 2640 FE0F', emoji: '🙎🏼‍♀️' },
            { code: '1F64E 1F3FD 200D 2640 FE0F', emoji: '🙎🏽‍♀️' },
            { code: '1F64E 1F3FE 200D 2640 FE0F', emoji: '🙎🏾‍♀️' },
            { code: '1F64E 1F3FF 200D 2640 FE0F', emoji: '🙎🏿‍♀️' },
            { code: '1F645', emoji: '🙅' },
            { code: '1F645 1F3FB', emoji: '🙅🏻' },
            { code: '1F645 1F3FC', emoji: '🙅🏼' },
            { code: '1F645 1F3FD', emoji: '🙅🏽' },
            { code: '1F645 1F3FE', emoji: '🙅🏾' },
            { code: '1F645 1F3FF', emoji: '🙅🏿' },
            { code: '1F645 200D 2642 FE0F', emoji: '🙅‍♂️' },
            { code: '1F645 1F3FB 200D 2642 FE0F', emoji: '🙅🏻‍♂️' },
            { code: '1F645 1F3FC 200D 2642 FE0F', emoji: '🙅🏼‍♂️' },
            { code: '1F645 1F3FD 200D 2642 FE0F', emoji: '🙅🏽‍♂️' },
            { code: '1F645 1F3FE 200D 2642 FE0F', emoji: '🙅🏾‍♂️' },
            { code: '1F645 1F3FF 200D 2642 FE0F', emoji: '🙅🏿‍♂️' },
            { code: '1F645 200D 2640 FE0F', emoji: '🙅‍♀️' },
            { code: '1F645 1F3FB 200D 2640 FE0F', emoji: '🙅🏻‍♀️' },
            { code: '1F645 1F3FC 200D 2640 FE0F', emoji: '🙅🏼‍♀️' },
            { code: '1F645 1F3FD 200D 2640 FE0F', emoji: '🙅🏽‍♀️' },
            { code: '1F645 1F3FE 200D 2640 FE0F', emoji: '🙅🏾‍♀️' },
            { code: '1F645 1F3FF 200D 2640 FE0F', emoji: '🙅🏿‍♀️' },
            { code: '1F646', emoji: '🙆' },
            { code: '1F646 1F3FB', emoji: '🙆🏻' },
            { code: '1F646 1F3FC', emoji: '🙆🏼' },
            { code: '1F646 1F3FD', emoji: '🙆🏽' },
            { code: '1F646 1F3FE', emoji: '🙆🏾' },
            { code: '1F646 1F3FF', emoji: '🙆🏿' },
            { code: '1F646 200D 2642 FE0F', emoji: '🙆‍♂️' },
            { code: '1F646 1F3FB 200D 2642 FE0F', emoji: '🙆🏻‍♂️' },
            { code: '1F646 1F3FC 200D 2642 FE0F', emoji: '🙆🏼‍♂️' },
            { code: '1F646 1F3FD 200D 2642 FE0F', emoji: '🙆🏽‍♂️' },
            { code: '1F646 1F3FE 200D 2642 FE0F', emoji: '🙆🏾‍♂️' },
            { code: '1F646 1F3FF 200D 2642 FE0F', emoji: '🙆🏿‍♂️' },
            { code: '1F646 200D 2640 FE0F', emoji: '🙆‍♀️' },
            { code: '1F646 1F3FB 200D 2640 FE0F', emoji: '🙆🏻‍♀️' },
            { code: '1F646 1F3FC 200D 2640 FE0F', emoji: '🙆🏼‍♀️' },
            { code: '1F646 1F3FD 200D 2640 FE0F', emoji: '🙆🏽‍♀️' },
            { code: '1F646 1F3FE 200D 2640 FE0F', emoji: '🙆🏾‍♀️' },
            { code: '1F646 1F3FF 200D 2640 FE0F', emoji: '🙆🏿‍♀️' },
            { code: '1F481', emoji: '💁' },
            { code: '1F481 1F3FB', emoji: '💁🏻' },
            { code: '1F481 1F3FC', emoji: '💁🏼' },
            { code: '1F481 1F3FD', emoji: '💁🏽' },
            { code: '1F481 1F3FE', emoji: '💁🏾' },
            { code: '1F481 1F3FF', emoji: '💁🏿' },
            { code: '1F481 200D 2642 FE0F', emoji: '💁‍♂️' },
            { code: '1F481 1F3FB 200D 2642 FE0F', emoji: '💁🏻‍♂️' },
            { code: '1F481 1F3FC 200D 2642 FE0F', emoji: '💁🏼‍♂️' },
            { code: '1F481 1F3FD 200D 2642 FE0F', emoji: '💁🏽‍♂️' },
            { code: '1F481 1F3FE 200D 2642 FE0F', emoji: '💁🏾‍♂️' },
            { code: '1F481 1F3FF 200D 2642 FE0F', emoji: '💁🏿‍♂️' },
            { code: '1F481 200D 2640 FE0F', emoji: '💁‍♀️' },
            { code: '1F481 1F3FB 200D 2640 FE0F', emoji: '💁🏻‍♀️' },
            { code: '1F481 1F3FC 200D 2640 FE0F', emoji: '💁🏼‍♀️' },
            { code: '1F481 1F3FD 200D 2640 FE0F', emoji: '💁🏽‍♀️' },
            { code: '1F481 1F3FE 200D 2640 FE0F', emoji: '💁🏾‍♀️' },
            { code: '1F481 1F3FF 200D 2640 FE0F', emoji: '💁🏿‍♀️' },
            { code: '1F64B', emoji: '🙋' },
            { code: '1F64B 1F3FB', emoji: '🙋🏻' },
            { code: '1F64B 1F3FC', emoji: '🙋🏼' },
            { code: '1F64B 1F3FD', emoji: '🙋🏽' },
            { code: '1F64B 1F3FE', emoji: '🙋🏾' },
            { code: '1F64B 1F3FF', emoji: '🙋🏿' },
            { code: '1F64B 200D 2642 FE0F', emoji: '🙋‍♂️' },
            { code: '1F64B 1F3FB 200D 2642 FE0F', emoji: '🙋🏻‍♂️' },
            { code: '1F64B 1F3FC 200D 2642 FE0F', emoji: '🙋🏼‍♂️' },
            { code: '1F64B 1F3FD 200D 2642 FE0F', emoji: '🙋🏽‍♂️' },
            { code: '1F64B 1F3FE 200D 2642 FE0F', emoji: '🙋🏾‍♂️' },
            { code: '1F64B 1F3FF 200D 2642 FE0F', emoji: '🙋🏿‍♂️' },
            { code: '1F64B 200D 2640 FE0F', emoji: '🙋‍♀️' },
            { code: '1F64B 1F3FB 200D 2640 FE0F', emoji: '🙋🏻‍♀️' },
            { code: '1F64B 1F3FC 200D 2640 FE0F', emoji: '🙋🏼‍♀️' },
            { code: '1F64B 1F3FD 200D 2640 FE0F', emoji: '🙋🏽‍♀️' },
            { code: '1F64B 1F3FE 200D 2640 FE0F', emoji: '🙋🏾‍♀️' },
            { code: '1F64B 1F3FF 200D 2640 FE0F', emoji: '🙋🏿‍♀️' },
            { code: '1F9CF', emoji: '🧏' },
            { code: '1F9CF 1F3FB', emoji: '🧏🏻' },
            { code: '1F9CF 1F3FC', emoji: '🧏🏼' },
            { code: '1F9CF 1F3FD', emoji: '🧏🏽' },
            { code: '1F9CF 1F3FE', emoji: '🧏🏾' },
            { code: '1F9CF 1F3FF', emoji: '🧏🏿' },
            { code: '1F9CF 200D 2642 FE0F', emoji: '🧏‍♂️' },
            { code: '1F9CF 1F3FB 200D 2642 FE0F', emoji: '🧏🏻‍♂️' },
            { code: '1F9CF 1F3FC 200D 2642 FE0F', emoji: '🧏🏼‍♂️' },
            { code: '1F9CF 1F3FD 200D 2642 FE0F', emoji: '🧏🏽‍♂️' },
            { code: '1F9CF 1F3FE 200D 2642 FE0F', emoji: '🧏🏾‍♂️' },
            { code: '1F9CF 1F3FF 200D 2642 FE0F', emoji: '🧏🏿‍♂️' },
            { code: '1F9CF 200D 2640 FE0F', emoji: '🧏‍♀️' },
            { code: '1F9CF 1F3FB 200D 2640 FE0F', emoji: '🧏🏻‍♀️' },
            { code: '1F9CF 1F3FC 200D 2640 FE0F', emoji: '🧏🏼‍♀️' },
            { code: '1F9CF 1F3FD 200D 2640 FE0F', emoji: '🧏🏽‍♀️' },
            { code: '1F9CF 1F3FE 200D 2640 FE0F', emoji: '🧏🏾‍♀️' },
            { code: '1F9CF 1F3FF 200D 2640 FE0F', emoji: '🧏🏿‍♀️' },
            { code: '1F647', emoji: '🙇' },
            { code: '1F647 1F3FB', emoji: '🙇🏻' },
            { code: '1F647 1F3FC', emoji: '🙇🏼' },
            { code: '1F647 1F3FD', emoji: '🙇🏽' },
            { code: '1F647 1F3FE', emoji: '🙇🏾' },
            { code: '1F647 1F3FF', emoji: '🙇🏿' },
            { code: '1F647 200D 2642 FE0F', emoji: '🙇‍♂️' },
            { code: '1F647 1F3FB 200D 2642 FE0F', emoji: '🙇🏻‍♂️' },
            { code: '1F647 1F3FC 200D 2642 FE0F', emoji: '🙇🏼‍♂️' },
            { code: '1F647 1F3FD 200D 2642 FE0F', emoji: '🙇🏽‍♂️' },
            { code: '1F647 1F3FE 200D 2642 FE0F', emoji: '🙇🏾‍♂️' },
            { code: '1F647 1F3FF 200D 2642 FE0F', emoji: '🙇🏿‍♂️' },
            { code: '1F647 200D 2640 FE0F', emoji: '🙇‍♀️' },
            { code: '1F647 1F3FB 200D 2640 FE0F', emoji: '🙇🏻‍♀️' },
            { code: '1F647 1F3FC 200D 2640 FE0F', emoji: '🙇🏼‍♀️' },
            { code: '1F647 1F3FD 200D 2640 FE0F', emoji: '🙇🏽‍♀️' },
            { code: '1F647 1F3FE 200D 2640 FE0F', emoji: '🙇🏾‍♀️' },
            { code: '1F647 1F3FF 200D 2640 FE0F', emoji: '🙇🏿‍♀️' },
            { code: '1F926', emoji: '🤦' },
            { code: '1F926 1F3FB', emoji: '🤦🏻' },
            { code: '1F926 1F3FC', emoji: '🤦🏼' },
            { code: '1F926 1F3FD', emoji: '🤦🏽' },
            { code: '1F926 1F3FE', emoji: '🤦🏾' },
            { code: '1F926 1F3FF', emoji: '🤦🏿' },
            { code: '1F926 200D 2642 FE0F', emoji: '🤦‍♂️' },
            { code: '1F926 1F3FB 200D 2642 FE0F', emoji: '🤦🏻‍♂️' },
            { code: '1F926 1F3FC 200D 2642 FE0F', emoji: '🤦🏼‍♂️' },
            { code: '1F926 1F3FD 200D 2642 FE0F', emoji: '🤦🏽‍♂️' },
            { code: '1F926 1F3FE 200D 2642 FE0F', emoji: '🤦🏾‍♂️' },
            { code: '1F926 1F3FF 200D 2642 FE0F', emoji: '🤦🏿‍♂️' },
            { code: '1F926 200D 2640 FE0F', emoji: '🤦‍♀️' },
            { code: '1F926 1F3FB 200D 2640 FE0F', emoji: '🤦🏻‍♀️' },
            { code: '1F926 1F3FC 200D 2640 FE0F', emoji: '🤦🏼‍♀️' },
            { code: '1F926 1F3FD 200D 2640 FE0F', emoji: '🤦🏽‍♀️' },
            { code: '1F926 1F3FE 200D 2640 FE0F', emoji: '🤦🏾‍♀️' },
            { code: '1F926 1F3FF 200D 2640 FE0F', emoji: '🤦🏿‍♀️' },
            { code: '1F937', emoji: '🤷' },
            { code: '1F937 1F3FB', emoji: '🤷🏻' },
            { code: '1F937 1F3FC', emoji: '🤷🏼' },
            { code: '1F937 1F3FD', emoji: '🤷🏽' },
            { code: '1F937 1F3FE', emoji: '🤷🏾' },
            { code: '1F937 1F3FF', emoji: '🤷🏿' },
            { code: '1F937 200D 2642 FE0F', emoji: '🤷‍♂️' },
            { code: '1F937 1F3FB 200D 2642 FE0F', emoji: '🤷🏻‍♂️' },
            { code: '1F937 1F3FC 200D 2642 FE0F', emoji: '🤷🏼‍♂️' },
            { code: '1F937 1F3FD 200D 2642 FE0F', emoji: '🤷🏽‍♂️' },
            { code: '1F937 1F3FE 200D 2642 FE0F', emoji: '🤷🏾‍♂️' },
            { code: '1F937 1F3FF 200D 2642 FE0F', emoji: '🤷🏿‍♂️' },
            { code: '1F937 200D 2640 FE0F', emoji: '🤷‍♀️' },
            { code: '1F937 1F3FB 200D 2640 FE0F', emoji: '🤷🏻‍♀️' },
            { code: '1F937 1F3FC 200D 2640 FE0F', emoji: '🤷🏼‍♀️' },
            { code: '1F937 1F3FD 200D 2640 FE0F', emoji: '🤷🏽‍♀️' },
            { code: '1F937 1F3FE 200D 2640 FE0F', emoji: '🤷🏾‍♀️' },
            { code: '1F937 1F3FF 200D 2640 FE0F', emoji: '🤷🏿‍♀️' },
        ],
        'person-role': [
            { code: '1F9D1 200D 2695 FE0F', emoji: '🧑‍⚕️' },
            { code: '1F9D1 1F3FB 200D 2695 FE0F', emoji: '🧑🏻‍⚕️' },
            { code: '1F9D1 1F3FC 200D 2695 FE0F', emoji: '🧑🏼‍⚕️' },
            { code: '1F9D1 1F3FD 200D 2695 FE0F', emoji: '🧑🏽‍⚕️' },
            { code: '1F9D1 1F3FE 200D 2695 FE0F', emoji: '🧑🏾‍⚕️' },
            { code: '1F9D1 1F3FF 200D 2695 FE0F', emoji: '🧑🏿‍⚕️' },
            { code: '1F468 200D 2695 FE0F', emoji: '👨‍⚕️' },
            { code: '1F468 1F3FB 200D 2695 FE0F', emoji: '👨🏻‍⚕️' },
            { code: '1F468 1F3FC 200D 2695 FE0F', emoji: '👨🏼‍⚕️' },
            { code: '1F468 1F3FD 200D 2695 FE0F', emoji: '👨🏽‍⚕️' },
            { code: '1F468 1F3FE 200D 2695 FE0F', emoji: '👨🏾‍⚕️' },
            { code: '1F468 1F3FF 200D 2695 FE0F', emoji: '👨🏿‍⚕️' },
            { code: '1F469 200D 2695 FE0F', emoji: '👩‍⚕️' },
            { code: '1F469 1F3FB 200D 2695 FE0F', emoji: '👩🏻‍⚕️' },
            { code: '1F469 1F3FC 200D 2695 FE0F', emoji: '👩🏼‍⚕️' },
            { code: '1F469 1F3FD 200D 2695 FE0F', emoji: '👩🏽‍⚕️' },
            { code: '1F469 1F3FE 200D 2695 FE0F', emoji: '👩🏾‍⚕️' },
            { code: '1F469 1F3FF 200D 2695 FE0F', emoji: '👩🏿‍⚕️' },
            { code: '1F9D1 200D 1F393', emoji: '🧑‍🎓' },
            { code: '1F9D1 1F3FB 200D 1F393', emoji: '🧑🏻‍🎓' },
            { code: '1F9D1 1F3FC 200D 1F393', emoji: '🧑🏼‍🎓' },
            { code: '1F9D1 1F3FD 200D 1F393', emoji: '🧑🏽‍🎓' },
            { code: '1F9D1 1F3FE 200D 1F393', emoji: '🧑🏾‍🎓' },
            { code: '1F9D1 1F3FF 200D 1F393', emoji: '🧑🏿‍🎓' },
            { code: '1F468 200D 1F393', emoji: '👨‍🎓' },
            { code: '1F468 1F3FB 200D 1F393', emoji: '👨🏻‍🎓' },
            { code: '1F468 1F3FC 200D 1F393', emoji: '👨🏼‍🎓' },
            { code: '1F468 1F3FD 200D 1F393', emoji: '👨🏽‍🎓' },
            { code: '1F468 1F3FE 200D 1F393', emoji: '👨🏾‍🎓' },
            { code: '1F468 1F3FF 200D 1F393', emoji: '👨🏿‍🎓' },
            { code: '1F469 200D 1F393', emoji: '👩‍🎓' },
            { code: '1F469 1F3FB 200D 1F393', emoji: '👩🏻‍🎓' },
            { code: '1F469 1F3FC 200D 1F393', emoji: '👩🏼‍🎓' },
            { code: '1F469 1F3FD 200D 1F393', emoji: '👩🏽‍🎓' },
            { code: '1F469 1F3FE 200D 1F393', emoji: '👩🏾‍🎓' },
            { code: '1F469 1F3FF 200D 1F393', emoji: '👩🏿‍🎓' },
            { code: '1F9D1 200D 1F3EB', emoji: '🧑‍🏫' },
            { code: '1F9D1 1F3FB 200D 1F3EB', emoji: '🧑🏻‍🏫' },
            { code: '1F9D1 1F3FC 200D 1F3EB', emoji: '🧑🏼‍🏫' },
            { code: '1F9D1 1F3FD 200D 1F3EB', emoji: '🧑🏽‍🏫' },
            { code: '1F9D1 1F3FE 200D 1F3EB', emoji: '🧑🏾‍🏫' },
            { code: '1F9D1 1F3FF 200D 1F3EB', emoji: '🧑🏿‍🏫' },
            { code: '1F468 200D 1F3EB', emoji: '👨‍🏫' },
            { code: '1F468 1F3FB 200D 1F3EB', emoji: '👨🏻‍🏫' },
            { code: '1F468 1F3FC 200D 1F3EB', emoji: '👨🏼‍🏫' },
            { code: '1F468 1F3FD 200D 1F3EB', emoji: '👨🏽‍🏫' },
            { code: '1F468 1F3FE 200D 1F3EB', emoji: '👨🏾‍🏫' },
            { code: '1F468 1F3FF 200D 1F3EB', emoji: '👨🏿‍🏫' },
            { code: '1F469 200D 1F3EB', emoji: '👩‍🏫' },
            { code: '1F469 1F3FB 200D 1F3EB', emoji: '👩🏻‍🏫' },
            { code: '1F469 1F3FC 200D 1F3EB', emoji: '👩🏼‍🏫' },
            { code: '1F469 1F3FD 200D 1F3EB', emoji: '👩🏽‍🏫' },
            { code: '1F469 1F3FE 200D 1F3EB', emoji: '👩🏾‍🏫' },
            { code: '1F469 1F3FF 200D 1F3EB', emoji: '👩🏿‍🏫' },
            { code: '1F9D1 200D 2696 FE0F', emoji: '🧑‍⚖️' },
            { code: '1F9D1 1F3FB 200D 2696 FE0F', emoji: '🧑🏻‍⚖️' },
            { code: '1F9D1 1F3FC 200D 2696 FE0F', emoji: '🧑🏼‍⚖️' },
            { code: '1F9D1 1F3FD 200D 2696 FE0F', emoji: '🧑🏽‍⚖️' },
            { code: '1F9D1 1F3FE 200D 2696 FE0F', emoji: '🧑🏾‍⚖️' },
            { code: '1F9D1 1F3FF 200D 2696 FE0F', emoji: '🧑🏿‍⚖️' },
            { code: '1F468 200D 2696 FE0F', emoji: '👨‍⚖️' },
            { code: '1F468 1F3FB 200D 2696 FE0F', emoji: '👨🏻‍⚖️' },
            { code: '1F468 1F3FC 200D 2696 FE0F', emoji: '👨🏼‍⚖️' },
            { code: '1F468 1F3FD 200D 2696 FE0F', emoji: '👨🏽‍⚖️' },
            { code: '1F468 1F3FE 200D 2696 FE0F', emoji: '👨🏾‍⚖️' },
            { code: '1F468 1F3FF 200D 2696 FE0F', emoji: '👨🏿‍⚖️' },
            { code: '1F469 200D 2696 FE0F', emoji: '👩‍⚖️' },
            { code: '1F469 1F3FB 200D 2696 FE0F', emoji: '👩🏻‍⚖️' },
            { code: '1F469 1F3FC 200D 2696 FE0F', emoji: '👩🏼‍⚖️' },
            { code: '1F469 1F3FD 200D 2696 FE0F', emoji: '👩🏽‍⚖️' },
            { code: '1F469 1F3FE 200D 2696 FE0F', emoji: '👩🏾‍⚖️' },
            { code: '1F469 1F3FF 200D 2696 FE0F', emoji: '👩🏿‍⚖️' },
            { code: '1F9D1 200D 1F33E', emoji: '🧑‍🌾' },
            { code: '1F9D1 1F3FB 200D 1F33E', emoji: '🧑🏻‍🌾' },
            { code: '1F9D1 1F3FC 200D 1F33E', emoji: '🧑🏼‍🌾' },
            { code: '1F9D1 1F3FD 200D 1F33E', emoji: '🧑🏽‍🌾' },
            { code: '1F9D1 1F3FE 200D 1F33E', emoji: '🧑🏾‍🌾' },
            { code: '1F9D1 1F3FF 200D 1F33E', emoji: '🧑🏿‍🌾' },
            { code: '1F468 200D 1F33E', emoji: '👨‍🌾' },
            { code: '1F468 1F3FB 200D 1F33E', emoji: '👨🏻‍🌾' },
            { code: '1F468 1F3FC 200D 1F33E', emoji: '👨🏼‍🌾' },
            { code: '1F468 1F3FD 200D 1F33E', emoji: '👨🏽‍🌾' },
            { code: '1F468 1F3FE 200D 1F33E', emoji: '👨🏾‍🌾' },
            { code: '1F468 1F3FF 200D 1F33E', emoji: '👨🏿‍🌾' },
            { code: '1F469 200D 1F33E', emoji: '👩‍🌾' },
            { code: '1F469 1F3FB 200D 1F33E', emoji: '👩🏻‍🌾' },
            { code: '1F469 1F3FC 200D 1F33E', emoji: '👩🏼‍🌾' },
            { code: '1F469 1F3FD 200D 1F33E', emoji: '👩🏽‍🌾' },
            { code: '1F469 1F3FE 200D 1F33E', emoji: '👩🏾‍🌾' },
            { code: '1F469 1F3FF 200D 1F33E', emoji: '👩🏿‍🌾' },
            { code: '1F9D1 200D 1F373', emoji: '🧑‍🍳' },
            { code: '1F9D1 1F3FB 200D 1F373', emoji: '🧑🏻‍🍳' },
            { code: '1F9D1 1F3FC 200D 1F373', emoji: '🧑🏼‍🍳' },
            { code: '1F9D1 1F3FD 200D 1F373', emoji: '🧑🏽‍🍳' },
            { code: '1F9D1 1F3FE 200D 1F373', emoji: '🧑🏾‍🍳' },
            { code: '1F9D1 1F3FF 200D 1F373', emoji: '🧑🏿‍🍳' },
            { code: '1F468 200D 1F373', emoji: '👨‍🍳' },
            { code: '1F468 1F3FB 200D 1F373', emoji: '👨🏻‍🍳' },
            { code: '1F468 1F3FC 200D 1F373', emoji: '👨🏼‍🍳' },
            { code: '1F468 1F3FD 200D 1F373', emoji: '👨🏽‍🍳' },
            { code: '1F468 1F3FE 200D 1F373', emoji: '👨🏾‍🍳' },
            { code: '1F468 1F3FF 200D 1F373', emoji: '👨🏿‍🍳' },
            { code: '1F469 200D 1F373', emoji: '👩‍🍳' },
            { code: '1F469 1F3FB 200D 1F373', emoji: '👩🏻‍🍳' },
            { code: '1F469 1F3FC 200D 1F373', emoji: '👩🏼‍🍳' },
            { code: '1F469 1F3FD 200D 1F373', emoji: '👩🏽‍🍳' },
            { code: '1F469 1F3FE 200D 1F373', emoji: '👩🏾‍🍳' },
            { code: '1F469 1F3FF 200D 1F373', emoji: '👩🏿‍🍳' },
            { code: '1F9D1 200D 1F527', emoji: '🧑‍🔧' },
            { code: '1F9D1 1F3FB 200D 1F527', emoji: '🧑🏻‍🔧' },
            { code: '1F9D1 1F3FC 200D 1F527', emoji: '🧑🏼‍🔧' },
            { code: '1F9D1 1F3FD 200D 1F527', emoji: '🧑🏽‍🔧' },
            { code: '1F9D1 1F3FE 200D 1F527', emoji: '🧑🏾‍🔧' },
            { code: '1F9D1 1F3FF 200D 1F527', emoji: '🧑🏿‍🔧' },
            { code: '1F468 200D 1F527', emoji: '👨‍🔧' },
            { code: '1F468 1F3FB 200D 1F527', emoji: '👨🏻‍🔧' },
            { code: '1F468 1F3FC 200D 1F527', emoji: '👨🏼‍🔧' },
            { code: '1F468 1F3FD 200D 1F527', emoji: '👨🏽‍🔧' },
            { code: '1F468 1F3FE 200D 1F527', emoji: '👨🏾‍🔧' },
            { code: '1F468 1F3FF 200D 1F527', emoji: '👨🏿‍🔧' },
            { code: '1F469 200D 1F527', emoji: '👩‍🔧' },
            { code: '1F469 1F3FB 200D 1F527', emoji: '👩🏻‍🔧' },
            { code: '1F469 1F3FC 200D 1F527', emoji: '👩🏼‍🔧' },
            { code: '1F469 1F3FD 200D 1F527', emoji: '👩🏽‍🔧' },
            { code: '1F469 1F3FE 200D 1F527', emoji: '👩🏾‍🔧' },
            { code: '1F469 1F3FF 200D 1F527', emoji: '👩🏿‍🔧' },
            { code: '1F9D1 200D 1F3ED', emoji: '🧑‍🏭' },
            { code: '1F9D1 1F3FB 200D 1F3ED', emoji: '🧑🏻‍🏭' },
            { code: '1F9D1 1F3FC 200D 1F3ED', emoji: '🧑🏼‍🏭' },
            { code: '1F9D1 1F3FD 200D 1F3ED', emoji: '🧑🏽‍🏭' },
            { code: '1F9D1 1F3FE 200D 1F3ED', emoji: '🧑🏾‍🏭' },
            { code: '1F9D1 1F3FF 200D 1F3ED', emoji: '🧑🏿‍🏭' },
            { code: '1F468 200D 1F3ED', emoji: '👨‍🏭' },
            { code: '1F468 1F3FB 200D 1F3ED', emoji: '👨🏻‍🏭' },
            { code: '1F468 1F3FC 200D 1F3ED', emoji: '👨🏼‍🏭' },
            { code: '1F468 1F3FD 200D 1F3ED', emoji: '👨🏽‍🏭' },
            { code: '1F468 1F3FE 200D 1F3ED', emoji: '👨🏾‍🏭' },
            { code: '1F468 1F3FF 200D 1F3ED', emoji: '👨🏿‍🏭' },
            { code: '1F469 200D 1F3ED', emoji: '👩‍🏭' },
            { code: '1F469 1F3FB 200D 1F3ED', emoji: '👩🏻‍🏭' },
            { code: '1F469 1F3FC 200D 1F3ED', emoji: '👩🏼‍🏭' },
            { code: '1F469 1F3FD 200D 1F3ED', emoji: '👩🏽‍🏭' },
            { code: '1F469 1F3FE 200D 1F3ED', emoji: '👩🏾‍🏭' },
            { code: '1F469 1F3FF 200D 1F3ED', emoji: '👩🏿‍🏭' },
            { code: '1F9D1 200D 1F4BC', emoji: '🧑‍💼' },
            { code: '1F9D1 1F3FB 200D 1F4BC', emoji: '🧑🏻‍💼' },
            { code: '1F9D1 1F3FC 200D 1F4BC', emoji: '🧑🏼‍💼' },
            { code: '1F9D1 1F3FD 200D 1F4BC', emoji: '🧑🏽‍💼' },
            { code: '1F9D1 1F3FE 200D 1F4BC', emoji: '🧑🏾‍💼' },
            { code: '1F9D1 1F3FF 200D 1F4BC', emoji: '🧑🏿‍💼' },
            { code: '1F468 200D 1F4BC', emoji: '👨‍💼' },
            { code: '1F468 1F3FB 200D 1F4BC', emoji: '👨🏻‍💼' },
            { code: '1F468 1F3FC 200D 1F4BC', emoji: '👨🏼‍💼' },
            { code: '1F468 1F3FD 200D 1F4BC', emoji: '👨🏽‍💼' },
            { code: '1F468 1F3FE 200D 1F4BC', emoji: '👨🏾‍💼' },
            { code: '1F468 1F3FF 200D 1F4BC', emoji: '👨🏿‍💼' },
            { code: '1F469 200D 1F4BC', emoji: '👩‍💼' },
            { code: '1F469 1F3FB 200D 1F4BC', emoji: '👩🏻‍💼' },
            { code: '1F469 1F3FC 200D 1F4BC', emoji: '👩🏼‍💼' },
            { code: '1F469 1F3FD 200D 1F4BC', emoji: '👩🏽‍💼' },
            { code: '1F469 1F3FE 200D 1F4BC', emoji: '👩🏾‍💼' },
            { code: '1F469 1F3FF 200D 1F4BC', emoji: '👩🏿‍💼' },
            { code: '1F9D1 200D 1F52C', emoji: '🧑‍🔬' },
            { code: '1F9D1 1F3FB 200D 1F52C', emoji: '🧑🏻‍🔬' },
            { code: '1F9D1 1F3FC 200D 1F52C', emoji: '🧑🏼‍🔬' },
            { code: '1F9D1 1F3FD 200D 1F52C', emoji: '🧑🏽‍🔬' },
            { code: '1F9D1 1F3FE 200D 1F52C', emoji: '🧑🏾‍🔬' },
            { code: '1F9D1 1F3FF 200D 1F52C', emoji: '🧑🏿‍🔬' },
            { code: '1F468 200D 1F52C', emoji: '👨‍🔬' },
            { code: '1F468 1F3FB 200D 1F52C', emoji: '👨🏻‍🔬' },
            { code: '1F468 1F3FC 200D 1F52C', emoji: '👨🏼‍🔬' },
            { code: '1F468 1F3FD 200D 1F52C', emoji: '👨🏽‍🔬' },
            { code: '1F468 1F3FE 200D 1F52C', emoji: '👨🏾‍🔬' },
            { code: '1F468 1F3FF 200D 1F52C', emoji: '👨🏿‍🔬' },
            { code: '1F469 200D 1F52C', emoji: '👩‍🔬' },
            { code: '1F469 1F3FB 200D 1F52C', emoji: '👩🏻‍🔬' },
            { code: '1F469 1F3FC 200D 1F52C', emoji: '👩🏼‍🔬' },
            { code: '1F469 1F3FD 200D 1F52C', emoji: '👩🏽‍🔬' },
            { code: '1F469 1F3FE 200D 1F52C', emoji: '👩🏾‍🔬' },
            { code: '1F469 1F3FF 200D 1F52C', emoji: '👩🏿‍🔬' },
            { code: '1F9D1 200D 1F4BB', emoji: '🧑‍💻' },
            { code: '1F9D1 1F3FB 200D 1F4BB', emoji: '🧑🏻‍💻' },
            { code: '1F9D1 1F3FC 200D 1F4BB', emoji: '🧑🏼‍💻' },
            { code: '1F9D1 1F3FD 200D 1F4BB', emoji: '🧑🏽‍💻' },
            { code: '1F9D1 1F3FE 200D 1F4BB', emoji: '🧑🏾‍💻' },
            { code: '1F9D1 1F3FF 200D 1F4BB', emoji: '🧑🏿‍💻' },
            { code: '1F468 200D 1F4BB', emoji: '👨‍💻' },
            { code: '1F468 1F3FB 200D 1F4BB', emoji: '👨🏻‍💻' },
            { code: '1F468 1F3FC 200D 1F4BB', emoji: '👨🏼‍💻' },
            { code: '1F468 1F3FD 200D 1F4BB', emoji: '👨🏽‍💻' },
            { code: '1F468 1F3FE 200D 1F4BB', emoji: '👨🏾‍💻' },
            { code: '1F468 1F3FF 200D 1F4BB', emoji: '👨🏿‍💻' },
            { code: '1F469 200D 1F4BB', emoji: '👩‍💻' },
            { code: '1F469 1F3FB 200D 1F4BB', emoji: '👩🏻‍💻' },
            { code: '1F469 1F3FC 200D 1F4BB', emoji: '👩🏼‍💻' },
            { code: '1F469 1F3FD 200D 1F4BB', emoji: '👩🏽‍💻' },
            { code: '1F469 1F3FE 200D 1F4BB', emoji: '👩🏾‍💻' },
            { code: '1F469 1F3FF 200D 1F4BB', emoji: '👩🏿‍💻' },
            { code: '1F9D1 200D 1F3A4', emoji: '🧑‍🎤' },
            { code: '1F9D1 1F3FB 200D 1F3A4', emoji: '🧑🏻‍🎤' },
            { code: '1F9D1 1F3FC 200D 1F3A4', emoji: '🧑🏼‍🎤' },
            { code: '1F9D1 1F3FD 200D 1F3A4', emoji: '🧑🏽‍🎤' },
            { code: '1F9D1 1F3FE 200D 1F3A4', emoji: '🧑🏾‍🎤' },
            { code: '1F9D1 1F3FF 200D 1F3A4', emoji: '🧑🏿‍🎤' },
            { code: '1F468 200D 1F3A4', emoji: '👨‍🎤' },
            { code: '1F468 1F3FB 200D 1F3A4', emoji: '👨🏻‍🎤' },
            { code: '1F468 1F3FC 200D 1F3A4', emoji: '👨🏼‍🎤' },
            { code: '1F468 1F3FD 200D 1F3A4', emoji: '👨🏽‍🎤' },
            { code: '1F468 1F3FE 200D 1F3A4', emoji: '👨🏾‍🎤' },
            { code: '1F468 1F3FF 200D 1F3A4', emoji: '👨🏿‍🎤' },
            { code: '1F469 200D 1F3A4', emoji: '👩‍🎤' },
            { code: '1F469 1F3FB 200D 1F3A4', emoji: '👩🏻‍🎤' },
            { code: '1F469 1F3FC 200D 1F3A4', emoji: '👩🏼‍🎤' },
            { code: '1F469 1F3FD 200D 1F3A4', emoji: '👩🏽‍🎤' },
            { code: '1F469 1F3FE 200D 1F3A4', emoji: '👩🏾‍🎤' },
            { code: '1F469 1F3FF 200D 1F3A4', emoji: '👩🏿‍🎤' },
            { code: '1F9D1 200D 1F3A8', emoji: '🧑‍🎨' },
            { code: '1F9D1 1F3FB 200D 1F3A8', emoji: '🧑🏻‍🎨' },
            { code: '1F9D1 1F3FC 200D 1F3A8', emoji: '🧑🏼‍🎨' },
            { code: '1F9D1 1F3FD 200D 1F3A8', emoji: '🧑🏽‍🎨' },
            { code: '1F9D1 1F3FE 200D 1F3A8', emoji: '🧑🏾‍🎨' },
            { code: '1F9D1 1F3FF 200D 1F3A8', emoji: '🧑🏿‍🎨' },
            { code: '1F468 200D 1F3A8', emoji: '👨‍🎨' },
            { code: '1F468 1F3FB 200D 1F3A8', emoji: '👨🏻‍🎨' },
            { code: '1F468 1F3FC 200D 1F3A8', emoji: '👨🏼‍🎨' },
            { code: '1F468 1F3FD 200D 1F3A8', emoji: '👨🏽‍🎨' },
            { code: '1F468 1F3FE 200D 1F3A8', emoji: '👨🏾‍🎨' },
            { code: '1F468 1F3FF 200D 1F3A8', emoji: '👨🏿‍🎨' },
            { code: '1F469 200D 1F3A8', emoji: '👩‍🎨' },
            { code: '1F469 1F3FB 200D 1F3A8', emoji: '👩🏻‍🎨' },
            { code: '1F469 1F3FC 200D 1F3A8', emoji: '👩🏼‍🎨' },
            { code: '1F469 1F3FD 200D 1F3A8', emoji: '👩🏽‍🎨' },
            { code: '1F469 1F3FE 200D 1F3A8', emoji: '👩🏾‍🎨' },
            { code: '1F469 1F3FF 200D 1F3A8', emoji: '👩🏿‍🎨' },
            { code: '1F9D1 200D 2708 FE0F', emoji: '🧑‍✈️' },
            { code: '1F9D1 1F3FB 200D 2708 FE0F', emoji: '🧑🏻‍✈️' },
            { code: '1F9D1 1F3FC 200D 2708 FE0F', emoji: '🧑🏼‍✈️' },
            { code: '1F9D1 1F3FD 200D 2708 FE0F', emoji: '🧑🏽‍✈️' },
            { code: '1F9D1 1F3FE 200D 2708 FE0F', emoji: '🧑🏾‍✈️' },
            { code: '1F9D1 1F3FF 200D 2708 FE0F', emoji: '🧑🏿‍✈️' },
            { code: '1F468 200D 2708 FE0F', emoji: '👨‍✈️' },
            { code: '1F468 1F3FB 200D 2708 FE0F', emoji: '👨🏻‍✈️' },
            { code: '1F468 1F3FC 200D 2708 FE0F', emoji: '👨🏼‍✈️' },
            { code: '1F468 1F3FD 200D 2708 FE0F', emoji: '👨🏽‍✈️' },
            { code: '1F468 1F3FE 200D 2708 FE0F', emoji: '👨🏾‍✈️' },
            { code: '1F468 1F3FF 200D 2708 FE0F', emoji: '👨🏿‍✈️' },
            { code: '1F469 200D 2708 FE0F', emoji: '👩‍✈️' },
            { code: '1F469 1F3FB 200D 2708 FE0F', emoji: '👩🏻‍✈️' },
            { code: '1F469 1F3FC 200D 2708 FE0F', emoji: '👩🏼‍✈️' },
            { code: '1F469 1F3FD 200D 2708 FE0F', emoji: '👩🏽‍✈️' },
            { code: '1F469 1F3FE 200D 2708 FE0F', emoji: '👩🏾‍✈️' },
            { code: '1F469 1F3FF 200D 2708 FE0F', emoji: '👩🏿‍✈️' },
            { code: '1F9D1 200D 1F680', emoji: '🧑‍🚀' },
            { code: '1F9D1 1F3FB 200D 1F680', emoji: '🧑🏻‍🚀' },
            { code: '1F9D1 1F3FC 200D 1F680', emoji: '🧑🏼‍🚀' },
            { code: '1F9D1 1F3FD 200D 1F680', emoji: '🧑🏽‍🚀' },
            { code: '1F9D1 1F3FE 200D 1F680', emoji: '🧑🏾‍🚀' },
            { code: '1F9D1 1F3FF 200D 1F680', emoji: '🧑🏿‍🚀' },
            { code: '1F468 200D 1F680', emoji: '👨‍🚀' },
            { code: '1F468 1F3FB 200D 1F680', emoji: '👨🏻‍🚀' },
            { code: '1F468 1F3FC 200D 1F680', emoji: '👨🏼‍🚀' },
            { code: '1F468 1F3FD 200D 1F680', emoji: '👨🏽‍🚀' },
            { code: '1F468 1F3FE 200D 1F680', emoji: '👨🏾‍🚀' },
            { code: '1F468 1F3FF 200D 1F680', emoji: '👨🏿‍🚀' },
            { code: '1F469 200D 1F680', emoji: '👩‍🚀' },
            { code: '1F469 1F3FB 200D 1F680', emoji: '👩🏻‍🚀' },
            { code: '1F469 1F3FC 200D 1F680', emoji: '👩🏼‍🚀' },
            { code: '1F469 1F3FD 200D 1F680', emoji: '👩🏽‍🚀' },
            { code: '1F469 1F3FE 200D 1F680', emoji: '👩🏾‍🚀' },
            { code: '1F469 1F3FF 200D 1F680', emoji: '👩🏿‍🚀' },
            { code: '1F9D1 200D 1F692', emoji: '🧑‍🚒' },
            { code: '1F9D1 1F3FB 200D 1F692', emoji: '🧑🏻‍🚒' },
            { code: '1F9D1 1F3FC 200D 1F692', emoji: '🧑🏼‍🚒' },
            { code: '1F9D1 1F3FD 200D 1F692', emoji: '🧑🏽‍🚒' },
            { code: '1F9D1 1F3FE 200D 1F692', emoji: '🧑🏾‍🚒' },
            { code: '1F9D1 1F3FF 200D 1F692', emoji: '🧑🏿‍🚒' },
            { code: '1F468 200D 1F692', emoji: '👨‍🚒' },
            { code: '1F468 1F3FB 200D 1F692', emoji: '👨🏻‍🚒' },
            { code: '1F468 1F3FC 200D 1F692', emoji: '👨🏼‍🚒' },
            { code: '1F468 1F3FD 200D 1F692', emoji: '👨🏽‍🚒' },
            { code: '1F468 1F3FE 200D 1F692', emoji: '👨🏾‍🚒' },
            { code: '1F468 1F3FF 200D 1F692', emoji: '👨🏿‍🚒' },
            { code: '1F469 200D 1F692', emoji: '👩‍🚒' },
            { code: '1F469 1F3FB 200D 1F692', emoji: '👩🏻‍🚒' },
            { code: '1F469 1F3FC 200D 1F692', emoji: '👩🏼‍🚒' },
            { code: '1F469 1F3FD 200D 1F692', emoji: '👩🏽‍🚒' },
            { code: '1F469 1F3FE 200D 1F692', emoji: '👩🏾‍🚒' },
            { code: '1F469 1F3FF 200D 1F692', emoji: '👩🏿‍🚒' },
            { code: '1F46E', emoji: '👮' },
            { code: '1F46E 1F3FB', emoji: '👮🏻' },
            { code: '1F46E 1F3FC', emoji: '👮🏼' },
            { code: '1F46E 1F3FD', emoji: '👮🏽' },
            { code: '1F46E 1F3FE', emoji: '👮🏾' },
            { code: '1F46E 1F3FF', emoji: '👮🏿' },
            { code: '1F46E 200D 2642 FE0F', emoji: '👮‍♂️' },
            { code: '1F46E 1F3FB 200D 2642 FE0F', emoji: '👮🏻‍♂️' },
            { code: '1F46E 1F3FC 200D 2642 FE0F', emoji: '👮🏼‍♂️' },
            { code: '1F46E 1F3FD 200D 2642 FE0F', emoji: '👮🏽‍♂️' },
            { code: '1F46E 1F3FE 200D 2642 FE0F', emoji: '👮🏾‍♂️' },
            { code: '1F46E 1F3FF 200D 2642 FE0F', emoji: '👮🏿‍♂️' },
            { code: '1F46E 200D 2640 FE0F', emoji: '👮‍♀️' },
            { code: '1F46E 1F3FB 200D 2640 FE0F', emoji: '👮🏻‍♀️' },
            { code: '1F46E 1F3FC 200D 2640 FE0F', emoji: '👮🏼‍♀️' },
            { code: '1F46E 1F3FD 200D 2640 FE0F', emoji: '👮🏽‍♀️' },
            { code: '1F46E 1F3FE 200D 2640 FE0F', emoji: '👮🏾‍♀️' },
            { code: '1F46E 1F3FF 200D 2640 FE0F', emoji: '👮🏿‍♀️' },
            { code: '1F575 FE0F', emoji: '🕵️' },
            { code: '1F575 1F3FB', emoji: '🕵🏻' },
            { code: '1F575 1F3FC', emoji: '🕵🏼' },
            { code: '1F575 1F3FD', emoji: '🕵🏽' },
            { code: '1F575 1F3FE', emoji: '🕵🏾' },
            { code: '1F575 1F3FF', emoji: '🕵🏿' },
            { code: '1F575 FE0F 200D 2642 FE0F', emoji: '🕵️‍♂️' },
            { code: '1F575 1F3FB 200D 2642 FE0F', emoji: '🕵🏻‍♂️' },
            { code: '1F575 1F3FC 200D 2642 FE0F', emoji: '🕵🏼‍♂️' },
            { code: '1F575 1F3FD 200D 2642 FE0F', emoji: '🕵🏽‍♂️' },
            { code: '1F575 1F3FE 200D 2642 FE0F', emoji: '🕵🏾‍♂️' },
            { code: '1F575 1F3FF 200D 2642 FE0F', emoji: '🕵🏿‍♂️' },
            { code: '1F575 FE0F 200D 2640 FE0F', emoji: '🕵️‍♀️' },
            { code: '1F575 1F3FB 200D 2640 FE0F', emoji: '🕵🏻‍♀️' },
            { code: '1F575 1F3FC 200D 2640 FE0F', emoji: '🕵🏼‍♀️' },
            { code: '1F575 1F3FD 200D 2640 FE0F', emoji: '🕵🏽‍♀️' },
            { code: '1F575 1F3FE 200D 2640 FE0F', emoji: '🕵🏾‍♀️' },
            { code: '1F575 1F3FF 200D 2640 FE0F', emoji: '🕵🏿‍♀️' },
            { code: '1F482', emoji: '💂' },
            { code: '1F482 1F3FB', emoji: '💂🏻' },
            { code: '1F482 1F3FC', emoji: '💂🏼' },
            { code: '1F482 1F3FD', emoji: '💂🏽' },
            { code: '1F482 1F3FE', emoji: '💂🏾' },
            { code: '1F482 1F3FF', emoji: '💂🏿' },
            { code: '1F482 200D 2642 FE0F', emoji: '💂‍♂️' },
            { code: '1F482 1F3FB 200D 2642 FE0F', emoji: '💂🏻‍♂️' },
            { code: '1F482 1F3FC 200D 2642 FE0F', emoji: '💂🏼‍♂️' },
            { code: '1F482 1F3FD 200D 2642 FE0F', emoji: '💂🏽‍♂️' },
            { code: '1F482 1F3FE 200D 2642 FE0F', emoji: '💂🏾‍♂️' },
            { code: '1F482 1F3FF 200D 2642 FE0F', emoji: '💂🏿‍♂️' },
            { code: '1F482 200D 2640 FE0F', emoji: '💂‍♀️' },
            { code: '1F482 1F3FB 200D 2640 FE0F', emoji: '💂🏻‍♀️' },
            { code: '1F482 1F3FC 200D 2640 FE0F', emoji: '💂🏼‍♀️' },
            { code: '1F482 1F3FD 200D 2640 FE0F', emoji: '💂🏽‍♀️' },
            { code: '1F482 1F3FE 200D 2640 FE0F', emoji: '💂🏾‍♀️' },
            { code: '1F482 1F3FF 200D 2640 FE0F', emoji: '💂🏿‍♀️' },
            { code: '1F977', emoji: '🥷' },
            { code: '1F977 1F3FB', emoji: '🥷🏻' },
            { code: '1F977 1F3FC', emoji: '🥷🏼' },
            { code: '1F977 1F3FD', emoji: '🥷🏽' },
            { code: '1F977 1F3FE', emoji: '🥷🏾' },
            { code: '1F977 1F3FF', emoji: '🥷🏿' },
            { code: '1F477', emoji: '👷' },
            { code: '1F477 1F3FB', emoji: '👷🏻' },
            { code: '1F477 1F3FC', emoji: '👷🏼' },
            { code: '1F477 1F3FD', emoji: '👷🏽' },
            { code: '1F477 1F3FE', emoji: '👷🏾' },
            { code: '1F477 1F3FF', emoji: '👷🏿' },
            { code: '1F477 200D 2642 FE0F', emoji: '👷‍♂️' },
            { code: '1F477 1F3FB 200D 2642 FE0F', emoji: '👷🏻‍♂️' },
            { code: '1F477 1F3FC 200D 2642 FE0F', emoji: '👷🏼‍♂️' },
            { code: '1F477 1F3FD 200D 2642 FE0F', emoji: '👷🏽‍♂️' },
            { code: '1F477 1F3FE 200D 2642 FE0F', emoji: '👷🏾‍♂️' },
            { code: '1F477 1F3FF 200D 2642 FE0F', emoji: '👷🏿‍♂️' },
            { code: '1F477 200D 2640 FE0F', emoji: '👷‍♀️' },
            { code: '1F477 1F3FB 200D 2640 FE0F', emoji: '👷🏻‍♀️' },
            { code: '1F477 1F3FC 200D 2640 FE0F', emoji: '👷🏼‍♀️' },
            { code: '1F477 1F3FD 200D 2640 FE0F', emoji: '👷🏽‍♀️' },
            { code: '1F477 1F3FE 200D 2640 FE0F', emoji: '👷🏾‍♀️' },
            { code: '1F477 1F3FF 200D 2640 FE0F', emoji: '👷🏿‍♀️' },
            { code: '1FAC5', emoji: '🫅' },
            { code: '1FAC5 1F3FB', emoji: '🫅🏻' },
            { code: '1FAC5 1F3FC', emoji: '🫅🏼' },
            { code: '1FAC5 1F3FD', emoji: '🫅🏽' },
            { code: '1FAC5 1F3FE', emoji: '🫅🏾' },
            { code: '1FAC5 1F3FF', emoji: '🫅🏿' },
            { code: '1F934', emoji: '🤴' },
            { code: '1F934 1F3FB', emoji: '🤴🏻' },
            { code: '1F934 1F3FC', emoji: '🤴🏼' },
            { code: '1F934 1F3FD', emoji: '🤴🏽' },
            { code: '1F934 1F3FE', emoji: '🤴🏾' },
            { code: '1F934 1F3FF', emoji: '🤴🏿' },
            { code: '1F478', emoji: '👸' },
            { code: '1F478 1F3FB', emoji: '👸🏻' },
            { code: '1F478 1F3FC', emoji: '👸🏼' },
            { code: '1F478 1F3FD', emoji: '👸🏽' },
            { code: '1F478 1F3FE', emoji: '👸🏾' },
            { code: '1F478 1F3FF', emoji: '👸🏿' },
            { code: '1F473', emoji: '👳' },
            { code: '1F473 1F3FB', emoji: '👳🏻' },
            { code: '1F473 1F3FC', emoji: '👳🏼' },
            { code: '1F473 1F3FD', emoji: '👳🏽' },
            { code: '1F473 1F3FE', emoji: '👳🏾' },
            { code: '1F473 1F3FF', emoji: '👳🏿' },
            { code: '1F473 200D 2642 FE0F', emoji: '👳‍♂️' },
            { code: '1F473 1F3FB 200D 2642 FE0F', emoji: '👳🏻‍♂️' },
            { code: '1F473 1F3FC 200D 2642 FE0F', emoji: '👳🏼‍♂️' },
            { code: '1F473 1F3FD 200D 2642 FE0F', emoji: '👳🏽‍♂️' },
            { code: '1F473 1F3FE 200D 2642 FE0F', emoji: '👳🏾‍♂️' },
            { code: '1F473 1F3FF 200D 2642 FE0F', emoji: '👳🏿‍♂️' },
            { code: '1F473 200D 2640 FE0F', emoji: '👳‍♀️' },
            { code: '1F473 1F3FB 200D 2640 FE0F', emoji: '👳🏻‍♀️' },
            { code: '1F473 1F3FC 200D 2640 FE0F', emoji: '👳🏼‍♀️' },
            { code: '1F473 1F3FD 200D 2640 FE0F', emoji: '👳🏽‍♀️' },
            { code: '1F473 1F3FE 200D 2640 FE0F', emoji: '👳🏾‍♀️' },
            { code: '1F473 1F3FF 200D 2640 FE0F', emoji: '👳🏿‍♀️' },
            { code: '1F472', emoji: '👲' },
            { code: '1F472 1F3FB', emoji: '👲🏻' },
            { code: '1F472 1F3FC', emoji: '👲🏼' },
            { code: '1F472 1F3FD', emoji: '👲🏽' },
            { code: '1F472 1F3FE', emoji: '👲🏾' },
            { code: '1F472 1F3FF', emoji: '👲🏿' },
            { code: '1F9D5', emoji: '🧕' },
            { code: '1F9D5 1F3FB', emoji: '🧕🏻' },
            { code: '1F9D5 1F3FC', emoji: '🧕🏼' },
            { code: '1F9D5 1F3FD', emoji: '🧕🏽' },
            { code: '1F9D5 1F3FE', emoji: '🧕🏾' },
            { code: '1F9D5 1F3FF', emoji: '🧕🏿' },
            { code: '1F935', emoji: '🤵' },
            { code: '1F935 1F3FB', emoji: '🤵🏻' },
            { code: '1F935 1F3FC', emoji: '🤵🏼' },
            { code: '1F935 1F3FD', emoji: '🤵🏽' },
            { code: '1F935 1F3FE', emoji: '🤵🏾' },
            { code: '1F935 1F3FF', emoji: '🤵🏿' },
            { code: '1F935 200D 2642 FE0F', emoji: '🤵‍♂️' },
            { code: '1F935 1F3FB 200D 2642 FE0F', emoji: '🤵🏻‍♂️' },
            { code: '1F935 1F3FC 200D 2642 FE0F', emoji: '🤵🏼‍♂️' },
            { code: '1F935 1F3FD 200D 2642 FE0F', emoji: '🤵🏽‍♂️' },
            { code: '1F935 1F3FE 200D 2642 FE0F', emoji: '🤵🏾‍♂️' },
            { code: '1F935 1F3FF 200D 2642 FE0F', emoji: '🤵🏿‍♂️' },
            { code: '1F935 200D 2640 FE0F', emoji: '🤵‍♀️' },
            { code: '1F935 1F3FB 200D 2640 FE0F', emoji: '🤵🏻‍♀️' },
            { code: '1F935 1F3FC 200D 2640 FE0F', emoji: '🤵🏼‍♀️' },
            { code: '1F935 1F3FD 200D 2640 FE0F', emoji: '🤵🏽‍♀️' },
            { code: '1F935 1F3FE 200D 2640 FE0F', emoji: '🤵🏾‍♀️' },
            { code: '1F935 1F3FF 200D 2640 FE0F', emoji: '🤵🏿‍♀️' },
            { code: '1F470', emoji: '👰' },
            { code: '1F470 1F3FB', emoji: '👰🏻' },
            { code: '1F470 1F3FC', emoji: '👰🏼' },
            { code: '1F470 1F3FD', emoji: '👰🏽' },
            { code: '1F470 1F3FE', emoji: '👰🏾' },
            { code: '1F470 1F3FF', emoji: '👰🏿' },
            { code: '1F470 200D 2642 FE0F', emoji: '👰‍♂️' },
            { code: '1F470 1F3FB 200D 2642 FE0F', emoji: '👰🏻‍♂️' },
            { code: '1F470 1F3FC 200D 2642 FE0F', emoji: '👰🏼‍♂️' },
            { code: '1F470 1F3FD 200D 2642 FE0F', emoji: '👰🏽‍♂️' },
            { code: '1F470 1F3FE 200D 2642 FE0F', emoji: '👰🏾‍♂️' },
            { code: '1F470 1F3FF 200D 2642 FE0F', emoji: '👰🏿‍♂️' },
            { code: '1F470 200D 2640 FE0F', emoji: '👰‍♀️' },
            { code: '1F470 1F3FB 200D 2640 FE0F', emoji: '👰🏻‍♀️' },
            { code: '1F470 1F3FC 200D 2640 FE0F', emoji: '👰🏼‍♀️' },
            { code: '1F470 1F3FD 200D 2640 FE0F', emoji: '👰🏽‍♀️' },
            { code: '1F470 1F3FE 200D 2640 FE0F', emoji: '👰🏾‍♀️' },
            { code: '1F470 1F3FF 200D 2640 FE0F', emoji: '👰🏿‍♀️' },
            { code: '1F930', emoji: '🤰' },
            { code: '1F930 1F3FB', emoji: '🤰🏻' },
            { code: '1F930 1F3FC', emoji: '🤰🏼' },
            { code: '1F930 1F3FD', emoji: '🤰🏽' },
            { code: '1F930 1F3FE', emoji: '🤰🏾' },
            { code: '1F930 1F3FF', emoji: '🤰🏿' },
            { code: '1FAC3', emoji: '🫃' },
            { code: '1FAC3 1F3FB', emoji: '🫃🏻' },
            { code: '1FAC3 1F3FC', emoji: '🫃🏼' },
            { code: '1FAC3 1F3FD', emoji: '🫃🏽' },
            { code: '1FAC3 1F3FE', emoji: '🫃🏾' },
            { code: '1FAC3 1F3FF', emoji: '🫃🏿' },
            { code: '1FAC4', emoji: '🫄' },
            { code: '1FAC4 1F3FB', emoji: '🫄🏻' },
            { code: '1FAC4 1F3FC', emoji: '🫄🏼' },
            { code: '1FAC4 1F3FD', emoji: '🫄🏽' },
            { code: '1FAC4 1F3FE', emoji: '🫄🏾' },
            { code: '1FAC4 1F3FF', emoji: '🫄🏿' },
            { code: '1F931', emoji: '🤱' },
            { code: '1F931 1F3FB', emoji: '🤱🏻' },
            { code: '1F931 1F3FC', emoji: '🤱🏼' },
            { code: '1F931 1F3FD', emoji: '🤱🏽' },
            { code: '1F931 1F3FE', emoji: '🤱🏾' },
            { code: '1F931 1F3FF', emoji: '🤱🏿' },
            { code: '1F469 200D 1F37C', emoji: '👩‍🍼' },
            { code: '1F469 1F3FB 200D 1F37C', emoji: '👩🏻‍🍼' },
            { code: '1F469 1F3FC 200D 1F37C', emoji: '👩🏼‍🍼' },
            { code: '1F469 1F3FD 200D 1F37C', emoji: '👩🏽‍🍼' },
            { code: '1F469 1F3FE 200D 1F37C', emoji: '👩🏾‍🍼' },
            { code: '1F469 1F3FF 200D 1F37C', emoji: '👩🏿‍🍼' },
            { code: '1F468 200D 1F37C', emoji: '👨‍🍼' },
            { code: '1F468 1F3FB 200D 1F37C', emoji: '👨🏻‍🍼' },
            { code: '1F468 1F3FC 200D 1F37C', emoji: '👨🏼‍🍼' },
            { code: '1F468 1F3FD 200D 1F37C', emoji: '👨🏽‍🍼' },
            { code: '1F468 1F3FE 200D 1F37C', emoji: '👨🏾‍🍼' },
            { code: '1F468 1F3FF 200D 1F37C', emoji: '👨🏿‍🍼' },
            { code: '1F9D1 200D 1F37C', emoji: '🧑‍🍼' },
            { code: '1F9D1 1F3FB 200D 1F37C', emoji: '🧑🏻‍🍼' },
            { code: '1F9D1 1F3FC 200D 1F37C', emoji: '🧑🏼‍🍼' },
            { code: '1F9D1 1F3FD 200D 1F37C', emoji: '🧑🏽‍🍼' },
            { code: '1F9D1 1F3FE 200D 1F37C', emoji: '🧑🏾‍🍼' },
            { code: '1F9D1 1F3FF 200D 1F37C', emoji: '🧑🏿‍🍼' },
        ],
        'person-fantasy': [
            { code: '1F47C', emoji: '👼' },
            { code: '1F47C 1F3FB', emoji: '👼🏻' },
            { code: '1F47C 1F3FC', emoji: '👼🏼' },
            { code: '1F47C 1F3FD', emoji: '👼🏽' },
            { code: '1F47C 1F3FE', emoji: '👼🏾' },
            { code: '1F47C 1F3FF', emoji: '👼🏿' },
            { code: '1F385', emoji: '🎅' },
            { code: '1F385 1F3FB', emoji: '🎅🏻' },
            { code: '1F385 1F3FC', emoji: '🎅🏼' },
            { code: '1F385 1F3FD', emoji: '🎅🏽' },
            { code: '1F385 1F3FE', emoji: '🎅🏾' },
            { code: '1F385 1F3FF', emoji: '🎅🏿' },
            { code: '1F936', emoji: '🤶' },
            { code: '1F936 1F3FB', emoji: '🤶🏻' },
            { code: '1F936 1F3FC', emoji: '🤶🏼' },
            { code: '1F936 1F3FD', emoji: '🤶🏽' },
            { code: '1F936 1F3FE', emoji: '🤶🏾' },
            { code: '1F936 1F3FF', emoji: '🤶🏿' },
            { code: '1F9D1 200D 1F384', emoji: '🧑‍🎄' },
            { code: '1F9D1 1F3FB 200D 1F384', emoji: '🧑🏻‍🎄' },
            { code: '1F9D1 1F3FC 200D 1F384', emoji: '🧑🏼‍🎄' },
            { code: '1F9D1 1F3FD 200D 1F384', emoji: '🧑🏽‍🎄' },
            { code: '1F9D1 1F3FE 200D 1F384', emoji: '🧑🏾‍🎄' },
            { code: '1F9D1 1F3FF 200D 1F384', emoji: '🧑🏿‍🎄' },
            { code: '1F9B8', emoji: '🦸' },
            { code: '1F9B8 1F3FB', emoji: '🦸🏻' },
            { code: '1F9B8 1F3FC', emoji: '🦸🏼' },
            { code: '1F9B8 1F3FD', emoji: '🦸🏽' },
            { code: '1F9B8 1F3FE', emoji: '🦸🏾' },
            { code: '1F9B8 1F3FF', emoji: '🦸🏿' },
            { code: '1F9B8 200D 2642 FE0F', emoji: '🦸‍♂️' },
            { code: '1F9B8 1F3FB 200D 2642 FE0F', emoji: '🦸🏻‍♂️' },
            { code: '1F9B8 1F3FC 200D 2642 FE0F', emoji: '🦸🏼‍♂️' },
            { code: '1F9B8 1F3FD 200D 2642 FE0F', emoji: '🦸🏽‍♂️' },
            { code: '1F9B8 1F3FE 200D 2642 FE0F', emoji: '🦸🏾‍♂️' },
            { code: '1F9B8 1F3FF 200D 2642 FE0F', emoji: '🦸🏿‍♂️' },
            { code: '1F9B8 200D 2640 FE0F', emoji: '🦸‍♀️' },
            { code: '1F9B8 1F3FB 200D 2640 FE0F', emoji: '🦸🏻‍♀️' },
            { code: '1F9B8 1F3FC 200D 2640 FE0F', emoji: '🦸🏼‍♀️' },
            { code: '1F9B8 1F3FD 200D 2640 FE0F', emoji: '🦸🏽‍♀️' },
            { code: '1F9B8 1F3FE 200D 2640 FE0F', emoji: '🦸🏾‍♀️' },
            { code: '1F9B8 1F3FF 200D 2640 FE0F', emoji: '🦸🏿‍♀️' },
            { code: '1F9B9', emoji: '🦹' },
            { code: '1F9B9 1F3FB', emoji: '🦹🏻' },
            { code: '1F9B9 1F3FC', emoji: '🦹🏼' },
            { code: '1F9B9 1F3FD', emoji: '🦹🏽' },
            { code: '1F9B9 1F3FE', emoji: '🦹🏾' },
            { code: '1F9B9 1F3FF', emoji: '🦹🏿' },
            { code: '1F9B9 200D 2642 FE0F', emoji: '🦹‍♂️' },
            { code: '1F9B9 1F3FB 200D 2642 FE0F', emoji: '🦹🏻‍♂️' },
            { code: '1F9B9 1F3FC 200D 2642 FE0F', emoji: '🦹🏼‍♂️' },
            { code: '1F9B9 1F3FD 200D 2642 FE0F', emoji: '🦹🏽‍♂️' },
            { code: '1F9B9 1F3FE 200D 2642 FE0F', emoji: '🦹🏾‍♂️' },
            { code: '1F9B9 1F3FF 200D 2642 FE0F', emoji: '🦹🏿‍♂️' },
            { code: '1F9B9 200D 2640 FE0F', emoji: '🦹‍♀️' },
            { code: '1F9B9 1F3FB 200D 2640 FE0F', emoji: '🦹🏻‍♀️' },
            { code: '1F9B9 1F3FC 200D 2640 FE0F', emoji: '🦹🏼‍♀️' },
            { code: '1F9B9 1F3FD 200D 2640 FE0F', emoji: '🦹🏽‍♀️' },
            { code: '1F9B9 1F3FE 200D 2640 FE0F', emoji: '🦹🏾‍♀️' },
            { code: '1F9B9 1F3FF 200D 2640 FE0F', emoji: '🦹🏿‍♀️' },
            { code: '1F9D9', emoji: '🧙' },
            { code: '1F9D9 1F3FB', emoji: '🧙🏻' },
            { code: '1F9D9 1F3FC', emoji: '🧙🏼' },
            { code: '1F9D9 1F3FD', emoji: '🧙🏽' },
            { code: '1F9D9 1F3FE', emoji: '🧙🏾' },
            { code: '1F9D9 1F3FF', emoji: '🧙🏿' },
            { code: '1F9D9 200D 2642 FE0F', emoji: '🧙‍♂️' },
            { code: '1F9D9 1F3FB 200D 2642 FE0F', emoji: '🧙🏻‍♂️' },
            { code: '1F9D9 1F3FC 200D 2642 FE0F', emoji: '🧙🏼‍♂️' },
            { code: '1F9D9 1F3FD 200D 2642 FE0F', emoji: '🧙🏽‍♂️' },
            { code: '1F9D9 1F3FE 200D 2642 FE0F', emoji: '🧙🏾‍♂️' },
            { code: '1F9D9 1F3FF 200D 2642 FE0F', emoji: '🧙🏿‍♂️' },
            { code: '1F9D9 200D 2640 FE0F', emoji: '🧙‍♀️' },
            { code: '1F9D9 1F3FB 200D 2640 FE0F', emoji: '🧙🏻‍♀️' },
            { code: '1F9D9 1F3FC 200D 2640 FE0F', emoji: '🧙🏼‍♀️' },
            { code: '1F9D9 1F3FD 200D 2640 FE0F', emoji: '🧙🏽‍♀️' },
            { code: '1F9D9 1F3FE 200D 2640 FE0F', emoji: '🧙🏾‍♀️' },
            { code: '1F9D9 1F3FF 200D 2640 FE0F', emoji: '🧙🏿‍♀️' },
            { code: '1F9DA', emoji: '🧚' },
            { code: '1F9DA 1F3FB', emoji: '🧚🏻' },
            { code: '1F9DA 1F3FC', emoji: '🧚🏼' },
            { code: '1F9DA 1F3FD', emoji: '🧚🏽' },
            { code: '1F9DA 1F3FE', emoji: '🧚🏾' },
            { code: '1F9DA 1F3FF', emoji: '🧚🏿' },
            { code: '1F9DA 200D 2642 FE0F', emoji: '🧚‍♂️' },
            { code: '1F9DA 1F3FB 200D 2642 FE0F', emoji: '🧚🏻‍♂️' },
            { code: '1F9DA 1F3FC 200D 2642 FE0F', emoji: '🧚🏼‍♂️' },
            { code: '1F9DA 1F3FD 200D 2642 FE0F', emoji: '🧚🏽‍♂️' },
            { code: '1F9DA 1F3FE 200D 2642 FE0F', emoji: '🧚🏾‍♂️' },
            { code: '1F9DA 1F3FF 200D 2642 FE0F', emoji: '🧚🏿‍♂️' },
            { code: '1F9DA 200D 2640 FE0F', emoji: '🧚‍♀️' },
            { code: '1F9DA 1F3FB 200D 2640 FE0F', emoji: '🧚🏻‍♀️' },
            { code: '1F9DA 1F3FC 200D 2640 FE0F', emoji: '🧚🏼‍♀️' },
            { code: '1F9DA 1F3FD 200D 2640 FE0F', emoji: '🧚🏽‍♀️' },
            { code: '1F9DA 1F3FE 200D 2640 FE0F', emoji: '🧚🏾‍♀️' },
            { code: '1F9DA 1F3FF 200D 2640 FE0F', emoji: '🧚🏿‍♀️' },
            { code: '1F9DB', emoji: '🧛' },
            { code: '1F9DB 1F3FB', emoji: '🧛🏻' },
            { code: '1F9DB 1F3FC', emoji: '🧛🏼' },
            { code: '1F9DB 1F3FD', emoji: '🧛🏽' },
            { code: '1F9DB 1F3FE', emoji: '🧛🏾' },
            { code: '1F9DB 1F3FF', emoji: '🧛🏿' },
            { code: '1F9DB 200D 2642 FE0F', emoji: '🧛‍♂️' },
            { code: '1F9DB 1F3FB 200D 2642 FE0F', emoji: '🧛🏻‍♂️' },
            { code: '1F9DB 1F3FC 200D 2642 FE0F', emoji: '🧛🏼‍♂️' },
            { code: '1F9DB 1F3FD 200D 2642 FE0F', emoji: '🧛🏽‍♂️' },
            { code: '1F9DB 1F3FE 200D 2642 FE0F', emoji: '🧛🏾‍♂️' },
            { code: '1F9DB 1F3FF 200D 2642 FE0F', emoji: '🧛🏿‍♂️' },
            { code: '1F9DB 200D 2640 FE0F', emoji: '🧛‍♀️' },
            { code: '1F9DB 1F3FB 200D 2640 FE0F', emoji: '🧛🏻‍♀️' },
            { code: '1F9DB 1F3FC 200D 2640 FE0F', emoji: '🧛🏼‍♀️' },
            { code: '1F9DB 1F3FD 200D 2640 FE0F', emoji: '🧛🏽‍♀️' },
            { code: '1F9DB 1F3FE 200D 2640 FE0F', emoji: '🧛🏾‍♀️' },
            { code: '1F9DB 1F3FF 200D 2640 FE0F', emoji: '🧛🏿‍♀️' },
            { code: '1F9DC', emoji: '🧜' },
            { code: '1F9DC 1F3FB', emoji: '🧜🏻' },
            { code: '1F9DC 1F3FC', emoji: '🧜🏼' },
            { code: '1F9DC 1F3FD', emoji: '🧜🏽' },
            { code: '1F9DC 1F3FE', emoji: '🧜🏾' },
            { code: '1F9DC 1F3FF', emoji: '🧜🏿' },
            { code: '1F9DC 200D 2642 FE0F', emoji: '🧜‍♂️' },
            { code: '1F9DC 1F3FB 200D 2642 FE0F', emoji: '🧜🏻‍♂️' },
            { code: '1F9DC 1F3FC 200D 2642 FE0F', emoji: '🧜🏼‍♂️' },
            { code: '1F9DC 1F3FD 200D 2642 FE0F', emoji: '🧜🏽‍♂️' },
            { code: '1F9DC 1F3FE 200D 2642 FE0F', emoji: '🧜🏾‍♂️' },
            { code: '1F9DC 1F3FF 200D 2642 FE0F', emoji: '🧜🏿‍♂️' },
            { code: '1F9DC 200D 2640 FE0F', emoji: '🧜‍♀️' },
            { code: '1F9DC 1F3FB 200D 2640 FE0F', emoji: '🧜🏻‍♀️' },
            { code: '1F9DC 1F3FC 200D 2640 FE0F', emoji: '🧜🏼‍♀️' },
            { code: '1F9DC 1F3FD 200D 2640 FE0F', emoji: '🧜🏽‍♀️' },
            { code: '1F9DC 1F3FE 200D 2640 FE0F', emoji: '🧜🏾‍♀️' },
            { code: '1F9DC 1F3FF 200D 2640 FE0F', emoji: '🧜🏿‍♀️' },
            { code: '1F9DD', emoji: '🧝' },
            { code: '1F9DD 1F3FB', emoji: '🧝🏻' },
            { code: '1F9DD 1F3FC', emoji: '🧝🏼' },
            { code: '1F9DD 1F3FD', emoji: '🧝🏽' },
            { code: '1F9DD 1F3FE', emoji: '🧝🏾' },
            { code: '1F9DD 1F3FF', emoji: '🧝🏿' },
            { code: '1F9DD 200D 2642 FE0F', emoji: '🧝‍♂️' },
            { code: '1F9DD 1F3FB 200D 2642 FE0F', emoji: '🧝🏻‍♂️' },
            { code: '1F9DD 1F3FC 200D 2642 FE0F', emoji: '🧝🏼‍♂️' },
            { code: '1F9DD 1F3FD 200D 2642 FE0F', emoji: '🧝🏽‍♂️' },
            { code: '1F9DD 1F3FE 200D 2642 FE0F', emoji: '🧝🏾‍♂️' },
            { code: '1F9DD 1F3FF 200D 2642 FE0F', emoji: '🧝🏿‍♂️' },
            { code: '1F9DD 200D 2640 FE0F', emoji: '🧝‍♀️' },
            { code: '1F9DD 1F3FB 200D 2640 FE0F', emoji: '🧝🏻‍♀️' },
            { code: '1F9DD 1F3FC 200D 2640 FE0F', emoji: '🧝🏼‍♀️' },
            { code: '1F9DD 1F3FD 200D 2640 FE0F', emoji: '🧝🏽‍♀️' },
            { code: '1F9DD 1F3FE 200D 2640 FE0F', emoji: '🧝🏾‍♀️' },
            { code: '1F9DD 1F3FF 200D 2640 FE0F', emoji: '🧝🏿‍♀️' },
            { code: '1F9DE', emoji: '🧞' },
            { code: '1F9DE 200D 2642 FE0F', emoji: '🧞‍♂️' },
            { code: '1F9DE 200D 2640 FE0F', emoji: '🧞‍♀️' },
            { code: '1F9DF', emoji: '🧟' },
            { code: '1F9DF 200D 2642 FE0F', emoji: '🧟‍♂️' },
            { code: '1F9DF 200D 2640 FE0F', emoji: '🧟‍♀️' },
            { code: '1F9CC', emoji: '🧌' },
        ],
        'person-activity': [
            { code: '1F486', emoji: '💆' },
            { code: '1F486 1F3FB', emoji: '💆🏻' },
            { code: '1F486 1F3FC', emoji: '💆🏼' },
            { code: '1F486 1F3FD', emoji: '💆🏽' },
            { code: '1F486 1F3FE', emoji: '💆🏾' },
            { code: '1F486 1F3FF', emoji: '💆🏿' },
            { code: '1F486 200D 2642 FE0F', emoji: '💆‍♂️' },
            { code: '1F486 1F3FB 200D 2642 FE0F', emoji: '💆🏻‍♂️' },
            { code: '1F486 1F3FC 200D 2642 FE0F', emoji: '💆🏼‍♂️' },
            { code: '1F486 1F3FD 200D 2642 FE0F', emoji: '💆🏽‍♂️' },
            { code: '1F486 1F3FE 200D 2642 FE0F', emoji: '💆🏾‍♂️' },
            { code: '1F486 1F3FF 200D 2642 FE0F', emoji: '💆🏿‍♂️' },
            { code: '1F486 200D 2640 FE0F', emoji: '💆‍♀️' },
            { code: '1F486 1F3FB 200D 2640 FE0F', emoji: '💆🏻‍♀️' },
            { code: '1F486 1F3FC 200D 2640 FE0F', emoji: '💆🏼‍♀️' },
            { code: '1F486 1F3FD 200D 2640 FE0F', emoji: '💆🏽‍♀️' },
            { code: '1F486 1F3FE 200D 2640 FE0F', emoji: '💆🏾‍♀️' },
            { code: '1F486 1F3FF 200D 2640 FE0F', emoji: '💆🏿‍♀️' },
            { code: '1F487', emoji: '💇' },
            { code: '1F487 1F3FB', emoji: '💇🏻' },
            { code: '1F487 1F3FC', emoji: '💇🏼' },
            { code: '1F487 1F3FD', emoji: '💇🏽' },
            { code: '1F487 1F3FE', emoji: '💇🏾' },
            { code: '1F487 1F3FF', emoji: '💇🏿' },
            { code: '1F487 200D 2642 FE0F', emoji: '💇‍♂️' },
            { code: '1F487 1F3FB 200D 2642 FE0F', emoji: '💇🏻‍♂️' },
            { code: '1F487 1F3FC 200D 2642 FE0F', emoji: '💇🏼‍♂️' },
            { code: '1F487 1F3FD 200D 2642 FE0F', emoji: '💇🏽‍♂️' },
            { code: '1F487 1F3FE 200D 2642 FE0F', emoji: '💇🏾‍♂️' },
            { code: '1F487 1F3FF 200D 2642 FE0F', emoji: '💇🏿‍♂️' },
            { code: '1F487 200D 2640 FE0F', emoji: '💇‍♀️' },
            { code: '1F487 1F3FB 200D 2640 FE0F', emoji: '💇🏻‍♀️' },
            { code: '1F487 1F3FC 200D 2640 FE0F', emoji: '💇🏼‍♀️' },
            { code: '1F487 1F3FD 200D 2640 FE0F', emoji: '💇🏽‍♀️' },
            { code: '1F487 1F3FE 200D 2640 FE0F', emoji: '💇🏾‍♀️' },
            { code: '1F487 1F3FF 200D 2640 FE0F', emoji: '💇🏿‍♀️' },
            { code: '1F6B6', emoji: '🚶' },
            { code: '1F6B6 1F3FB', emoji: '🚶🏻' },
            { code: '1F6B6 1F3FC', emoji: '🚶🏼' },
            { code: '1F6B6 1F3FD', emoji: '🚶🏽' },
            { code: '1F6B6 1F3FE', emoji: '🚶🏾' },
            { code: '1F6B6 1F3FF', emoji: '🚶🏿' },
            { code: '1F6B6 200D 2642 FE0F', emoji: '🚶‍♂️' },
            { code: '1F6B6 1F3FB 200D 2642 FE0F', emoji: '🚶🏻‍♂️' },
            { code: '1F6B6 1F3FC 200D 2642 FE0F', emoji: '🚶🏼‍♂️' },
            { code: '1F6B6 1F3FD 200D 2642 FE0F', emoji: '🚶🏽‍♂️' },
            { code: '1F6B6 1F3FE 200D 2642 FE0F', emoji: '🚶🏾‍♂️' },
            { code: '1F6B6 1F3FF 200D 2642 FE0F', emoji: '🚶🏿‍♂️' },
            { code: '1F6B6 200D 2640 FE0F', emoji: '🚶‍♀️' },
            { code: '1F6B6 1F3FB 200D 2640 FE0F', emoji: '🚶🏻‍♀️' },
            { code: '1F6B6 1F3FC 200D 2640 FE0F', emoji: '🚶🏼‍♀️' },
            { code: '1F6B6 1F3FD 200D 2640 FE0F', emoji: '🚶🏽‍♀️' },
            { code: '1F6B6 1F3FE 200D 2640 FE0F', emoji: '🚶🏾‍♀️' },
            { code: '1F6B6 1F3FF 200D 2640 FE0F', emoji: '🚶🏿‍♀️' },
            { code: '1F6B6 200D 27A1 FE0F', emoji: '🚶‍➡️' },
            { code: '1F6B6 1F3FB 200D 27A1 FE0F', emoji: '🚶🏻‍➡️' },
            { code: '1F6B6 1F3FC 200D 27A1 FE0F', emoji: '🚶🏼‍➡️' },
            { code: '1F6B6 1F3FD 200D 27A1 FE0F', emoji: '🚶🏽‍➡️' },
            { code: '1F6B6 1F3FE 200D 27A1 FE0F', emoji: '🚶🏾‍➡️' },
            { code: '1F6B6 1F3FF 200D 27A1 FE0F', emoji: '🚶🏿‍➡️' },
            { code: '1F6B6 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🚶‍♀️‍➡️' },
            { code: '1F6B6 1F3FB 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🚶🏻‍♀️‍➡️' },
            { code: '1F6B6 1F3FC 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🚶🏼‍♀️‍➡️' },
            { code: '1F6B6 1F3FD 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🚶🏽‍♀️‍➡️' },
            { code: '1F6B6 1F3FE 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🚶🏾‍♀️‍➡️' },
            { code: '1F6B6 1F3FF 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🚶🏿‍♀️‍➡️' },
            { code: '1F6B6 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🚶‍♂️‍➡️' },
            { code: '1F6B6 1F3FB 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🚶🏻‍♂️‍➡️' },
            { code: '1F6B6 1F3FC 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🚶🏼‍♂️‍➡️' },
            { code: '1F6B6 1F3FD 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🚶🏽‍♂️‍➡️' },
            { code: '1F6B6 1F3FE 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🚶🏾‍♂️‍➡️' },
            { code: '1F6B6 1F3FF 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🚶🏿‍♂️‍➡️' },
            { code: '1F9CD', emoji: '🧍' },
            { code: '1F9CD 1F3FB', emoji: '🧍🏻' },
            { code: '1F9CD 1F3FC', emoji: '🧍🏼' },
            { code: '1F9CD 1F3FD', emoji: '🧍🏽' },
            { code: '1F9CD 1F3FE', emoji: '🧍🏾' },
            { code: '1F9CD 1F3FF', emoji: '🧍🏿' },
            { code: '1F9CD 200D 2642 FE0F', emoji: '🧍‍♂️' },
            { code: '1F9CD 1F3FB 200D 2642 FE0F', emoji: '🧍🏻‍♂️' },
            { code: '1F9CD 1F3FC 200D 2642 FE0F', emoji: '🧍🏼‍♂️' },
            { code: '1F9CD 1F3FD 200D 2642 FE0F', emoji: '🧍🏽‍♂️' },
            { code: '1F9CD 1F3FE 200D 2642 FE0F', emoji: '🧍🏾‍♂️' },
            { code: '1F9CD 1F3FF 200D 2642 FE0F', emoji: '🧍🏿‍♂️' },
            { code: '1F9CD 200D 2640 FE0F', emoji: '🧍‍♀️' },
            { code: '1F9CD 1F3FB 200D 2640 FE0F', emoji: '🧍🏻‍♀️' },
            { code: '1F9CD 1F3FC 200D 2640 FE0F', emoji: '🧍🏼‍♀️' },
            { code: '1F9CD 1F3FD 200D 2640 FE0F', emoji: '🧍🏽‍♀️' },
            { code: '1F9CD 1F3FE 200D 2640 FE0F', emoji: '🧍🏾‍♀️' },
            { code: '1F9CD 1F3FF 200D 2640 FE0F', emoji: '🧍🏿‍♀️' },
            { code: '1F9CE', emoji: '🧎' },
            { code: '1F9CE 1F3FB', emoji: '🧎🏻' },
            { code: '1F9CE 1F3FC', emoji: '🧎🏼' },
            { code: '1F9CE 1F3FD', emoji: '🧎🏽' },
            { code: '1F9CE 1F3FE', emoji: '🧎🏾' },
            { code: '1F9CE 1F3FF', emoji: '🧎🏿' },
            { code: '1F9CE 200D 2642 FE0F', emoji: '🧎‍♂️' },
            { code: '1F9CE 1F3FB 200D 2642 FE0F', emoji: '🧎🏻‍♂️' },
            { code: '1F9CE 1F3FC 200D 2642 FE0F', emoji: '🧎🏼‍♂️' },
            { code: '1F9CE 1F3FD 200D 2642 FE0F', emoji: '🧎🏽‍♂️' },
            { code: '1F9CE 1F3FE 200D 2642 FE0F', emoji: '🧎🏾‍♂️' },
            { code: '1F9CE 1F3FF 200D 2642 FE0F', emoji: '🧎🏿‍♂️' },
            { code: '1F9CE 200D 2640 FE0F', emoji: '🧎‍♀️' },
            { code: '1F9CE 1F3FB 200D 2640 FE0F', emoji: '🧎🏻‍♀️' },
            { code: '1F9CE 1F3FC 200D 2640 FE0F', emoji: '🧎🏼‍♀️' },
            { code: '1F9CE 1F3FD 200D 2640 FE0F', emoji: '🧎🏽‍♀️' },
            { code: '1F9CE 1F3FE 200D 2640 FE0F', emoji: '🧎🏾‍♀️' },
            { code: '1F9CE 1F3FF 200D 2640 FE0F', emoji: '🧎🏿‍♀️' },
            { code: '1F9CE 200D 27A1 FE0F', emoji: '🧎‍➡️' },
            { code: '1F9CE 1F3FB 200D 27A1 FE0F', emoji: '🧎🏻‍➡️' },
            { code: '1F9CE 1F3FC 200D 27A1 FE0F', emoji: '🧎🏼‍➡️' },
            { code: '1F9CE 1F3FD 200D 27A1 FE0F', emoji: '🧎🏽‍➡️' },
            { code: '1F9CE 1F3FE 200D 27A1 FE0F', emoji: '🧎🏾‍➡️' },
            { code: '1F9CE 1F3FF 200D 27A1 FE0F', emoji: '🧎🏿‍➡️' },
            { code: '1F9CE 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🧎‍♀️‍➡️' },
            { code: '1F9CE 1F3FB 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🧎🏻‍♀️‍➡️' },
            { code: '1F9CE 1F3FC 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🧎🏼‍♀️‍➡️' },
            { code: '1F9CE 1F3FD 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🧎🏽‍♀️‍➡️' },
            { code: '1F9CE 1F3FE 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🧎🏾‍♀️‍➡️' },
            { code: '1F9CE 1F3FF 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🧎🏿‍♀️‍➡️' },
            { code: '1F9CE 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🧎‍♂️‍➡️' },
            { code: '1F9CE 1F3FB 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🧎🏻‍♂️‍➡️' },
            { code: '1F9CE 1F3FC 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🧎🏼‍♂️‍➡️' },
            { code: '1F9CE 1F3FD 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🧎🏽‍♂️‍➡️' },
            { code: '1F9CE 1F3FE 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🧎🏾‍♂️‍➡️' },
            { code: '1F9CE 1F3FF 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🧎🏿‍♂️‍➡️' },
            { code: '1F9D1 200D 1F9AF', emoji: '🧑‍🦯' },
            { code: '1F9D1 1F3FB 200D 1F9AF', emoji: '🧑🏻‍🦯' },
            { code: '1F9D1 1F3FC 200D 1F9AF', emoji: '🧑🏼‍🦯' },
            { code: '1F9D1 1F3FD 200D 1F9AF', emoji: '🧑🏽‍🦯' },
            { code: '1F9D1 1F3FE 200D 1F9AF', emoji: '🧑🏾‍🦯' },
            { code: '1F9D1 1F3FF 200D 1F9AF', emoji: '🧑🏿‍🦯' },
            { code: '1F9D1 200D 1F9AF 200D 27A1 FE0F', emoji: '🧑‍🦯‍➡️' },
            { code: '1F9D1 1F3FB 200D 1F9AF 200D 27A1 FE0F', emoji: '🧑🏻‍🦯‍➡️' },
            { code: '1F9D1 1F3FC 200D 1F9AF 200D 27A1 FE0F', emoji: '🧑🏼‍🦯‍➡️' },
            { code: '1F9D1 1F3FD 200D 1F9AF 200D 27A1 FE0F', emoji: '🧑🏽‍🦯‍➡️' },
            { code: '1F9D1 1F3FE 200D 1F9AF 200D 27A1 FE0F', emoji: '🧑🏾‍🦯‍➡️' },
            { code: '1F9D1 1F3FF 200D 1F9AF 200D 27A1 FE0F', emoji: '🧑🏿‍🦯‍➡️' },
            { code: '1F468 200D 1F9AF', emoji: '👨‍🦯' },
            { code: '1F468 1F3FB 200D 1F9AF', emoji: '👨🏻‍🦯' },
            { code: '1F468 1F3FC 200D 1F9AF', emoji: '👨🏼‍🦯' },
            { code: '1F468 1F3FD 200D 1F9AF', emoji: '👨🏽‍🦯' },
            { code: '1F468 1F3FE 200D 1F9AF', emoji: '👨🏾‍🦯' },
            { code: '1F468 1F3FF 200D 1F9AF', emoji: '👨🏿‍🦯' },
            { code: '1F468 200D 1F9AF 200D 27A1 FE0F', emoji: '👨‍🦯‍➡️' },
            { code: '1F468 1F3FB 200D 1F9AF 200D 27A1 FE0F', emoji: '👨🏻‍🦯‍➡️' },
            { code: '1F468 1F3FC 200D 1F9AF 200D 27A1 FE0F', emoji: '👨🏼‍🦯‍➡️' },
            { code: '1F468 1F3FD 200D 1F9AF 200D 27A1 FE0F', emoji: '👨🏽‍🦯‍➡️' },
            { code: '1F468 1F3FE 200D 1F9AF 200D 27A1 FE0F', emoji: '👨🏾‍🦯‍➡️' },
            { code: '1F468 1F3FF 200D 1F9AF 200D 27A1 FE0F', emoji: '👨🏿‍🦯‍➡️' },
            { code: '1F469 200D 1F9AF', emoji: '👩‍🦯' },
            { code: '1F469 1F3FB 200D 1F9AF', emoji: '👩🏻‍🦯' },
            { code: '1F469 1F3FC 200D 1F9AF', emoji: '👩🏼‍🦯' },
            { code: '1F469 1F3FD 200D 1F9AF', emoji: '👩🏽‍🦯' },
            { code: '1F469 1F3FE 200D 1F9AF', emoji: '👩🏾‍🦯' },
            { code: '1F469 1F3FF 200D 1F9AF', emoji: '👩🏿‍🦯' },
            { code: '1F469 200D 1F9AF 200D 27A1 FE0F', emoji: '👩‍🦯‍➡️' },
            { code: '1F469 1F3FB 200D 1F9AF 200D 27A1 FE0F', emoji: '👩🏻‍🦯‍➡️' },
            { code: '1F469 1F3FC 200D 1F9AF 200D 27A1 FE0F', emoji: '👩🏼‍🦯‍➡️' },
            { code: '1F469 1F3FD 200D 1F9AF 200D 27A1 FE0F', emoji: '👩🏽‍🦯‍➡️' },
            { code: '1F469 1F3FE 200D 1F9AF 200D 27A1 FE0F', emoji: '👩🏾‍🦯‍➡️' },
            { code: '1F469 1F3FF 200D 1F9AF 200D 27A1 FE0F', emoji: '👩🏿‍🦯‍➡️' },
            { code: '1F9D1 200D 1F9BC', emoji: '🧑‍🦼' },
            { code: '1F9D1 1F3FB 200D 1F9BC', emoji: '🧑🏻‍🦼' },
            { code: '1F9D1 1F3FC 200D 1F9BC', emoji: '🧑🏼‍🦼' },
            { code: '1F9D1 1F3FD 200D 1F9BC', emoji: '🧑🏽‍🦼' },
            { code: '1F9D1 1F3FE 200D 1F9BC', emoji: '🧑🏾‍🦼' },
            { code: '1F9D1 1F3FF 200D 1F9BC', emoji: '🧑🏿‍🦼' },
            { code: '1F9D1 200D 1F9BC 200D 27A1 FE0F', emoji: '🧑‍🦼‍➡️' },
            { code: '1F9D1 1F3FB 200D 1F9BC 200D 27A1 FE0F', emoji: '🧑🏻‍🦼‍➡️' },
            { code: '1F9D1 1F3FC 200D 1F9BC 200D 27A1 FE0F', emoji: '🧑🏼‍🦼‍➡️' },
            { code: '1F9D1 1F3FD 200D 1F9BC 200D 27A1 FE0F', emoji: '🧑🏽‍🦼‍➡️' },
            { code: '1F9D1 1F3FE 200D 1F9BC 200D 27A1 FE0F', emoji: '🧑🏾‍🦼‍➡️' },
            { code: '1F9D1 1F3FF 200D 1F9BC 200D 27A1 FE0F', emoji: '🧑🏿‍🦼‍➡️' },
            { code: '1F468 200D 1F9BC', emoji: '👨‍🦼' },
            { code: '1F468 1F3FB 200D 1F9BC', emoji: '👨🏻‍🦼' },
            { code: '1F468 1F3FC 200D 1F9BC', emoji: '👨🏼‍🦼' },
            { code: '1F468 1F3FD 200D 1F9BC', emoji: '👨🏽‍🦼' },
            { code: '1F468 1F3FE 200D 1F9BC', emoji: '👨🏾‍🦼' },
            { code: '1F468 1F3FF 200D 1F9BC', emoji: '👨🏿‍🦼' },
            { code: '1F468 200D 1F9BC 200D 27A1 FE0F', emoji: '👨‍🦼‍➡️' },
            { code: '1F468 1F3FB 200D 1F9BC 200D 27A1 FE0F', emoji: '👨🏻‍🦼‍➡️' },
            { code: '1F468 1F3FC 200D 1F9BC 200D 27A1 FE0F', emoji: '👨🏼‍🦼‍➡️' },
            { code: '1F468 1F3FD 200D 1F9BC 200D 27A1 FE0F', emoji: '👨🏽‍🦼‍➡️' },
            { code: '1F468 1F3FE 200D 1F9BC 200D 27A1 FE0F', emoji: '👨🏾‍🦼‍➡️' },
            { code: '1F468 1F3FF 200D 1F9BC 200D 27A1 FE0F', emoji: '👨🏿‍🦼‍➡️' },
            { code: '1F469 200D 1F9BC', emoji: '👩‍🦼' },
            { code: '1F469 1F3FB 200D 1F9BC', emoji: '👩🏻‍🦼' },
            { code: '1F469 1F3FC 200D 1F9BC', emoji: '👩🏼‍🦼' },
            { code: '1F469 1F3FD 200D 1F9BC', emoji: '👩🏽‍🦼' },
            { code: '1F469 1F3FE 200D 1F9BC', emoji: '👩🏾‍🦼' },
            { code: '1F469 1F3FF 200D 1F9BC', emoji: '👩🏿‍🦼' },
            { code: '1F469 200D 1F9BC 200D 27A1 FE0F', emoji: '👩‍🦼‍➡️' },
            { code: '1F469 1F3FB 200D 1F9BC 200D 27A1 FE0F', emoji: '👩🏻‍🦼‍➡️' },
            { code: '1F469 1F3FC 200D 1F9BC 200D 27A1 FE0F', emoji: '👩🏼‍🦼‍➡️' },
            { code: '1F469 1F3FD 200D 1F9BC 200D 27A1 FE0F', emoji: '👩🏽‍🦼‍➡️' },
            { code: '1F469 1F3FE 200D 1F9BC 200D 27A1 FE0F', emoji: '👩🏾‍🦼‍➡️' },
            { code: '1F469 1F3FF 200D 1F9BC 200D 27A1 FE0F', emoji: '👩🏿‍🦼‍➡️' },
            { code: '1F9D1 200D 1F9BD', emoji: '🧑‍🦽' },
            { code: '1F9D1 1F3FB 200D 1F9BD', emoji: '🧑🏻‍🦽' },
            { code: '1F9D1 1F3FC 200D 1F9BD', emoji: '🧑🏼‍🦽' },
            { code: '1F9D1 1F3FD 200D 1F9BD', emoji: '🧑🏽‍🦽' },
            { code: '1F9D1 1F3FE 200D 1F9BD', emoji: '🧑🏾‍🦽' },
            { code: '1F9D1 1F3FF 200D 1F9BD', emoji: '🧑🏿‍🦽' },
            { code: '1F9D1 200D 1F9BD 200D 27A1 FE0F', emoji: '🧑‍🦽‍➡️' },
            { code: '1F9D1 1F3FB 200D 1F9BD 200D 27A1 FE0F', emoji: '🧑🏻‍🦽‍➡️' },
            { code: '1F9D1 1F3FC 200D 1F9BD 200D 27A1 FE0F', emoji: '🧑🏼‍🦽‍➡️' },
            { code: '1F9D1 1F3FD 200D 1F9BD 200D 27A1 FE0F', emoji: '🧑🏽‍🦽‍➡️' },
            { code: '1F9D1 1F3FE 200D 1F9BD 200D 27A1 FE0F', emoji: '🧑🏾‍🦽‍➡️' },
            { code: '1F9D1 1F3FF 200D 1F9BD 200D 27A1 FE0F', emoji: '🧑🏿‍🦽‍➡️' },
            { code: '1F468 200D 1F9BD', emoji: '👨‍🦽' },
            { code: '1F468 1F3FB 200D 1F9BD', emoji: '👨🏻‍🦽' },
            { code: '1F468 1F3FC 200D 1F9BD', emoji: '👨🏼‍🦽' },
            { code: '1F468 1F3FD 200D 1F9BD', emoji: '👨🏽‍🦽' },
            { code: '1F468 1F3FE 200D 1F9BD', emoji: '👨🏾‍🦽' },
            { code: '1F468 1F3FF 200D 1F9BD', emoji: '👨🏿‍🦽' },
            { code: '1F468 200D 1F9BD 200D 27A1 FE0F', emoji: '👨‍🦽‍➡️' },
            { code: '1F468 1F3FB 200D 1F9BD 200D 27A1 FE0F', emoji: '👨🏻‍🦽‍➡️' },
            { code: '1F468 1F3FC 200D 1F9BD 200D 27A1 FE0F', emoji: '👨🏼‍🦽‍➡️' },
            { code: '1F468 1F3FD 200D 1F9BD 200D 27A1 FE0F', emoji: '👨🏽‍🦽‍➡️' },
            { code: '1F468 1F3FE 200D 1F9BD 200D 27A1 FE0F', emoji: '👨🏾‍🦽‍➡️' },
            { code: '1F468 1F3FF 200D 1F9BD 200D 27A1 FE0F', emoji: '👨🏿‍🦽‍➡️' },
            { code: '1F469 200D 1F9BD', emoji: '👩‍🦽' },
            { code: '1F469 1F3FB 200D 1F9BD', emoji: '👩🏻‍🦽' },
            { code: '1F469 1F3FC 200D 1F9BD', emoji: '👩🏼‍🦽' },
            { code: '1F469 1F3FD 200D 1F9BD', emoji: '👩🏽‍🦽' },
            { code: '1F469 1F3FE 200D 1F9BD', emoji: '👩🏾‍🦽' },
            { code: '1F469 1F3FF 200D 1F9BD', emoji: '👩🏿‍🦽' },
            { code: '1F469 200D 1F9BD 200D 27A1 FE0F', emoji: '👩‍🦽‍➡️' },
            { code: '1F469 1F3FB 200D 1F9BD 200D 27A1 FE0F', emoji: '👩🏻‍🦽‍➡️' },
            { code: '1F469 1F3FC 200D 1F9BD 200D 27A1 FE0F', emoji: '👩🏼‍🦽‍➡️' },
            { code: '1F469 1F3FD 200D 1F9BD 200D 27A1 FE0F', emoji: '👩🏽‍🦽‍➡️' },
            { code: '1F469 1F3FE 200D 1F9BD 200D 27A1 FE0F', emoji: '👩🏾‍🦽‍➡️' },
            { code: '1F469 1F3FF 200D 1F9BD 200D 27A1 FE0F', emoji: '👩🏿‍🦽‍➡️' },
            { code: '1F3C3', emoji: '🏃' },
            { code: '1F3C3 1F3FB', emoji: '🏃🏻' },
            { code: '1F3C3 1F3FC', emoji: '🏃🏼' },
            { code: '1F3C3 1F3FD', emoji: '🏃🏽' },
            { code: '1F3C3 1F3FE', emoji: '🏃🏾' },
            { code: '1F3C3 1F3FF', emoji: '🏃🏿' },
            { code: '1F3C3 200D 2642 FE0F', emoji: '🏃‍♂️' },
            { code: '1F3C3 1F3FB 200D 2642 FE0F', emoji: '🏃🏻‍♂️' },
            { code: '1F3C3 1F3FC 200D 2642 FE0F', emoji: '🏃🏼‍♂️' },
            { code: '1F3C3 1F3FD 200D 2642 FE0F', emoji: '🏃🏽‍♂️' },
            { code: '1F3C3 1F3FE 200D 2642 FE0F', emoji: '🏃🏾‍♂️' },
            { code: '1F3C3 1F3FF 200D 2642 FE0F', emoji: '🏃🏿‍♂️' },
            { code: '1F3C3 200D 2640 FE0F', emoji: '🏃‍♀️' },
            { code: '1F3C3 1F3FB 200D 2640 FE0F', emoji: '🏃🏻‍♀️' },
            { code: '1F3C3 1F3FC 200D 2640 FE0F', emoji: '🏃🏼‍♀️' },
            { code: '1F3C3 1F3FD 200D 2640 FE0F', emoji: '🏃🏽‍♀️' },
            { code: '1F3C3 1F3FE 200D 2640 FE0F', emoji: '🏃🏾‍♀️' },
            { code: '1F3C3 1F3FF 200D 2640 FE0F', emoji: '🏃🏿‍♀️' },
            { code: '1F3C3 200D 27A1 FE0F', emoji: '🏃‍➡️' },
            { code: '1F3C3 1F3FB 200D 27A1 FE0F', emoji: '🏃🏻‍➡️' },
            { code: '1F3C3 1F3FC 200D 27A1 FE0F', emoji: '🏃🏼‍➡️' },
            { code: '1F3C3 1F3FD 200D 27A1 FE0F', emoji: '🏃🏽‍➡️' },
            { code: '1F3C3 1F3FE 200D 27A1 FE0F', emoji: '🏃🏾‍➡️' },
            { code: '1F3C3 1F3FF 200D 27A1 FE0F', emoji: '🏃🏿‍➡️' },
            { code: '1F3C3 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🏃‍♀️‍➡️' },
            { code: '1F3C3 1F3FB 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🏃🏻‍♀️‍➡️' },
            { code: '1F3C3 1F3FC 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🏃🏼‍♀️‍➡️' },
            { code: '1F3C3 1F3FD 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🏃🏽‍♀️‍➡️' },
            { code: '1F3C3 1F3FE 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🏃🏾‍♀️‍➡️' },
            { code: '1F3C3 1F3FF 200D 2640 FE0F 200D 27A1 FE0F', emoji: '🏃🏿‍♀️‍➡️' },
            { code: '1F3C3 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🏃‍♂️‍➡️' },
            { code: '1F3C3 1F3FB 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🏃🏻‍♂️‍➡️' },
            { code: '1F3C3 1F3FC 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🏃🏼‍♂️‍➡️' },
            { code: '1F3C3 1F3FD 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🏃🏽‍♂️‍➡️' },
            { code: '1F3C3 1F3FE 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🏃🏾‍♂️‍➡️' },
            { code: '1F3C3 1F3FF 200D 2642 FE0F 200D 27A1 FE0F', emoji: '🏃🏿‍♂️‍➡️' },
            { code: '1F483', emoji: '💃' },
            { code: '1F483 1F3FB', emoji: '💃🏻' },
            { code: '1F483 1F3FC', emoji: '💃🏼' },
            { code: '1F483 1F3FD', emoji: '💃🏽' },
            { code: '1F483 1F3FE', emoji: '💃🏾' },
            { code: '1F483 1F3FF', emoji: '💃🏿' },
            { code: '1F57A', emoji: '🕺' },
            { code: '1F57A 1F3FB', emoji: '🕺🏻' },
            { code: '1F57A 1F3FC', emoji: '🕺🏼' },
            { code: '1F57A 1F3FD', emoji: '🕺🏽' },
            { code: '1F57A 1F3FE', emoji: '🕺🏾' },
            { code: '1F57A 1F3FF', emoji: '🕺🏿' },
            { code: '1F574 FE0F', emoji: '🕴️' },
            { code: '1F574 1F3FB', emoji: '🕴🏻' },
            { code: '1F574 1F3FC', emoji: '🕴🏼' },
            { code: '1F574 1F3FD', emoji: '🕴🏽' },
            { code: '1F574 1F3FE', emoji: '🕴🏾' },
            { code: '1F574 1F3FF', emoji: '🕴🏿' },
            { code: '1F46F', emoji: '👯' },
            { code: '1F46F 200D 2642 FE0F', emoji: '👯‍♂️' },
            { code: '1F46F 200D 2640 FE0F', emoji: '👯‍♀️' },
            { code: '1F9D6', emoji: '🧖' },
            { code: '1F9D6 1F3FB', emoji: '🧖🏻' },
            { code: '1F9D6 1F3FC', emoji: '🧖🏼' },
            { code: '1F9D6 1F3FD', emoji: '🧖🏽' },
            { code: '1F9D6 1F3FE', emoji: '🧖🏾' },
            { code: '1F9D6 1F3FF', emoji: '🧖🏿' },
            { code: '1F9D6 200D 2642 FE0F', emoji: '🧖‍♂️' },
            { code: '1F9D6 1F3FB 200D 2642 FE0F', emoji: '🧖🏻‍♂️' },
            { code: '1F9D6 1F3FC 200D 2642 FE0F', emoji: '🧖🏼‍♂️' },
            { code: '1F9D6 1F3FD 200D 2642 FE0F', emoji: '🧖🏽‍♂️' },
            { code: '1F9D6 1F3FE 200D 2642 FE0F', emoji: '🧖🏾‍♂️' },
            { code: '1F9D6 1F3FF 200D 2642 FE0F', emoji: '🧖🏿‍♂️' },
            { code: '1F9D6 200D 2640 FE0F', emoji: '🧖‍♀️' },
            { code: '1F9D6 1F3FB 200D 2640 FE0F', emoji: '🧖🏻‍♀️' },
            { code: '1F9D6 1F3FC 200D 2640 FE0F', emoji: '🧖🏼‍♀️' },
            { code: '1F9D6 1F3FD 200D 2640 FE0F', emoji: '🧖🏽‍♀️' },
            { code: '1F9D6 1F3FE 200D 2640 FE0F', emoji: '🧖🏾‍♀️' },
            { code: '1F9D6 1F3FF 200D 2640 FE0F', emoji: '🧖🏿‍♀️' },
            { code: '1F9D7', emoji: '🧗' },
            { code: '1F9D7 1F3FB', emoji: '🧗🏻' },
            { code: '1F9D7 1F3FC', emoji: '🧗🏼' },
            { code: '1F9D7 1F3FD', emoji: '🧗🏽' },
            { code: '1F9D7 1F3FE', emoji: '🧗🏾' },
            { code: '1F9D7 1F3FF', emoji: '🧗🏿' },
            { code: '1F9D7 200D 2642 FE0F', emoji: '🧗‍♂️' },
            { code: '1F9D7 1F3FB 200D 2642 FE0F', emoji: '🧗🏻‍♂️' },
            { code: '1F9D7 1F3FC 200D 2642 FE0F', emoji: '🧗🏼‍♂️' },
            { code: '1F9D7 1F3FD 200D 2642 FE0F', emoji: '🧗🏽‍♂️' },
            { code: '1F9D7 1F3FE 200D 2642 FE0F', emoji: '🧗🏾‍♂️' },
            { code: '1F9D7 1F3FF 200D 2642 FE0F', emoji: '🧗🏿‍♂️' },
            { code: '1F9D7 200D 2640 FE0F', emoji: '🧗‍♀️' },
            { code: '1F9D7 1F3FB 200D 2640 FE0F', emoji: '🧗🏻‍♀️' },
            { code: '1F9D7 1F3FC 200D 2640 FE0F', emoji: '🧗🏼‍♀️' },
            { code: '1F9D7 1F3FD 200D 2640 FE0F', emoji: '🧗🏽‍♀️' },
            { code: '1F9D7 1F3FE 200D 2640 FE0F', emoji: '🧗🏾‍♀️' },
            { code: '1F9D7 1F3FF 200D 2640 FE0F', emoji: '🧗🏿‍♀️' },
        ],
        'person-sport': [
            { code: '1F93A', emoji: '🤺' },
            { code: '1F3C7', emoji: '🏇' },
            { code: '1F3C7 1F3FB', emoji: '🏇🏻' },
            { code: '1F3C7 1F3FC', emoji: '🏇🏼' },
            { code: '1F3C7 1F3FD', emoji: '🏇🏽' },
            { code: '1F3C7 1F3FE', emoji: '🏇🏾' },
            { code: '1F3C7 1F3FF', emoji: '🏇🏿' },
            { code: '26F7 FE0F', emoji: '⛷️' },
            { code: '1F3C2', emoji: '🏂' },
            { code: '1F3C2 1F3FB', emoji: '🏂🏻' },
            { code: '1F3C2 1F3FC', emoji: '🏂🏼' },
            { code: '1F3C2 1F3FD', emoji: '🏂🏽' },
            { code: '1F3C2 1F3FE', emoji: '🏂🏾' },
            { code: '1F3C2 1F3FF', emoji: '🏂🏿' },
            { code: '1F3CC FE0F', emoji: '🏌️' },
            { code: '1F3CC 1F3FB', emoji: '🏌🏻' },
            { code: '1F3CC 1F3FC', emoji: '🏌🏼' },
            { code: '1F3CC 1F3FD', emoji: '🏌🏽' },
            { code: '1F3CC 1F3FE', emoji: '🏌🏾' },
            { code: '1F3CC 1F3FF', emoji: '🏌🏿' },
            { code: '1F3CC FE0F 200D 2642 FE0F', emoji: '🏌️‍♂️' },
            { code: '1F3CC 1F3FB 200D 2642 FE0F', emoji: '🏌🏻‍♂️' },
            { code: '1F3CC 1F3FC 200D 2642 FE0F', emoji: '🏌🏼‍♂️' },
            { code: '1F3CC 1F3FD 200D 2642 FE0F', emoji: '🏌🏽‍♂️' },
            { code: '1F3CC 1F3FE 200D 2642 FE0F', emoji: '🏌🏾‍♂️' },
            { code: '1F3CC 1F3FF 200D 2642 FE0F', emoji: '🏌🏿‍♂️' },
            { code: '1F3CC FE0F 200D 2640 FE0F', emoji: '🏌️‍♀️' },
            { code: '1F3CC 1F3FB 200D 2640 FE0F', emoji: '🏌🏻‍♀️' },
            { code: '1F3CC 1F3FC 200D 2640 FE0F', emoji: '🏌🏼‍♀️' },
            { code: '1F3CC 1F3FD 200D 2640 FE0F', emoji: '🏌🏽‍♀️' },
            { code: '1F3CC 1F3FE 200D 2640 FE0F', emoji: '🏌🏾‍♀️' },
            { code: '1F3CC 1F3FF 200D 2640 FE0F', emoji: '🏌🏿‍♀️' },
            { code: '1F3C4', emoji: '🏄' },
            { code: '1F3C4 1F3FB', emoji: '🏄🏻' },
            { code: '1F3C4 1F3FC', emoji: '🏄🏼' },
            { code: '1F3C4 1F3FD', emoji: '🏄🏽' },
            { code: '1F3C4 1F3FE', emoji: '🏄🏾' },
            { code: '1F3C4 1F3FF', emoji: '🏄🏿' },
            { code: '1F3C4 200D 2642 FE0F', emoji: '🏄‍♂️' },
            { code: '1F3C4 1F3FB 200D 2642 FE0F', emoji: '🏄🏻‍♂️' },
            { code: '1F3C4 1F3FC 200D 2642 FE0F', emoji: '🏄🏼‍♂️' },
            { code: '1F3C4 1F3FD 200D 2642 FE0F', emoji: '🏄🏽‍♂️' },
            { code: '1F3C4 1F3FE 200D 2642 FE0F', emoji: '🏄🏾‍♂️' },
            { code: '1F3C4 1F3FF 200D 2642 FE0F', emoji: '🏄🏿‍♂️' },
            { code: '1F3C4 200D 2640 FE0F', emoji: '🏄‍♀️' },
            { code: '1F3C4 1F3FB 200D 2640 FE0F', emoji: '🏄🏻‍♀️' },
            { code: '1F3C4 1F3FC 200D 2640 FE0F', emoji: '🏄🏼‍♀️' },
            { code: '1F3C4 1F3FD 200D 2640 FE0F', emoji: '🏄🏽‍♀️' },
            { code: '1F3C4 1F3FE 200D 2640 FE0F', emoji: '🏄🏾‍♀️' },
            { code: '1F3C4 1F3FF 200D 2640 FE0F', emoji: '🏄🏿‍♀️' },
            { code: '1F6A3', emoji: '🚣' },
            { code: '1F6A3 1F3FB', emoji: '🚣🏻' },
            { code: '1F6A3 1F3FC', emoji: '🚣🏼' },
            { code: '1F6A3 1F3FD', emoji: '🚣🏽' },
            { code: '1F6A3 1F3FE', emoji: '🚣🏾' },
            { code: '1F6A3 1F3FF', emoji: '🚣🏿' },
            { code: '1F6A3 200D 2642 FE0F', emoji: '🚣‍♂️' },
            { code: '1F6A3 1F3FB 200D 2642 FE0F', emoji: '🚣🏻‍♂️' },
            { code: '1F6A3 1F3FC 200D 2642 FE0F', emoji: '🚣🏼‍♂️' },
            { code: '1F6A3 1F3FD 200D 2642 FE0F', emoji: '🚣🏽‍♂️' },
            { code: '1F6A3 1F3FE 200D 2642 FE0F', emoji: '🚣🏾‍♂️' },
            { code: '1F6A3 1F3FF 200D 2642 FE0F', emoji: '🚣🏿‍♂️' },
            { code: '1F6A3 200D 2640 FE0F', emoji: '🚣‍♀️' },
            { code: '1F6A3 1F3FB 200D 2640 FE0F', emoji: '🚣🏻‍♀️' },
            { code: '1F6A3 1F3FC 200D 2640 FE0F', emoji: '🚣🏼‍♀️' },
            { code: '1F6A3 1F3FD 200D 2640 FE0F', emoji: '🚣🏽‍♀️' },
            { code: '1F6A3 1F3FE 200D 2640 FE0F', emoji: '🚣🏾‍♀️' },
            { code: '1F6A3 1F3FF 200D 2640 FE0F', emoji: '🚣🏿‍♀️' },
            { code: '1F3CA', emoji: '🏊' },
            { code: '1F3CA 1F3FB', emoji: '🏊🏻' },
            { code: '1F3CA 1F3FC', emoji: '🏊🏼' },
            { code: '1F3CA 1F3FD', emoji: '🏊🏽' },
            { code: '1F3CA 1F3FE', emoji: '🏊🏾' },
            { code: '1F3CA 1F3FF', emoji: '🏊🏿' },
            { code: '1F3CA 200D 2642 FE0F', emoji: '🏊‍♂️' },
            { code: '1F3CA 1F3FB 200D 2642 FE0F', emoji: '🏊🏻‍♂️' },
            { code: '1F3CA 1F3FC 200D 2642 FE0F', emoji: '🏊🏼‍♂️' },
            { code: '1F3CA 1F3FD 200D 2642 FE0F', emoji: '🏊🏽‍♂️' },
            { code: '1F3CA 1F3FE 200D 2642 FE0F', emoji: '🏊🏾‍♂️' },
            { code: '1F3CA 1F3FF 200D 2642 FE0F', emoji: '🏊🏿‍♂️' },
            { code: '1F3CA 200D 2640 FE0F', emoji: '🏊‍♀️' },
            { code: '1F3CA 1F3FB 200D 2640 FE0F', emoji: '🏊🏻‍♀️' },
            { code: '1F3CA 1F3FC 200D 2640 FE0F', emoji: '🏊🏼‍♀️' },
            { code: '1F3CA 1F3FD 200D 2640 FE0F', emoji: '🏊🏽‍♀️' },
            { code: '1F3CA 1F3FE 200D 2640 FE0F', emoji: '🏊🏾‍♀️' },
            { code: '1F3CA 1F3FF 200D 2640 FE0F', emoji: '🏊🏿‍♀️' },
            { code: '26F9 FE0F', emoji: '⛹️' },
            { code: '26F9 1F3FB', emoji: '⛹🏻' },
            { code: '26F9 1F3FC', emoji: '⛹🏼' },
            { code: '26F9 1F3FD', emoji: '⛹🏽' },
            { code: '26F9 1F3FE', emoji: '⛹🏾' },
            { code: '26F9 1F3FF', emoji: '⛹🏿' },
            { code: '26F9 FE0F 200D 2642 FE0F', emoji: '⛹️‍♂️' },
            { code: '26F9 1F3FB 200D 2642 FE0F', emoji: '⛹🏻‍♂️' },
            { code: '26F9 1F3FC 200D 2642 FE0F', emoji: '⛹🏼‍♂️' },
            { code: '26F9 1F3FD 200D 2642 FE0F', emoji: '⛹🏽‍♂️' },
            { code: '26F9 1F3FE 200D 2642 FE0F', emoji: '⛹🏾‍♂️' },
            { code: '26F9 1F3FF 200D 2642 FE0F', emoji: '⛹🏿‍♂️' },
            { code: '26F9 FE0F 200D 2640 FE0F', emoji: '⛹️‍♀️' },
            { code: '26F9 1F3FB 200D 2640 FE0F', emoji: '⛹🏻‍♀️' },
            { code: '26F9 1F3FC 200D 2640 FE0F', emoji: '⛹🏼‍♀️' },
            { code: '26F9 1F3FD 200D 2640 FE0F', emoji: '⛹🏽‍♀️' },
            { code: '26F9 1F3FE 200D 2640 FE0F', emoji: '⛹🏾‍♀️' },
            { code: '26F9 1F3FF 200D 2640 FE0F', emoji: '⛹🏿‍♀️' },
            { code: '1F3CB FE0F', emoji: '🏋️' },
            { code: '1F3CB 1F3FB', emoji: '🏋🏻' },
            { code: '1F3CB 1F3FC', emoji: '🏋🏼' },
            { code: '1F3CB 1F3FD', emoji: '🏋🏽' },
            { code: '1F3CB 1F3FE', emoji: '🏋🏾' },
            { code: '1F3CB 1F3FF', emoji: '🏋🏿' },
            { code: '1F3CB FE0F 200D 2642 FE0F', emoji: '🏋️‍♂️' },
            { code: '1F3CB 1F3FB 200D 2642 FE0F', emoji: '🏋🏻‍♂️' },
            { code: '1F3CB 1F3FC 200D 2642 FE0F', emoji: '🏋🏼‍♂️' },
            { code: '1F3CB 1F3FD 200D 2642 FE0F', emoji: '🏋🏽‍♂️' },
            { code: '1F3CB 1F3FE 200D 2642 FE0F', emoji: '🏋🏾‍♂️' },
            { code: '1F3CB 1F3FF 200D 2642 FE0F', emoji: '🏋🏿‍♂️' },
            { code: '1F3CB FE0F 200D 2640 FE0F', emoji: '🏋️‍♀️' },
            { code: '1F3CB 1F3FB 200D 2640 FE0F', emoji: '🏋🏻‍♀️' },
            { code: '1F3CB 1F3FC 200D 2640 FE0F', emoji: '🏋🏼‍♀️' },
            { code: '1F3CB 1F3FD 200D 2640 FE0F', emoji: '🏋🏽‍♀️' },
            { code: '1F3CB 1F3FE 200D 2640 FE0F', emoji: '🏋🏾‍♀️' },
            { code: '1F3CB 1F3FF 200D 2640 FE0F', emoji: '🏋🏿‍♀️' },
            { code: '1F6B4', emoji: '🚴' },
            { code: '1F6B4 1F3FB', emoji: '🚴🏻' },
            { code: '1F6B4 1F3FC', emoji: '🚴🏼' },
            { code: '1F6B4 1F3FD', emoji: '🚴🏽' },
            { code: '1F6B4 1F3FE', emoji: '🚴🏾' },
            { code: '1F6B4 1F3FF', emoji: '🚴🏿' },
            { code: '1F6B4 200D 2642 FE0F', emoji: '🚴‍♂️' },
            { code: '1F6B4 1F3FB 200D 2642 FE0F', emoji: '🚴🏻‍♂️' },
            { code: '1F6B4 1F3FC 200D 2642 FE0F', emoji: '🚴🏼‍♂️' },
            { code: '1F6B4 1F3FD 200D 2642 FE0F', emoji: '🚴🏽‍♂️' },
            { code: '1F6B4 1F3FE 200D 2642 FE0F', emoji: '🚴🏾‍♂️' },
            { code: '1F6B4 1F3FF 200D 2642 FE0F', emoji: '🚴🏿‍♂️' },
            { code: '1F6B4 200D 2640 FE0F', emoji: '🚴‍♀️' },
            { code: '1F6B4 1F3FB 200D 2640 FE0F', emoji: '🚴🏻‍♀️' },
            { code: '1F6B4 1F3FC 200D 2640 FE0F', emoji: '🚴🏼‍♀️' },
            { code: '1F6B4 1F3FD 200D 2640 FE0F', emoji: '🚴🏽‍♀️' },
            { code: '1F6B4 1F3FE 200D 2640 FE0F', emoji: '🚴🏾‍♀️' },
            { code: '1F6B4 1F3FF 200D 2640 FE0F', emoji: '🚴🏿‍♀️' },
            { code: '1F6B5', emoji: '🚵' },
            { code: '1F6B5 1F3FB', emoji: '🚵🏻' },
            { code: '1F6B5 1F3FC', emoji: '🚵🏼' },
            { code: '1F6B5 1F3FD', emoji: '🚵🏽' },
            { code: '1F6B5 1F3FE', emoji: '🚵🏾' },
            { code: '1F6B5 1F3FF', emoji: '🚵🏿' },
            { code: '1F6B5 200D 2642 FE0F', emoji: '🚵‍♂️' },
            { code: '1F6B5 1F3FB 200D 2642 FE0F', emoji: '🚵🏻‍♂️' },
            { code: '1F6B5 1F3FC 200D 2642 FE0F', emoji: '🚵🏼‍♂️' },
            { code: '1F6B5 1F3FD 200D 2642 FE0F', emoji: '🚵🏽‍♂️' },
            { code: '1F6B5 1F3FE 200D 2642 FE0F', emoji: '🚵🏾‍♂️' },
            { code: '1F6B5 1F3FF 200D 2642 FE0F', emoji: '🚵🏿‍♂️' },
            { code: '1F6B5 200D 2640 FE0F', emoji: '🚵‍♀️' },
            { code: '1F6B5 1F3FB 200D 2640 FE0F', emoji: '🚵🏻‍♀️' },
            { code: '1F6B5 1F3FC 200D 2640 FE0F', emoji: '🚵🏼‍♀️' },
            { code: '1F6B5 1F3FD 200D 2640 FE0F', emoji: '🚵🏽‍♀️' },
            { code: '1F6B5 1F3FE 200D 2640 FE0F', emoji: '🚵🏾‍♀️' },
            { code: '1F6B5 1F3FF 200D 2640 FE0F', emoji: '🚵🏿‍♀️' },
            { code: '1F938', emoji: '🤸' },
            { code: '1F938 1F3FB', emoji: '🤸🏻' },
            { code: '1F938 1F3FC', emoji: '🤸🏼' },
            { code: '1F938 1F3FD', emoji: '🤸🏽' },
            { code: '1F938 1F3FE', emoji: '🤸🏾' },
            { code: '1F938 1F3FF', emoji: '🤸🏿' },
            { code: '1F938 200D 2642 FE0F', emoji: '🤸‍♂️' },
            { code: '1F938 1F3FB 200D 2642 FE0F', emoji: '🤸🏻‍♂️' },
            { code: '1F938 1F3FC 200D 2642 FE0F', emoji: '🤸🏼‍♂️' },
            { code: '1F938 1F3FD 200D 2642 FE0F', emoji: '🤸🏽‍♂️' },
            { code: '1F938 1F3FE 200D 2642 FE0F', emoji: '🤸🏾‍♂️' },
            { code: '1F938 1F3FF 200D 2642 FE0F', emoji: '🤸🏿‍♂️' },
            { code: '1F938 200D 2640 FE0F', emoji: '🤸‍♀️' },
            { code: '1F938 1F3FB 200D 2640 FE0F', emoji: '🤸🏻‍♀️' },
            { code: '1F938 1F3FC 200D 2640 FE0F', emoji: '🤸🏼‍♀️' },
            { code: '1F938 1F3FD 200D 2640 FE0F', emoji: '🤸🏽‍♀️' },
            { code: '1F938 1F3FE 200D 2640 FE0F', emoji: '🤸🏾‍♀️' },
            { code: '1F938 1F3FF 200D 2640 FE0F', emoji: '🤸🏿‍♀️' },
            { code: '1F93C', emoji: '🤼' },
            { code: '1F93C 200D 2642 FE0F', emoji: '🤼‍♂️' },
            { code: '1F93C 200D 2640 FE0F', emoji: '🤼‍♀️' },
            { code: '1F93D', emoji: '🤽' },
            { code: '1F93D 1F3FB', emoji: '🤽🏻' },
            { code: '1F93D 1F3FC', emoji: '🤽🏼' },
            { code: '1F93D 1F3FD', emoji: '🤽🏽' },
            { code: '1F93D 1F3FE', emoji: '🤽🏾' },
            { code: '1F93D 1F3FF', emoji: '🤽🏿' },
            { code: '1F93D 200D 2642 FE0F', emoji: '🤽‍♂️' },
            { code: '1F93D 1F3FB 200D 2642 FE0F', emoji: '🤽🏻‍♂️' },
            { code: '1F93D 1F3FC 200D 2642 FE0F', emoji: '🤽🏼‍♂️' },
            { code: '1F93D 1F3FD 200D 2642 FE0F', emoji: '🤽🏽‍♂️' },
            { code: '1F93D 1F3FE 200D 2642 FE0F', emoji: '🤽🏾‍♂️' },
            { code: '1F93D 1F3FF 200D 2642 FE0F', emoji: '🤽🏿‍♂️' },
            { code: '1F93D 200D 2640 FE0F', emoji: '🤽‍♀️' },
            { code: '1F93D 1F3FB 200D 2640 FE0F', emoji: '🤽🏻‍♀️' },
            { code: '1F93D 1F3FC 200D 2640 FE0F', emoji: '🤽🏼‍♀️' },
            { code: '1F93D 1F3FD 200D 2640 FE0F', emoji: '🤽🏽‍♀️' },
            { code: '1F93D 1F3FE 200D 2640 FE0F', emoji: '🤽🏾‍♀️' },
            { code: '1F93D 1F3FF 200D 2640 FE0F', emoji: '🤽🏿‍♀️' },
            { code: '1F93E', emoji: '🤾' },
            { code: '1F93E 1F3FB', emoji: '🤾🏻' },
            { code: '1F93E 1F3FC', emoji: '🤾🏼' },
            { code: '1F93E 1F3FD', emoji: '🤾🏽' },
            { code: '1F93E 1F3FE', emoji: '🤾🏾' },
            { code: '1F93E 1F3FF', emoji: '🤾🏿' },
            { code: '1F93E 200D 2642 FE0F', emoji: '🤾‍♂️' },
            { code: '1F93E 1F3FB 200D 2642 FE0F', emoji: '🤾🏻‍♂️' },
            { code: '1F93E 1F3FC 200D 2642 FE0F', emoji: '🤾🏼‍♂️' },
            { code: '1F93E 1F3FD 200D 2642 FE0F', emoji: '🤾🏽‍♂️' },
            { code: '1F93E 1F3FE 200D 2642 FE0F', emoji: '🤾🏾‍♂️' },
            { code: '1F93E 1F3FF 200D 2642 FE0F', emoji: '🤾🏿‍♂️' },
            { code: '1F93E 200D 2640 FE0F', emoji: '🤾‍♀️' },
            { code: '1F93E 1F3FB 200D 2640 FE0F', emoji: '🤾🏻‍♀️' },
            { code: '1F93E 1F3FC 200D 2640 FE0F', emoji: '🤾🏼‍♀️' },
            { code: '1F93E 1F3FD 200D 2640 FE0F', emoji: '🤾🏽‍♀️' },
            { code: '1F93E 1F3FE 200D 2640 FE0F', emoji: '🤾🏾‍♀️' },
            { code: '1F93E 1F3FF 200D 2640 FE0F', emoji: '🤾🏿‍♀️' },
            { code: '1F939', emoji: '🤹' },
            { code: '1F939 1F3FB', emoji: '🤹🏻' },
            { code: '1F939 1F3FC', emoji: '🤹🏼' },
            { code: '1F939 1F3FD', emoji: '🤹🏽' },
            { code: '1F939 1F3FE', emoji: '🤹🏾' },
            { code: '1F939 1F3FF', emoji: '🤹🏿' },
            { code: '1F939 200D 2642 FE0F', emoji: '🤹‍♂️' },
            { code: '1F939 1F3FB 200D 2642 FE0F', emoji: '🤹🏻‍♂️' },
            { code: '1F939 1F3FC 200D 2642 FE0F', emoji: '🤹🏼‍♂️' },
            { code: '1F939 1F3FD 200D 2642 FE0F', emoji: '🤹🏽‍♂️' },
            { code: '1F939 1F3FE 200D 2642 FE0F', emoji: '🤹🏾‍♂️' },
            { code: '1F939 1F3FF 200D 2642 FE0F', emoji: '🤹🏿‍♂️' },
            { code: '1F939 200D 2640 FE0F', emoji: '🤹‍♀️' },
            { code: '1F939 1F3FB 200D 2640 FE0F', emoji: '🤹🏻‍♀️' },
            { code: '1F939 1F3FC 200D 2640 FE0F', emoji: '🤹🏼‍♀️' },
            { code: '1F939 1F3FD 200D 2640 FE0F', emoji: '🤹🏽‍♀️' },
            { code: '1F939 1F3FE 200D 2640 FE0F', emoji: '🤹🏾‍♀️' },
            { code: '1F939 1F3FF 200D 2640 FE0F', emoji: '🤹🏿‍♀️' },
        ],
        'person-resting': [
            { code: '1F9D8', emoji: '🧘' },
            { code: '1F9D8 1F3FB', emoji: '🧘🏻' },
            { code: '1F9D8 1F3FC', emoji: '🧘🏼' },
            { code: '1F9D8 1F3FD', emoji: '🧘🏽' },
            { code: '1F9D8 1F3FE', emoji: '🧘🏾' },
            { code: '1F9D8 1F3FF', emoji: '🧘🏿' },
            { code: '1F9D8 200D 2642 FE0F', emoji: '🧘‍♂️' },
            { code: '1F9D8 1F3FB 200D 2642 FE0F', emoji: '🧘🏻‍♂️' },
            { code: '1F9D8 1F3FC 200D 2642 FE0F', emoji: '🧘🏼‍♂️' },
            { code: '1F9D8 1F3FD 200D 2642 FE0F', emoji: '🧘🏽‍♂️' },
            { code: '1F9D8 1F3FE 200D 2642 FE0F', emoji: '🧘🏾‍♂️' },
            { code: '1F9D8 1F3FF 200D 2642 FE0F', emoji: '🧘🏿‍♂️' },
            { code: '1F9D8 200D 2640 FE0F', emoji: '🧘‍♀️' },
            { code: '1F9D8 1F3FB 200D 2640 FE0F', emoji: '🧘🏻‍♀️' },
            { code: '1F9D8 1F3FC 200D 2640 FE0F', emoji: '🧘🏼‍♀️' },
            { code: '1F9D8 1F3FD 200D 2640 FE0F', emoji: '🧘🏽‍♀️' },
            { code: '1F9D8 1F3FE 200D 2640 FE0F', emoji: '🧘🏾‍♀️' },
            { code: '1F9D8 1F3FF 200D 2640 FE0F', emoji: '🧘🏿‍♀️' },
            { code: '1F6C0', emoji: '🛀' },
            { code: '1F6C0 1F3FB', emoji: '🛀🏻' },
            { code: '1F6C0 1F3FC', emoji: '🛀🏼' },
            { code: '1F6C0 1F3FD', emoji: '🛀🏽' },
            { code: '1F6C0 1F3FE', emoji: '🛀🏾' },
            { code: '1F6C0 1F3FF', emoji: '🛀🏿' },
            { code: '1F6CC', emoji: '🛌' },
            { code: '1F6CC 1F3FB', emoji: '🛌🏻' },
            { code: '1F6CC 1F3FC', emoji: '🛌🏼' },
            { code: '1F6CC 1F3FD', emoji: '🛌🏽' },
            { code: '1F6CC 1F3FE', emoji: '🛌🏾' },
            { code: '1F6CC 1F3FF', emoji: '🛌🏿' },
        ],
        'family': [
            { code: '1F9D1 200D 1F91D 200D 1F9D1', emoji: '🧑‍🤝‍🧑' },
            { code: '1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FB', emoji: '🧑🏻‍🤝‍🧑🏻' },
            { code: '1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FC', emoji: '🧑🏻‍🤝‍🧑🏼' },
            { code: '1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FD', emoji: '🧑🏻‍🤝‍🧑🏽' },
            { code: '1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FE', emoji: '🧑🏻‍🤝‍🧑🏾' },
            { code: '1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FF', emoji: '🧑🏻‍🤝‍🧑🏿' },
            { code: '1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FB', emoji: '🧑🏼‍🤝‍🧑🏻' },
            { code: '1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FC', emoji: '🧑🏼‍🤝‍🧑🏼' },
            { code: '1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FD', emoji: '🧑🏼‍🤝‍🧑🏽' },
            { code: '1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FE', emoji: '🧑🏼‍🤝‍🧑🏾' },
            { code: '1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FF', emoji: '🧑🏼‍🤝‍🧑🏿' },
            { code: '1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FB', emoji: '🧑🏽‍🤝‍🧑🏻' },
            { code: '1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FC', emoji: '🧑🏽‍🤝‍🧑🏼' },
            { code: '1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FD', emoji: '🧑🏽‍🤝‍🧑🏽' },
            { code: '1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FE', emoji: '🧑🏽‍🤝‍🧑🏾' },
            { code: '1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FF', emoji: '🧑🏽‍🤝‍🧑🏿' },
            { code: '1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FB', emoji: '🧑🏾‍🤝‍🧑🏻' },
            { code: '1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FC', emoji: '🧑🏾‍🤝‍🧑🏼' },
            { code: '1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FD', emoji: '🧑🏾‍🤝‍🧑🏽' },
            { code: '1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FE', emoji: '🧑🏾‍🤝‍🧑🏾' },
            { code: '1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FF', emoji: '🧑🏾‍🤝‍🧑🏿' },
            { code: '1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FB', emoji: '🧑🏿‍🤝‍🧑🏻' },
            { code: '1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FC', emoji: '🧑🏿‍🤝‍🧑🏼' },
            { code: '1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FD', emoji: '🧑🏿‍🤝‍🧑🏽' },
            { code: '1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FE', emoji: '🧑🏿‍🤝‍🧑🏾' },
            { code: '1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FF', emoji: '🧑🏿‍🤝‍🧑🏿' },
            { code: '1F46D', emoji: '👭' },
            { code: '1F46D 1F3FB', emoji: '👭🏻' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F469 1F3FC', emoji: '👩🏻‍🤝‍👩🏼' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F469 1F3FD', emoji: '👩🏻‍🤝‍👩🏽' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F469 1F3FE', emoji: '👩🏻‍🤝‍👩🏾' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F469 1F3FF', emoji: '👩🏻‍🤝‍👩🏿' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F469 1F3FB', emoji: '👩🏼‍🤝‍👩🏻' },
            { code: '1F46D 1F3FC', emoji: '👭🏼' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F469 1F3FD', emoji: '👩🏼‍🤝‍👩🏽' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F469 1F3FE', emoji: '👩🏼‍🤝‍👩🏾' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F469 1F3FF', emoji: '👩🏼‍🤝‍👩🏿' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F469 1F3FB', emoji: '👩🏽‍🤝‍👩🏻' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F469 1F3FC', emoji: '👩🏽‍🤝‍👩🏼' },
            { code: '1F46D 1F3FD', emoji: '👭🏽' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F469 1F3FE', emoji: '👩🏽‍🤝‍👩🏾' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F469 1F3FF', emoji: '👩🏽‍🤝‍👩🏿' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F469 1F3FB', emoji: '👩🏾‍🤝‍👩🏻' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F469 1F3FC', emoji: '👩🏾‍🤝‍👩🏼' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F469 1F3FD', emoji: '👩🏾‍🤝‍👩🏽' },
            { code: '1F46D 1F3FE', emoji: '👭🏾' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F469 1F3FF', emoji: '👩🏾‍🤝‍👩🏿' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F469 1F3FB', emoji: '👩🏿‍🤝‍👩🏻' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F469 1F3FC', emoji: '👩🏿‍🤝‍👩🏼' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F469 1F3FD', emoji: '👩🏿‍🤝‍👩🏽' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F469 1F3FE', emoji: '👩🏿‍🤝‍👩🏾' },
            { code: '1F46D 1F3FF', emoji: '👭🏿' },
            { code: '1F46B', emoji: '👫' },
            { code: '1F46B 1F3FB', emoji: '👫🏻' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F468 1F3FC', emoji: '👩🏻‍🤝‍👨🏼' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F468 1F3FD', emoji: '👩🏻‍🤝‍👨🏽' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F468 1F3FE', emoji: '👩🏻‍🤝‍👨🏾' },
            { code: '1F469 1F3FB 200D 1F91D 200D 1F468 1F3FF', emoji: '👩🏻‍🤝‍👨🏿' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F468 1F3FB', emoji: '👩🏼‍🤝‍👨🏻' },
            { code: '1F46B 1F3FC', emoji: '👫🏼' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F468 1F3FD', emoji: '👩🏼‍🤝‍👨🏽' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F468 1F3FE', emoji: '👩🏼‍🤝‍👨🏾' },
            { code: '1F469 1F3FC 200D 1F91D 200D 1F468 1F3FF', emoji: '👩🏼‍🤝‍👨🏿' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F468 1F3FB', emoji: '👩🏽‍🤝‍👨🏻' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F468 1F3FC', emoji: '👩🏽‍🤝‍👨🏼' },
            { code: '1F46B 1F3FD', emoji: '👫🏽' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F468 1F3FE', emoji: '👩🏽‍🤝‍👨🏾' },
            { code: '1F469 1F3FD 200D 1F91D 200D 1F468 1F3FF', emoji: '👩🏽‍🤝‍👨🏿' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F468 1F3FB', emoji: '👩🏾‍🤝‍👨🏻' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F468 1F3FC', emoji: '👩🏾‍🤝‍👨🏼' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F468 1F3FD', emoji: '👩🏾‍🤝‍👨🏽' },
            { code: '1F46B 1F3FE', emoji: '👫🏾' },
            { code: '1F469 1F3FE 200D 1F91D 200D 1F468 1F3FF', emoji: '👩🏾‍🤝‍👨🏿' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F468 1F3FB', emoji: '👩🏿‍🤝‍👨🏻' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F468 1F3FC', emoji: '👩🏿‍🤝‍👨🏼' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F468 1F3FD', emoji: '👩🏿‍🤝‍👨🏽' },
            { code: '1F469 1F3FF 200D 1F91D 200D 1F468 1F3FE', emoji: '👩🏿‍🤝‍👨🏾' },
            { code: '1F46B 1F3FF', emoji: '👫🏿' },
            { code: '1F46C', emoji: '👬' },
            { code: '1F46C 1F3FB', emoji: '👬🏻' },
            { code: '1F468 1F3FB 200D 1F91D 200D 1F468 1F3FC', emoji: '👨🏻‍🤝‍👨🏼' },
            { code: '1F468 1F3FB 200D 1F91D 200D 1F468 1F3FD', emoji: '👨🏻‍🤝‍👨🏽' },
            { code: '1F468 1F3FB 200D 1F91D 200D 1F468 1F3FE', emoji: '👨🏻‍🤝‍👨🏾' },
            { code: '1F468 1F3FB 200D 1F91D 200D 1F468 1F3FF', emoji: '👨🏻‍🤝‍👨🏿' },
            { code: '1F468 1F3FC 200D 1F91D 200D 1F468 1F3FB', emoji: '👨🏼‍🤝‍👨🏻' },
            { code: '1F46C 1F3FC', emoji: '👬🏼' },
            { code: '1F468 1F3FC 200D 1F91D 200D 1F468 1F3FD', emoji: '👨🏼‍🤝‍👨🏽' },
            { code: '1F468 1F3FC 200D 1F91D 200D 1F468 1F3FE', emoji: '👨🏼‍🤝‍👨🏾' },
            { code: '1F468 1F3FC 200D 1F91D 200D 1F468 1F3FF', emoji: '👨🏼‍🤝‍👨🏿' },
            { code: '1F468 1F3FD 200D 1F91D 200D 1F468 1F3FB', emoji: '👨🏽‍🤝‍👨🏻' },
            { code: '1F468 1F3FD 200D 1F91D 200D 1F468 1F3FC', emoji: '👨🏽‍🤝‍👨🏼' },
            { code: '1F46C 1F3FD', emoji: '👬🏽' },
            { code: '1F468 1F3FD 200D 1F91D 200D 1F468 1F3FE', emoji: '👨🏽‍🤝‍👨🏾' },
            { code: '1F468 1F3FD 200D 1F91D 200D 1F468 1F3FF', emoji: '👨🏽‍🤝‍👨🏿' },
            { code: '1F468 1F3FE 200D 1F91D 200D 1F468 1F3FB', emoji: '👨🏾‍🤝‍👨🏻' },
            { code: '1F468 1F3FE 200D 1F91D 200D 1F468 1F3FC', emoji: '👨🏾‍🤝‍👨🏼' },
            { code: '1F468 1F3FE 200D 1F91D 200D 1F468 1F3FD', emoji: '👨🏾‍🤝‍👨🏽' },
            { code: '1F46C 1F3FE', emoji: '👬🏾' },
            { code: '1F468 1F3FE 200D 1F91D 200D 1F468 1F3FF', emoji: '👨🏾‍🤝‍👨🏿' },
            { code: '1F468 1F3FF 200D 1F91D 200D 1F468 1F3FB', emoji: '👨🏿‍🤝‍👨🏻' },
            { code: '1F468 1F3FF 200D 1F91D 200D 1F468 1F3FC', emoji: '👨🏿‍🤝‍👨🏼' },
            { code: '1F468 1F3FF 200D 1F91D 200D 1F468 1F3FD', emoji: '👨🏿‍🤝‍👨🏽' },
            { code: '1F468 1F3FF 200D 1F91D 200D 1F468 1F3FE', emoji: '👨🏿‍🤝‍👨🏾' },
            { code: '1F46C 1F3FF', emoji: '👬🏿' },
            { code: '1F48F', emoji: '💏' },
            { code: '1F48F 1F3FB', emoji: '💏🏻' },
            { code: '1F48F 1F3FC', emoji: '💏🏼' },
            { code: '1F48F 1F3FD', emoji: '💏🏽' },
            { code: '1F48F 1F3FE', emoji: '💏🏾' },
            { code: '1F48F 1F3FF', emoji: '💏🏿' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC', emoji: '🧑🏻‍❤️‍💋‍🧑🏼' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD', emoji: '🧑🏻‍❤️‍💋‍🧑🏽' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE', emoji: '🧑🏻‍❤️‍💋‍🧑🏾' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF', emoji: '🧑🏻‍❤️‍💋‍🧑🏿' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB', emoji: '🧑🏼‍❤️‍💋‍🧑🏻' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD', emoji: '🧑🏼‍❤️‍💋‍🧑🏽' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE', emoji: '🧑🏼‍❤️‍💋‍🧑🏾' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF', emoji: '🧑🏼‍❤️‍💋‍🧑🏿' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB', emoji: '🧑🏽‍❤️‍💋‍🧑🏻' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC', emoji: '🧑🏽‍❤️‍💋‍🧑🏼' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE', emoji: '🧑🏽‍❤️‍💋‍🧑🏾' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF', emoji: '🧑🏽‍❤️‍💋‍🧑🏿' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB', emoji: '🧑🏾‍❤️‍💋‍🧑🏻' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC', emoji: '🧑🏾‍❤️‍💋‍🧑🏼' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD', emoji: '🧑🏾‍❤️‍💋‍🧑🏽' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF', emoji: '🧑🏾‍❤️‍💋‍🧑🏿' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB', emoji: '🧑🏿‍❤️‍💋‍🧑🏻' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC', emoji: '🧑🏿‍❤️‍💋‍🧑🏼' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD', emoji: '🧑🏿‍❤️‍💋‍🧑🏽' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE', emoji: '🧑🏿‍❤️‍💋‍🧑🏾' },
            { code: '1F469 200D 2764 FE0F 200D 1F48B 200D 1F468', emoji: '👩‍❤️‍💋‍👨' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👩🏻‍❤️‍💋‍👨🏻' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👩🏻‍❤️‍💋‍👨🏼' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👩🏻‍❤️‍💋‍👨🏽' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👩🏻‍❤️‍💋‍👨🏾' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👩🏻‍❤️‍💋‍👨🏿' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👩🏼‍❤️‍💋‍👨🏻' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👩🏼‍❤️‍💋‍👨🏼' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👩🏼‍❤️‍💋‍👨🏽' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👩🏼‍❤️‍💋‍👨🏾' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👩🏼‍❤️‍💋‍👨🏿' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👩🏽‍❤️‍💋‍👨🏻' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👩🏽‍❤️‍💋‍👨🏼' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👩🏽‍❤️‍💋‍👨🏽' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👩🏽‍❤️‍💋‍👨🏾' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👩🏽‍❤️‍💋‍👨🏿' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👩🏾‍❤️‍💋‍👨🏻' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👩🏾‍❤️‍💋‍👨🏼' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👩🏾‍❤️‍💋‍👨🏽' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👩🏾‍❤️‍💋‍👨🏾' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👩🏾‍❤️‍💋‍👨🏿' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👩🏿‍❤️‍💋‍👨🏻' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👩🏿‍❤️‍💋‍👨🏼' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👩🏿‍❤️‍💋‍👨🏽' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👩🏿‍❤️‍💋‍👨🏾' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👩🏿‍❤️‍💋‍👨🏿' },
            { code: '1F468 200D 2764 FE0F 200D 1F48B 200D 1F468', emoji: '👨‍❤️‍💋‍👨' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👨🏻‍❤️‍💋‍👨🏻' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👨🏻‍❤️‍💋‍👨🏼' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👨🏻‍❤️‍💋‍👨🏽' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👨🏻‍❤️‍💋‍👨🏾' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👨🏻‍❤️‍💋‍👨🏿' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👨🏼‍❤️‍💋‍👨🏻' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👨🏼‍❤️‍💋‍👨🏼' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👨🏼‍❤️‍💋‍👨🏽' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👨🏼‍❤️‍💋‍👨🏾' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👨🏼‍❤️‍💋‍👨🏿' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👨🏽‍❤️‍💋‍👨🏻' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👨🏽‍❤️‍💋‍👨🏼' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👨🏽‍❤️‍💋‍👨🏽' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👨🏽‍❤️‍💋‍👨🏾' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👨🏽‍❤️‍💋‍👨🏿' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👨🏾‍❤️‍💋‍👨🏻' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👨🏾‍❤️‍💋‍👨🏼' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👨🏾‍❤️‍💋‍👨🏽' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👨🏾‍❤️‍💋‍👨🏾' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👨🏾‍❤️‍💋‍👨🏿' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB', emoji: '👨🏿‍❤️‍💋‍👨🏻' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC', emoji: '👨🏿‍❤️‍💋‍👨🏼' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD', emoji: '👨🏿‍❤️‍💋‍👨🏽' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE', emoji: '👨🏿‍❤️‍💋‍👨🏾' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF', emoji: '👨🏿‍❤️‍💋‍👨🏿' },
            { code: '1F469 200D 2764 FE0F 200D 1F48B 200D 1F469', emoji: '👩‍❤️‍💋‍👩' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB', emoji: '👩🏻‍❤️‍💋‍👩🏻' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC', emoji: '👩🏻‍❤️‍💋‍👩🏼' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD', emoji: '👩🏻‍❤️‍💋‍👩🏽' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE', emoji: '👩🏻‍❤️‍💋‍👩🏾' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF', emoji: '👩🏻‍❤️‍💋‍👩🏿' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB', emoji: '👩🏼‍❤️‍💋‍👩🏻' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC', emoji: '👩🏼‍❤️‍💋‍👩🏼' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD', emoji: '👩🏼‍❤️‍💋‍👩🏽' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE', emoji: '👩🏼‍❤️‍💋‍👩🏾' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF', emoji: '👩🏼‍❤️‍💋‍👩🏿' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB', emoji: '👩🏽‍❤️‍💋‍👩🏻' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC', emoji: '👩🏽‍❤️‍💋‍👩🏼' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD', emoji: '👩🏽‍❤️‍💋‍👩🏽' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE', emoji: '👩🏽‍❤️‍💋‍👩🏾' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF', emoji: '👩🏽‍❤️‍💋‍👩🏿' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB', emoji: '👩🏾‍❤️‍💋‍👩🏻' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC', emoji: '👩🏾‍❤️‍💋‍👩🏼' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD', emoji: '👩🏾‍❤️‍💋‍👩🏽' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE', emoji: '👩🏾‍❤️‍💋‍👩🏾' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF', emoji: '👩🏾‍❤️‍💋‍👩🏿' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB', emoji: '👩🏿‍❤️‍💋‍👩🏻' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC', emoji: '👩🏿‍❤️‍💋‍👩🏼' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD', emoji: '👩🏿‍❤️‍💋‍👩🏽' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE', emoji: '👩🏿‍❤️‍💋‍👩🏾' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF', emoji: '👩🏿‍❤️‍💋‍👩🏿' },
            { code: '1F491', emoji: '💑' },
            { code: '1F491 1F3FB', emoji: '💑🏻' },
            { code: '1F491 1F3FC', emoji: '💑🏼' },
            { code: '1F491 1F3FD', emoji: '💑🏽' },
            { code: '1F491 1F3FE', emoji: '💑🏾' },
            { code: '1F491 1F3FF', emoji: '💑🏿' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FC', emoji: '🧑🏻‍❤️‍🧑🏼' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FD', emoji: '🧑🏻‍❤️‍🧑🏽' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FE', emoji: '🧑🏻‍❤️‍🧑🏾' },
            { code: '1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FF', emoji: '🧑🏻‍❤️‍🧑🏿' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FB', emoji: '🧑🏼‍❤️‍🧑🏻' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FD', emoji: '🧑🏼‍❤️‍🧑🏽' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FE', emoji: '🧑🏼‍❤️‍🧑🏾' },
            { code: '1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FF', emoji: '🧑🏼‍❤️‍🧑🏿' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FB', emoji: '🧑🏽‍❤️‍🧑🏻' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FC', emoji: '🧑🏽‍❤️‍🧑🏼' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FE', emoji: '🧑🏽‍❤️‍🧑🏾' },
            { code: '1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FF', emoji: '🧑🏽‍❤️‍🧑🏿' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FB', emoji: '🧑🏾‍❤️‍🧑🏻' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FC', emoji: '🧑🏾‍❤️‍🧑🏼' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FD', emoji: '🧑🏾‍❤️‍🧑🏽' },
            { code: '1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FF', emoji: '🧑🏾‍❤️‍🧑🏿' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FB', emoji: '🧑🏿‍❤️‍🧑🏻' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FC', emoji: '🧑🏿‍❤️‍🧑🏼' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FD', emoji: '🧑🏿‍❤️‍🧑🏽' },
            { code: '1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FE', emoji: '🧑🏿‍❤️‍🧑🏾' },
            { code: '1F469 200D 2764 FE0F 200D 1F468', emoji: '👩‍❤️‍👨' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👩🏻‍❤️‍👨🏻' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👩🏻‍❤️‍👨🏼' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👩🏻‍❤️‍👨🏽' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👩🏻‍❤️‍👨🏾' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👩🏻‍❤️‍👨🏿' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👩🏼‍❤️‍👨🏻' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👩🏼‍❤️‍👨🏼' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👩🏼‍❤️‍👨🏽' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👩🏼‍❤️‍👨🏾' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👩🏼‍❤️‍👨🏿' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👩🏽‍❤️‍👨🏻' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👩🏽‍❤️‍👨🏼' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👩🏽‍❤️‍👨🏽' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👩🏽‍❤️‍👨🏾' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👩🏽‍❤️‍👨🏿' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👩🏾‍❤️‍👨🏻' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👩🏾‍❤️‍👨🏼' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👩🏾‍❤️‍👨🏽' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👩🏾‍❤️‍👨🏾' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👩🏾‍❤️‍👨🏿' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👩🏿‍❤️‍👨🏻' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👩🏿‍❤️‍👨🏼' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👩🏿‍❤️‍👨🏽' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👩🏿‍❤️‍👨🏾' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👩🏿‍❤️‍👨🏿' },
            { code: '1F468 200D 2764 FE0F 200D 1F468', emoji: '👨‍❤️‍👨' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👨🏻‍❤️‍👨🏻' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👨🏻‍❤️‍👨🏼' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👨🏻‍❤️‍👨🏽' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👨🏻‍❤️‍👨🏾' },
            { code: '1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👨🏻‍❤️‍👨🏿' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👨🏼‍❤️‍👨🏻' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👨🏼‍❤️‍👨🏼' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👨🏼‍❤️‍👨🏽' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👨🏼‍❤️‍👨🏾' },
            { code: '1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👨🏼‍❤️‍👨🏿' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👨🏽‍❤️‍👨🏻' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👨🏽‍❤️‍👨🏼' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👨🏽‍❤️‍👨🏽' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👨🏽‍❤️‍👨🏾' },
            { code: '1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👨🏽‍❤️‍👨🏿' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👨🏾‍❤️‍👨🏻' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👨🏾‍❤️‍👨🏼' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👨🏾‍❤️‍👨🏽' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👨🏾‍❤️‍👨🏾' },
            { code: '1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👨🏾‍❤️‍👨🏿' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FB', emoji: '👨🏿‍❤️‍👨🏻' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FC', emoji: '👨🏿‍❤️‍👨🏼' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FD', emoji: '👨🏿‍❤️‍👨🏽' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FE', emoji: '👨🏿‍❤️‍👨🏾' },
            { code: '1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FF', emoji: '👨🏿‍❤️‍👨🏿' },
            { code: '1F469 200D 2764 FE0F 200D 1F469', emoji: '👩‍❤️‍👩' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FB', emoji: '👩🏻‍❤️‍👩🏻' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FC', emoji: '👩🏻‍❤️‍👩🏼' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FD', emoji: '👩🏻‍❤️‍👩🏽' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FE', emoji: '👩🏻‍❤️‍👩🏾' },
            { code: '1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FF', emoji: '👩🏻‍❤️‍👩🏿' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FB', emoji: '👩🏼‍❤️‍👩🏻' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FC', emoji: '👩🏼‍❤️‍👩🏼' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FD', emoji: '👩🏼‍❤️‍👩🏽' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FE', emoji: '👩🏼‍❤️‍👩🏾' },
            { code: '1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FF', emoji: '👩🏼‍❤️‍👩🏿' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FB', emoji: '👩🏽‍❤️‍👩🏻' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FC', emoji: '👩🏽‍❤️‍👩🏼' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FD', emoji: '👩🏽‍❤️‍👩🏽' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FE', emoji: '👩🏽‍❤️‍👩🏾' },
            { code: '1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FF', emoji: '👩🏽‍❤️‍👩🏿' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FB', emoji: '👩🏾‍❤️‍👩🏻' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FC', emoji: '👩🏾‍❤️‍👩🏼' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FD', emoji: '👩🏾‍❤️‍👩🏽' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FE', emoji: '👩🏾‍❤️‍👩🏾' },
            { code: '1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FF', emoji: '👩🏾‍❤️‍👩🏿' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FB', emoji: '👩🏿‍❤️‍👩🏻' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FC', emoji: '👩🏿‍❤️‍👩🏼' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FD', emoji: '👩🏿‍❤️‍👩🏽' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FE', emoji: '👩🏿‍❤️‍👩🏾' },
            { code: '1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FF', emoji: '👩🏿‍❤️‍👩🏿' },
            { code: '1F468 200D 1F469 200D 1F466', emoji: '👨‍👩‍👦' },
            { code: '1F468 200D 1F469 200D 1F467', emoji: '👨‍👩‍👧' },
            { code: '1F468 200D 1F469 200D 1F467 200D 1F466', emoji: '👨‍👩‍👧‍👦' },
            { code: '1F468 200D 1F469 200D 1F466 200D 1F466', emoji: '👨‍👩‍👦‍👦' },
            { code: '1F468 200D 1F469 200D 1F467 200D 1F467', emoji: '👨‍👩‍👧‍👧' },
            { code: '1F468 200D 1F468 200D 1F466', emoji: '👨‍👨‍👦' },
            { code: '1F468 200D 1F468 200D 1F467', emoji: '👨‍👨‍👧' },
            { code: '1F468 200D 1F468 200D 1F467 200D 1F466', emoji: '👨‍👨‍👧‍👦' },
            { code: '1F468 200D 1F468 200D 1F466 200D 1F466', emoji: '👨‍👨‍👦‍👦' },
            { code: '1F468 200D 1F468 200D 1F467 200D 1F467', emoji: '👨‍👨‍👧‍👧' },
            { code: '1F469 200D 1F469 200D 1F466', emoji: '👩‍👩‍👦' },
            { code: '1F469 200D 1F469 200D 1F467', emoji: '👩‍👩‍👧' },
            { code: '1F469 200D 1F469 200D 1F467 200D 1F466', emoji: '👩‍👩‍👧‍👦' },
            { code: '1F469 200D 1F469 200D 1F466 200D 1F466', emoji: '👩‍👩‍👦‍👦' },
            { code: '1F469 200D 1F469 200D 1F467 200D 1F467', emoji: '👩‍👩‍👧‍👧' },
            { code: '1F468 200D 1F466', emoji: '👨‍👦' },
            { code: '1F468 200D 1F466 200D 1F466', emoji: '👨‍👦‍👦' },
            { code: '1F468 200D 1F467', emoji: '👨‍👧' },
            { code: '1F468 200D 1F467 200D 1F466', emoji: '👨‍👧‍👦' },
            { code: '1F468 200D 1F467 200D 1F467', emoji: '👨‍👧‍👧' },
            { code: '1F469 200D 1F466', emoji: '👩‍👦' },
            { code: '1F469 200D 1F466 200D 1F466', emoji: '👩‍👦‍👦' },
            { code: '1F469 200D 1F467', emoji: '👩‍👧' },
            { code: '1F469 200D 1F467 200D 1F466', emoji: '👩‍👧‍👦' },
            { code: '1F469 200D 1F467 200D 1F467', emoji: '👩‍👧‍👧' },
        ],
        'person-symbol': [
            { code: '1F5E3 FE0F', emoji: '🗣️' },
            { code: '1F464', emoji: '👤' },
            { code: '1F465', emoji: '👥' },
            { code: '1FAC2', emoji: '🫂' },
            { code: '1F46A', emoji: '👪' },
            { code: '1F9D1 200D 1F9D1 200D 1F9D2', emoji: '🧑‍🧑‍🧒' },
            { code: '1F9D1 200D 1F9D1 200D 1F9D2 200D 1F9D2', emoji: '🧑‍🧑‍🧒‍🧒' },
            { code: '1F9D1 200D 1F9D2', emoji: '🧑‍🧒' },
            { code: '1F9D1 200D 1F9D2 200D 1F9D2', emoji: '🧑‍🧒‍🧒' },
            { code: '1F463', emoji: '👣' },
            { code: '1FAC6', emoji: '🫆' },
        ],
        'animal-mammal': [
            { code: '1F435', emoji: '🐵' },
            { code: '1F412', emoji: '🐒' },
            { code: '1F98D', emoji: '🦍' },
            { code: '1F9A7', emoji: '🦧' },
            { code: '1F436', emoji: '🐶' },
            { code: '1F415', emoji: '🐕' },
            { code: '1F9AE', emoji: '🦮' },
            { code: '1F415 200D 1F9BA', emoji: '🐕‍🦺' },
            { code: '1F429', emoji: '🐩' },
            { code: '1F43A', emoji: '🐺' },
            { code: '1F98A', emoji: '🦊' },
            { code: '1F99D', emoji: '🦝' },
            { code: '1F431', emoji: '🐱' },
            { code: '1F408', emoji: '🐈' },
            { code: '1F408 200D 2B1B', emoji: '🐈‍⬛' },
            { code: '1F981', emoji: '🦁' },
            { code: '1F42F', emoji: '🐯' },
            { code: '1F405', emoji: '🐅' },
            { code: '1F406', emoji: '🐆' },
            { code: '1F434', emoji: '🐴' },
            { code: '1FACE', emoji: '🫎' },
            { code: '1FACF', emoji: '🫏' },
            { code: '1F40E', emoji: '🐎' },
            { code: '1F984', emoji: '🦄' },
            { code: '1F993', emoji: '🦓' },
            { code: '1F98C', emoji: '🦌' },
            { code: '1F9AC', emoji: '🦬' },
            { code: '1F42E', emoji: '🐮' },
            { code: '1F402', emoji: '🐂' },
            { code: '1F403', emoji: '🐃' },
            { code: '1F404', emoji: '🐄' },
            { code: '1F437', emoji: '🐷' },
            { code: '1F416', emoji: '🐖' },
            { code: '1F417', emoji: '🐗' },
            { code: '1F43D', emoji: '🐽' },
            { code: '1F40F', emoji: '🐏' },
            { code: '1F411', emoji: '🐑' },
            { code: '1F410', emoji: '🐐' },
            { code: '1F42A', emoji: '🐪' },
            { code: '1F42B', emoji: '🐫' },
            { code: '1F999', emoji: '🦙' },
            { code: '1F992', emoji: '🦒' },
            { code: '1F418', emoji: '🐘' },
            { code: '1F9A3', emoji: '🦣' },
            { code: '1F98F', emoji: '🦏' },
            { code: '1F99B', emoji: '🦛' },
            { code: '1F42D', emoji: '🐭' },
            { code: '1F401', emoji: '🐁' },
            { code: '1F400', emoji: '🐀' },
            { code: '1F439', emoji: '🐹' },
            { code: '1F430', emoji: '🐰' },
            { code: '1F407', emoji: '🐇' },
            { code: '1F43F FE0F', emoji: '🐿️' },
            { code: '1F9AB', emoji: '🦫' },
            { code: '1F994', emoji: '🦔' },
            { code: '1F987', emoji: '🦇' },
            { code: '1F43B', emoji: '🐻' },
            { code: '1F43B 200D 2744 FE0F', emoji: '🐻‍❄️' },
            { code: '1F428', emoji: '🐨' },
            { code: '1F43C', emoji: '🐼' },
            { code: '1F9A5', emoji: '🦥' },
            { code: '1F9A6', emoji: '🦦' },
            { code: '1F9A8', emoji: '🦨' },
            { code: '1F998', emoji: '🦘' },
            { code: '1F9A1', emoji: '🦡' },
            { code: '1F43E', emoji: '🐾' },
        ],
        'animal-bird': [
            { code: '1F983', emoji: '🦃' },
            { code: '1F414', emoji: '🐔' },
            { code: '1F413', emoji: '🐓' },
            { code: '1F423', emoji: '🐣' },
            { code: '1F424', emoji: '🐤' },
            { code: '1F425', emoji: '🐥' },
            { code: '1F426', emoji: '🐦' },
            { code: '1F427', emoji: '🐧' },
            { code: '1F54A FE0F', emoji: '🕊️' },
            { code: '1F985', emoji: '🦅' },
            { code: '1F986', emoji: '🦆' },
            { code: '1F9A2', emoji: '🦢' },
            { code: '1F989', emoji: '🦉' },
            { code: '1F9A4', emoji: '🦤' },
            { code: '1FAB6', emoji: '🪶' },
            { code: '1F9A9', emoji: '🦩' },
            { code: '1F99A', emoji: '🦚' },
            { code: '1F99C', emoji: '🦜' },
            { code: '1FABD', emoji: '🪽' },
            { code: '1F426 200D 2B1B', emoji: '🐦‍⬛' },
            { code: '1FABF', emoji: '🪿' },
            { code: '1F426 200D 1F525', emoji: '🐦‍🔥' },
        ],
        'animal-amphibian': [
            { code: '1F438', emoji: '🐸' },
        ],
        'animal-reptile': [
            { code: '1F40A', emoji: '🐊' },
            { code: '1F422', emoji: '🐢' },
            { code: '1F98E', emoji: '🦎' },
            { code: '1F40D', emoji: '🐍' },
            { code: '1F432', emoji: '🐲' },
            { code: '1F409', emoji: '🐉' },
            { code: '1F995', emoji: '🦕' },
            { code: '1F996', emoji: '🦖' },
        ],
        'animal-marine': [
            { code: '1F433', emoji: '🐳' },
            { code: '1F40B', emoji: '🐋' },
            { code: '1F42C', emoji: '🐬' },
            { code: '1F9AD', emoji: '🦭' },
            { code: '1F41F', emoji: '🐟' },
            { code: '1F420', emoji: '🐠' },
            { code: '1F421', emoji: '🐡' },
            { code: '1F988', emoji: '🦈' },
            { code: '1F419', emoji: '🐙' },
            { code: '1F41A', emoji: '🐚' },
            { code: '1FAB8', emoji: '🪸' },
            { code: '1FABC', emoji: '🪼' },
            { code: '1F980', emoji: '🦀' },
            { code: '1F99E', emoji: '🦞' },
            { code: '1F990', emoji: '🦐' },
            { code: '1F991', emoji: '🦑' },
            { code: '1F9AA', emoji: '🦪' },
        ],
        'animal-bug': [
            { code: '1F40C', emoji: '🐌' },
            { code: '1F98B', emoji: '🦋' },
            { code: '1F41B', emoji: '🐛' },
            { code: '1F41C', emoji: '🐜' },
            { code: '1F41D', emoji: '🐝' },
            { code: '1FAB2', emoji: '🪲' },
            { code: '1F41E', emoji: '🐞' },
            { code: '1F997', emoji: '🦗' },
            { code: '1FAB3', emoji: '🪳' },
            { code: '1F577 FE0F', emoji: '🕷️' },
            { code: '1F578 FE0F', emoji: '🕸️' },
            { code: '1F982', emoji: '🦂' },
            { code: '1F99F', emoji: '🦟' },
            { code: '1FAB0', emoji: '🪰' },
            { code: '1FAB1', emoji: '🪱' },
            { code: '1F9A0', emoji: '🦠' },
        ],
        'plant-flower': [
            { code: '1F490', emoji: '💐' },
            { code: '1F338', emoji: '🌸' },
            { code: '1F4AE', emoji: '💮' },
            { code: '1FAB7', emoji: '🪷' },
            { code: '1F3F5 FE0F', emoji: '🏵️' },
            { code: '1F339', emoji: '🌹' },
            { code: '1F940', emoji: '🥀' },
            { code: '1F33A', emoji: '🌺' },
            { code: '1F33B', emoji: '🌻' },
            { code: '1F33C', emoji: '🌼' },
            { code: '1F337', emoji: '🌷' },
            { code: '1FABB', emoji: '🪻' },
        ],
        'plant-other': [
            { code: '1F331', emoji: '🌱' },
            { code: '1FAB4', emoji: '🪴' },
            { code: '1F332', emoji: '🌲' },
            { code: '1F333', emoji: '🌳' },
            { code: '1F334', emoji: '🌴' },
            { code: '1F335', emoji: '🌵' },
            { code: '1F33E', emoji: '🌾' },
            { code: '1F33F', emoji: '🌿' },
            { code: '2618 FE0F', emoji: '☘️' },
            { code: '1F340', emoji: '🍀' },
            { code: '1F341', emoji: '🍁' },
            { code: '1F342', emoji: '🍂' },
            { code: '1F343', emoji: '🍃' },
            { code: '1FAB9', emoji: '🪹' },
            { code: '1FABA', emoji: '🪺' },
            { code: '1F344', emoji: '🍄' },
            { code: '1FABE', emoji: '🪾' },
        ],
        'food-fruit': [
            { code: '1F347', emoji: '🍇' },
            { code: '1F348', emoji: '🍈' },
            { code: '1F349', emoji: '🍉' },
            { code: '1F34A', emoji: '🍊' },
            { code: '1F34B', emoji: '🍋' },
            { code: '1F34B 200D 1F7E9', emoji: '🍋‍🟩' },
            { code: '1F34C', emoji: '🍌' },
            { code: '1F34D', emoji: '🍍' },
            { code: '1F96D', emoji: '🥭' },
            { code: '1F34E', emoji: '🍎' },
            { code: '1F34F', emoji: '🍏' },
            { code: '1F350', emoji: '🍐' },
            { code: '1F351', emoji: '🍑' },
            { code: '1F352', emoji: '🍒' },
            { code: '1F353', emoji: '🍓' },
            { code: '1FAD0', emoji: '🫐' },
            { code: '1F95D', emoji: '🥝' },
            { code: '1F345', emoji: '🍅' },
            { code: '1FAD2', emoji: '🫒' },
            { code: '1F965', emoji: '🥥' },
        ],
        'food-vegetable': [
            { code: '1F951', emoji: '🥑' },
            { code: '1F346', emoji: '🍆' },
            { code: '1F954', emoji: '🥔' },
            { code: '1F955', emoji: '🥕' },
            { code: '1F33D', emoji: '🌽' },
            { code: '1F336 FE0F', emoji: '🌶️' },
            { code: '1FAD1', emoji: '🫑' },
            { code: '1F952', emoji: '🥒' },
            { code: '1F96C', emoji: '🥬' },
            { code: '1F966', emoji: '🥦' },
            { code: '1F9C4', emoji: '🧄' },
            { code: '1F9C5', emoji: '🧅' },
            { code: '1F95C', emoji: '🥜' },
            { code: '1FAD8', emoji: '🫘' },
            { code: '1F330', emoji: '🌰' },
            { code: '1FADA', emoji: '🫚' },
            { code: '1FADB', emoji: '🫛' },
            { code: '1F344 200D 1F7EB', emoji: '🍄‍🟫' },
            { code: '1FADC', emoji: '🫜' },
        ],
        'food-prepared': [
            { code: '1F35E', emoji: '🍞' },
            { code: '1F950', emoji: '🥐' },
            { code: '1F956', emoji: '🥖' },
            { code: '1FAD3', emoji: '🫓' },
            { code: '1F968', emoji: '🥨' },
            { code: '1F96F', emoji: '🥯' },
            { code: '1F95E', emoji: '🥞' },
            { code: '1F9C7', emoji: '🧇' },
            { code: '1F9C0', emoji: '🧀' },
            { code: '1F356', emoji: '🍖' },
            { code: '1F357', emoji: '🍗' },
            { code: '1F969', emoji: '🥩' },
            { code: '1F953', emoji: '🥓' },
            { code: '1F354', emoji: '🍔' },
            { code: '1F35F', emoji: '🍟' },
            { code: '1F355', emoji: '🍕' },
            { code: '1F32D', emoji: '🌭' },
            { code: '1F96A', emoji: '🥪' },
            { code: '1F32E', emoji: '🌮' },
            { code: '1F32F', emoji: '🌯' },
            { code: '1FAD4', emoji: '🫔' },
            { code: '1F959', emoji: '🥙' },
            { code: '1F9C6', emoji: '🧆' },
            { code: '1F95A', emoji: '🥚' },
            { code: '1F373', emoji: '🍳' },
            { code: '1F958', emoji: '🥘' },
            { code: '1F372', emoji: '🍲' },
            { code: '1FAD5', emoji: '🫕' },
            { code: '1F963', emoji: '🥣' },
            { code: '1F957', emoji: '🥗' },
            { code: '1F37F', emoji: '🍿' },
            { code: '1F9C8', emoji: '🧈' },
            { code: '1F9C2', emoji: '🧂' },
            { code: '1F96B', emoji: '🥫' },
        ],
        'food-asian': [
            { code: '1F371', emoji: '🍱' },
            { code: '1F358', emoji: '🍘' },
            { code: '1F359', emoji: '🍙' },
            { code: '1F35A', emoji: '🍚' },
            { code: '1F35B', emoji: '🍛' },
            { code: '1F35C', emoji: '🍜' },
            { code: '1F35D', emoji: '🍝' },
            { code: '1F360', emoji: '🍠' },
            { code: '1F362', emoji: '🍢' },
            { code: '1F363', emoji: '🍣' },
            { code: '1F364', emoji: '🍤' },
            { code: '1F365', emoji: '🍥' },
            { code: '1F96E', emoji: '🥮' },
            { code: '1F361', emoji: '🍡' },
            { code: '1F95F', emoji: '🥟' },
            { code: '1F960', emoji: '🥠' },
            { code: '1F961', emoji: '🥡' },
        ],
        'food-sweet': [
            { code: '1F366', emoji: '🍦' },
            { code: '1F367', emoji: '🍧' },
            { code: '1F368', emoji: '🍨' },
            { code: '1F369', emoji: '🍩' },
            { code: '1F36A', emoji: '🍪' },
            { code: '1F382', emoji: '🎂' },
            { code: '1F370', emoji: '🍰' },
            { code: '1F9C1', emoji: '🧁' },
            { code: '1F967', emoji: '🥧' },
            { code: '1F36B', emoji: '🍫' },
            { code: '1F36C', emoji: '🍬' },
            { code: '1F36D', emoji: '🍭' },
            { code: '1F36E', emoji: '🍮' },
            { code: '1F36F', emoji: '🍯' },
        ],
        'drink': [
            { code: '1F37C', emoji: '🍼' },
            { code: '1F95B', emoji: '🥛' },
            { code: '2615', emoji: '☕' },
            { code: '1FAD6', emoji: '🫖' },
            { code: '1F375', emoji: '🍵' },
            { code: '1F376', emoji: '🍶' },
            { code: '1F37E', emoji: '🍾' },
            { code: '1F377', emoji: '🍷' },
            { code: '1F378', emoji: '🍸' },
            { code: '1F379', emoji: '🍹' },
            { code: '1F37A', emoji: '🍺' },
            { code: '1F37B', emoji: '🍻' },
            { code: '1F942', emoji: '🥂' },
            { code: '1F943', emoji: '🥃' },
            { code: '1FAD7', emoji: '🫗' },
            { code: '1F964', emoji: '🥤' },
            { code: '1F9CB', emoji: '🧋' },
            { code: '1F9C3', emoji: '🧃' },
            { code: '1F9C9', emoji: '🧉' },
            { code: '1F9CA', emoji: '🧊' },
        ],
        'dishware': [
            { code: '1F962', emoji: '🥢' },
            { code: '1F37D FE0F', emoji: '🍽️' },
            { code: '1F374', emoji: '🍴' },
            { code: '1F944', emoji: '🥄' },
            { code: '1F52A', emoji: '🔪' },
            { code: '1FAD9', emoji: '🫙' },
            { code: '1F3FA', emoji: '🏺' },
        ],
        'place-map': [
            { code: '1F30D', emoji: '🌍' },
            { code: '1F30E', emoji: '🌎' },
            { code: '1F30F', emoji: '🌏' },
            { code: '1F310', emoji: '🌐' },
            { code: '1F5FA FE0F', emoji: '🗺️' },
            { code: '1F5FE', emoji: '🗾' },
            { code: '1F9ED', emoji: '🧭' },
        ],
        'place-geographic': [
            { code: '1F3D4 FE0F', emoji: '🏔️' },
            { code: '26F0 FE0F', emoji: '⛰️' },
            { code: '1F30B', emoji: '🌋' },
            { code: '1F5FB', emoji: '🗻' },
            { code: '1F3D5 FE0F', emoji: '🏕️' },
            { code: '1F3D6 FE0F', emoji: '🏖️' },
            { code: '1F3DC FE0F', emoji: '🏜️' },
            { code: '1F3DD FE0F', emoji: '🏝️' },
            { code: '1F3DE FE0F', emoji: '🏞️' },
        ],
        'place-building': [
            { code: '1F3DF FE0F', emoji: '🏟️' },
            { code: '1F3DB FE0F', emoji: '🏛️' },
            { code: '1F3D7 FE0F', emoji: '🏗️' },
            { code: '1F9F1', emoji: '🧱' },
            { code: '1FAA8', emoji: '🪨' },
            { code: '1FAB5', emoji: '🪵' },
            { code: '1F6D6', emoji: '🛖' },
            { code: '1F3D8 FE0F', emoji: '🏘️' },
            { code: '1F3DA FE0F', emoji: '🏚️' },
            { code: '1F3E0', emoji: '🏠' },
            { code: '1F3E1', emoji: '🏡' },
            { code: '1F3E2', emoji: '🏢' },
            { code: '1F3E3', emoji: '🏣' },
            { code: '1F3E4', emoji: '🏤' },
            { code: '1F3E5', emoji: '🏥' },
            { code: '1F3E6', emoji: '🏦' },
            { code: '1F3E8', emoji: '🏨' },
            { code: '1F3E9', emoji: '🏩' },
            { code: '1F3EA', emoji: '🏪' },
            { code: '1F3EB', emoji: '🏫' },
            { code: '1F3EC', emoji: '🏬' },
            { code: '1F3ED', emoji: '🏭' },
            { code: '1F3EF', emoji: '🏯' },
            { code: '1F3F0', emoji: '🏰' },
            { code: '1F492', emoji: '💒' },
            { code: '1F5FC', emoji: '🗼' },
            { code: '1F5FD', emoji: '🗽' },
        ],
        'place-religious': [
            { code: '26EA', emoji: '⛪' },
            { code: '1F54C', emoji: '🕌' },
            { code: '1F6D5', emoji: '🛕' },
            { code: '1F54D', emoji: '🕍' },
            { code: '26E9 FE0F', emoji: '⛩️' },
            { code: '1F54B', emoji: '🕋' },
        ],
        'place-other': [
            { code: '26F2', emoji: '⛲' },
            { code: '26FA', emoji: '⛺' },
            { code: '1F301', emoji: '🌁' },
            { code: '1F303', emoji: '🌃' },
            { code: '1F3D9 FE0F', emoji: '🏙️' },
            { code: '1F304', emoji: '🌄' },
            { code: '1F305', emoji: '🌅' },
            { code: '1F306', emoji: '🌆' },
            { code: '1F307', emoji: '🌇' },
            { code: '1F309', emoji: '🌉' },
            { code: '2668 FE0F', emoji: '♨️' },
            { code: '1F3A0', emoji: '🎠' },
            { code: '1F6DD', emoji: '🛝' },
            { code: '1F3A1', emoji: '🎡' },
            { code: '1F3A2', emoji: '🎢' },
            { code: '1F488', emoji: '💈' },
            { code: '1F3AA', emoji: '🎪' },
        ],
        'transport-ground': [
            { code: '1F682', emoji: '🚂' },
            { code: '1F683', emoji: '🚃' },
            { code: '1F684', emoji: '🚄' },
            { code: '1F685', emoji: '🚅' },
            { code: '1F686', emoji: '🚆' },
            { code: '1F687', emoji: '🚇' },
            { code: '1F688', emoji: '🚈' },
            { code: '1F689', emoji: '🚉' },
            { code: '1F68A', emoji: '🚊' },
            { code: '1F69D', emoji: '🚝' },
            { code: '1F69E', emoji: '🚞' },
            { code: '1F68B', emoji: '🚋' },
            { code: '1F68C', emoji: '🚌' },
            { code: '1F68D', emoji: '🚍' },
            { code: '1F68E', emoji: '🚎' },
            { code: '1F690', emoji: '🚐' },
            { code: '1F691', emoji: '🚑' },
            { code: '1F692', emoji: '🚒' },
            { code: '1F693', emoji: '🚓' },
            { code: '1F694', emoji: '🚔' },
            { code: '1F695', emoji: '🚕' },
            { code: '1F696', emoji: '🚖' },
            { code: '1F697', emoji: '🚗' },
            { code: '1F698', emoji: '🚘' },
            { code: '1F699', emoji: '🚙' },
            { code: '1F6FB', emoji: '🛻' },
            { code: '1F69A', emoji: '🚚' },
            { code: '1F69B', emoji: '🚛' },
            { code: '1F69C', emoji: '🚜' },
            { code: '1F3CE FE0F', emoji: '🏎️' },
            { code: '1F3CD FE0F', emoji: '🏍️' },
            { code: '1F6F5', emoji: '🛵' },
            { code: '1F9BD', emoji: '🦽' },
            { code: '1F9BC', emoji: '🦼' },
            { code: '1F6FA', emoji: '🛺' },
            { code: '1F6B2', emoji: '🚲' },
            { code: '1F6F4', emoji: '🛴' },
            { code: '1F6F9', emoji: '🛹' },
            { code: '1F6FC', emoji: '🛼' },
            { code: '1F68F', emoji: '🚏' },
            { code: '1F6E3 FE0F', emoji: '🛣️' },
            { code: '1F6E4 FE0F', emoji: '🛤️' },
            { code: '1F6E2 FE0F', emoji: '🛢️' },
            { code: '26FD', emoji: '⛽' },
            { code: '1F6DE', emoji: '🛞' },
            { code: '1F6A8', emoji: '🚨' },
            { code: '1F6A5', emoji: '🚥' },
            { code: '1F6A6', emoji: '🚦' },
            { code: '1F6D1', emoji: '🛑' },
            { code: '1F6A7', emoji: '🚧' },
        ],
        'transport-water': [
            { code: '2693', emoji: '⚓' },
            { code: '1F6DF', emoji: '🛟' },
            { code: '26F5', emoji: '⛵' },
            { code: '1F6F6', emoji: '🛶' },
            { code: '1F6A4', emoji: '🚤' },
            { code: '1F6F3 FE0F', emoji: '🛳️' },
            { code: '26F4 FE0F', emoji: '⛴️' },
            { code: '1F6E5 FE0F', emoji: '🛥️' },
            { code: '1F6A2', emoji: '🚢' },
        ],
        'transport-air': [
            { code: '2708 FE0F', emoji: '✈️' },
            { code: '1F6E9 FE0F', emoji: '🛩️' },
            { code: '1F6EB', emoji: '🛫' },
            { code: '1F6EC', emoji: '🛬' },
            { code: '1FA82', emoji: '🪂' },
            { code: '1F4BA', emoji: '💺' },
            { code: '1F681', emoji: '🚁' },
            { code: '1F69F', emoji: '🚟' },
            { code: '1F6A0', emoji: '🚠' },
            { code: '1F6A1', emoji: '🚡' },
            { code: '1F6F0 FE0F', emoji: '🛰️' },
            { code: '1F680', emoji: '🚀' },
            { code: '1F6F8', emoji: '🛸' },
        ],
        'hotel': [
            { code: '1F6CE FE0F', emoji: '🛎️' },
            { code: '1F9F3', emoji: '🧳' },
        ],
        'time': [
            { code: '231B', emoji: '⌛' },
            { code: '23F3', emoji: '⏳' },
            { code: '231A', emoji: '⌚' },
            { code: '23F0', emoji: '⏰' },
            { code: '23F1 FE0F', emoji: '⏱️' },
            { code: '23F2 FE0F', emoji: '⏲️' },
            { code: '1F570 FE0F', emoji: '🕰️' },
            { code: '1F55B', emoji: '🕛' },
            { code: '1F567', emoji: '🕧' },
            { code: '1F550', emoji: '🕐' },
            { code: '1F55C', emoji: '🕜' },
            { code: '1F551', emoji: '🕑' },
            { code: '1F55D', emoji: '🕝' },
            { code: '1F552', emoji: '🕒' },
            { code: '1F55E', emoji: '🕞' },
            { code: '1F553', emoji: '🕓' },
            { code: '1F55F', emoji: '🕟' },
            { code: '1F554', emoji: '🕔' },
            { code: '1F560', emoji: '🕠' },
            { code: '1F555', emoji: '🕕' },
            { code: '1F561', emoji: '🕡' },
            { code: '1F556', emoji: '🕖' },
            { code: '1F562', emoji: '🕢' },
            { code: '1F557', emoji: '🕗' },
            { code: '1F563', emoji: '🕣' },
            { code: '1F558', emoji: '🕘' },
            { code: '1F564', emoji: '🕤' },
            { code: '1F559', emoji: '🕙' },
            { code: '1F565', emoji: '🕥' },
            { code: '1F55A', emoji: '🕚' },
            { code: '1F566', emoji: '🕦' },
        ],
        'sky & weather': [
            { code: '1F311', emoji: '🌑' },
            { code: '1F312', emoji: '🌒' },
            { code: '1F313', emoji: '🌓' },
            { code: '1F314', emoji: '🌔' },
            { code: '1F315', emoji: '🌕' },
            { code: '1F316', emoji: '🌖' },
            { code: '1F317', emoji: '🌗' },
            { code: '1F318', emoji: '🌘' },
            { code: '1F319', emoji: '🌙' },
            { code: '1F31A', emoji: '🌚' },
            { code: '1F31B', emoji: '🌛' },
            { code: '1F31C', emoji: '🌜' },
            { code: '1F321 FE0F', emoji: '🌡️' },
            { code: '2600 FE0F', emoji: '☀️' },
            { code: '1F31D', emoji: '🌝' },
            { code: '1F31E', emoji: '🌞' },
            { code: '1FA90', emoji: '🪐' },
            { code: '2B50', emoji: '⭐' },
            { code: '1F31F', emoji: '🌟' },
            { code: '1F320', emoji: '🌠' },
            { code: '1F30C', emoji: '🌌' },
            { code: '2601 FE0F', emoji: '☁️' },
            { code: '26C5', emoji: '⛅' },
            { code: '26C8 FE0F', emoji: '⛈️' },
            { code: '1F324 FE0F', emoji: '🌤️' },
            { code: '1F325 FE0F', emoji: '🌥️' },
            { code: '1F326 FE0F', emoji: '🌦️' },
            { code: '1F327 FE0F', emoji: '🌧️' },
            { code: '1F328 FE0F', emoji: '🌨️' },
            { code: '1F329 FE0F', emoji: '🌩️' },
            { code: '1F32A FE0F', emoji: '🌪️' },
            { code: '1F32B FE0F', emoji: '🌫️' },
            { code: '1F32C FE0F', emoji: '🌬️' },
            { code: '1F300', emoji: '🌀' },
            { code: '1F308', emoji: '🌈' },
            { code: '1F302', emoji: '🌂' },
            { code: '2602 FE0F', emoji: '☂️' },
            { code: '2614', emoji: '☔' },
            { code: '26F1 FE0F', emoji: '⛱️' },
            { code: '26A1', emoji: '⚡' },
            { code: '2744 FE0F', emoji: '❄️' },
            { code: '2603 FE0F', emoji: '☃️' },
            { code: '26C4', emoji: '⛄' },
            { code: '2604 FE0F', emoji: '☄️' },
            { code: '1F525', emoji: '🔥' },
            { code: '1F4A7', emoji: '💧' },
            { code: '1F30A', emoji: '🌊' },
        ],
        'event': [
            { code: '1F383', emoji: '🎃' },
            { code: '1F384', emoji: '🎄' },
            { code: '1F386', emoji: '🎆' },
            { code: '1F387', emoji: '🎇' },
            { code: '1F9E8', emoji: '🧨' },
            { code: '2728', emoji: '✨' },
            { code: '1F388', emoji: '🎈' },
            { code: '1F389', emoji: '🎉' },
            { code: '1F38A', emoji: '🎊' },
            { code: '1F38B', emoji: '🎋' },
            { code: '1F38D', emoji: '🎍' },
            { code: '1F38E', emoji: '🎎' },
            { code: '1F38F', emoji: '🎏' },
            { code: '1F390', emoji: '🎐' },
            { code: '1F391', emoji: '🎑' },
            { code: '1F9E7', emoji: '🧧' },
            { code: '1F380', emoji: '🎀' },
            { code: '1F381', emoji: '🎁' },
            { code: '1F397 FE0F', emoji: '🎗️' },
            { code: '1F39F FE0F', emoji: '🎟️' },
            { code: '1F3AB', emoji: '🎫' },
        ],
        'award-medal': [
            { code: '1F396 FE0F', emoji: '🎖️' },
            { code: '1F3C6', emoji: '🏆' },
            { code: '1F3C5', emoji: '🏅' },
            { code: '1F947', emoji: '🥇' },
            { code: '1F948', emoji: '🥈' },
            { code: '1F949', emoji: '🥉' },
        ],
        'sport': [
            { code: '26BD', emoji: '⚽' },
            { code: '26BE', emoji: '⚾' },
            { code: '1F94E', emoji: '🥎' },
            { code: '1F3C0', emoji: '🏀' },
            { code: '1F3D0', emoji: '🏐' },
            { code: '1F3C8', emoji: '🏈' },
            { code: '1F3C9', emoji: '🏉' },
            { code: '1F3BE', emoji: '🎾' },
            { code: '1F94F', emoji: '🥏' },
            { code: '1F3B3', emoji: '🎳' },
            { code: '1F3CF', emoji: '🏏' },
            { code: '1F3D1', emoji: '🏑' },
            { code: '1F3D2', emoji: '🏒' },
            { code: '1F94D', emoji: '🥍' },
            { code: '1F3D3', emoji: '🏓' },
            { code: '1F3F8', emoji: '🏸' },
            { code: '1F94A', emoji: '🥊' },
            { code: '1F94B', emoji: '🥋' },
            { code: '1F945', emoji: '🥅' },
            { code: '26F3', emoji: '⛳' },
            { code: '26F8 FE0F', emoji: '⛸️' },
            { code: '1F3A3', emoji: '🎣' },
            { code: '1F93F', emoji: '🤿' },
            { code: '1F3BD', emoji: '🎽' },
            { code: '1F3BF', emoji: '🎿' },
            { code: '1F6F7', emoji: '🛷' },
            { code: '1F94C', emoji: '🥌' },
        ],
        'game': [
            { code: '1F3AF', emoji: '🎯' },
            { code: '1FA80', emoji: '🪀' },
            { code: '1FA81', emoji: '🪁' },
            { code: '1F52B', emoji: '🔫' },
            { code: '1F3B1', emoji: '🎱' },
            { code: '1F52E', emoji: '🔮' },
            { code: '1FA84', emoji: '🪄' },
            { code: '1F3AE', emoji: '🎮' },
            { code: '1F579 FE0F', emoji: '🕹️' },
            { code: '1F3B0', emoji: '🎰' },
            { code: '1F3B2', emoji: '🎲' },
            { code: '1F9E9', emoji: '🧩' },
            { code: '1F9F8', emoji: '🧸' },
            { code: '1FA85', emoji: '🪅' },
            { code: '1FAA9', emoji: '🪩' },
            { code: '1FA86', emoji: '🪆' },
            { code: '2660 FE0F', emoji: '♠️' },
            { code: '2665 FE0F', emoji: '♥️' },
            { code: '2666 FE0F', emoji: '♦️' },
            { code: '2663 FE0F', emoji: '♣️' },
            { code: '265F FE0F', emoji: '♟️' },
            { code: '1F0CF', emoji: '🃏' },
            { code: '1F004', emoji: '🀄' },
            { code: '1F3B4', emoji: '🎴' },
        ],
        'arts & crafts': [
            { code: '1F3AD', emoji: '🎭' },
            { code: '1F5BC FE0F', emoji: '🖼️' },
            { code: '1F3A8', emoji: '🎨' },
            { code: '1F9F5', emoji: '🧵' },
            { code: '1FAA1', emoji: '🪡' },
            { code: '1F9F6', emoji: '🧶' },
            { code: '1FAA2', emoji: '🪢' },
        ],
        'clothing': [
            { code: '1F453', emoji: '👓' },
            { code: '1F576 FE0F', emoji: '🕶️' },
            { code: '1F97D', emoji: '🥽' },
            { code: '1F97C', emoji: '🥼' },
            { code: '1F9BA', emoji: '🦺' },
            { code: '1F454', emoji: '👔' },
            { code: '1F455', emoji: '👕' },
            { code: '1F456', emoji: '👖' },
            { code: '1F9E3', emoji: '🧣' },
            { code: '1F9E4', emoji: '🧤' },
            { code: '1F9E5', emoji: '🧥' },
            { code: '1F9E6', emoji: '🧦' },
            { code: '1F457', emoji: '👗' },
            { code: '1F458', emoji: '👘' },
            { code: '1F97B', emoji: '🥻' },
            { code: '1FA71', emoji: '🩱' },
            { code: '1FA72', emoji: '🩲' },
            { code: '1FA73', emoji: '🩳' },
            { code: '1F459', emoji: '👙' },
            { code: '1F45A', emoji: '👚' },
            { code: '1FAAD', emoji: '🪭' },
            { code: '1F45B', emoji: '👛' },
            { code: '1F45C', emoji: '👜' },
            { code: '1F45D', emoji: '👝' },
            { code: '1F6CD FE0F', emoji: '🛍️' },
            { code: '1F392', emoji: '🎒' },
            { code: '1FA74', emoji: '🩴' },
            { code: '1F45E', emoji: '👞' },
            { code: '1F45F', emoji: '👟' },
            { code: '1F97E', emoji: '🥾' },
            { code: '1F97F', emoji: '🥿' },
            { code: '1F460', emoji: '👠' },
            { code: '1F461', emoji: '👡' },
            { code: '1FA70', emoji: '🩰' },
            { code: '1F462', emoji: '👢' },
            { code: '1FAAE', emoji: '🪮' },
            { code: '1F451', emoji: '👑' },
            { code: '1F452', emoji: '👒' },
            { code: '1F3A9', emoji: '🎩' },
            { code: '1F393', emoji: '🎓' },
            { code: '1F9E2', emoji: '🧢' },
            { code: '1FA96', emoji: '🪖' },
            { code: '26D1 FE0F', emoji: '⛑️' },
            { code: '1F4FF', emoji: '📿' },
            { code: '1F484', emoji: '💄' },
            { code: '1F48D', emoji: '💍' },
            { code: '1F48E', emoji: '💎' },
        ],
        'sound': [
            { code: '1F507', emoji: '🔇' },
            { code: '1F508', emoji: '🔈' },
            { code: '1F509', emoji: '🔉' },
            { code: '1F50A', emoji: '🔊' },
            { code: '1F4E2', emoji: '📢' },
            { code: '1F4E3', emoji: '📣' },
            { code: '1F4EF', emoji: '📯' },
            { code: '1F514', emoji: '🔔' },
            { code: '1F515', emoji: '🔕' },
        ],
        'music': [
            { code: '1F3BC', emoji: '🎼' },
            { code: '1F3B5', emoji: '🎵' },
            { code: '1F3B6', emoji: '🎶' },
            { code: '1F399 FE0F', emoji: '🎙️' },
            { code: '1F39A FE0F', emoji: '🎚️' },
            { code: '1F39B FE0F', emoji: '🎛️' },
            { code: '1F3A4', emoji: '🎤' },
            { code: '1F3A7', emoji: '🎧' },
            { code: '1F4FB', emoji: '📻' },
        ],
        'musical-instrument': [
            { code: '1F3B7', emoji: '🎷' },
            { code: '1FA97', emoji: '🪗' },
            { code: '1F3B8', emoji: '🎸' },
            { code: '1F3B9', emoji: '🎹' },
            { code: '1F3BA', emoji: '🎺' },
            { code: '1F3BB', emoji: '🎻' },
            { code: '1FA95', emoji: '🪕' },
            { code: '1F941', emoji: '🥁' },
            { code: '1FA98', emoji: '🪘' },
            { code: '1FA87', emoji: '🪇' },
            { code: '1FA88', emoji: '🪈' },
            { code: '1FA89', emoji: '🪉' },
        ],
        'phone': [
            { code: '1F4F1', emoji: '📱' },
            { code: '1F4F2', emoji: '📲' },
            { code: '260E FE0F', emoji: '☎️' },
            { code: '1F4DE', emoji: '📞' },
            { code: '1F4DF', emoji: '📟' },
            { code: '1F4E0', emoji: '📠' },
        ],
        'computer': [
            { code: '1F50B', emoji: '🔋' },
            { code: '1FAAB', emoji: '🪫' },
            { code: '1F50C', emoji: '🔌' },
            { code: '1F4BB', emoji: '💻' },
            { code: '1F5A5 FE0F', emoji: '🖥️' },
            { code: '1F5A8 FE0F', emoji: '🖨️' },
            { code: '2328 FE0F', emoji: '⌨️' },
            { code: '1F5B1 FE0F', emoji: '🖱️' },
            { code: '1F5B2 FE0F', emoji: '🖲️' },
            { code: '1F4BD', emoji: '💽' },
            { code: '1F4BE', emoji: '💾' },
            { code: '1F4BF', emoji: '💿' },
            { code: '1F4C0', emoji: '📀' },
            { code: '1F9EE', emoji: '🧮' },
        ],
        'light & video': [
            { code: '1F3A5', emoji: '🎥' },
            { code: '1F39E FE0F', emoji: '🎞️' },
            { code: '1F4FD FE0F', emoji: '📽️' },
            { code: '1F3AC', emoji: '🎬' },
            { code: '1F4FA', emoji: '📺' },
            { code: '1F4F7', emoji: '📷' },
            { code: '1F4F8', emoji: '📸' },
            { code: '1F4F9', emoji: '📹' },
            { code: '1F4FC', emoji: '📼' },
            { code: '1F50D', emoji: '🔍' },
            { code: '1F50E', emoji: '🔎' },
            { code: '1F56F FE0F', emoji: '🕯️' },
            { code: '1F4A1', emoji: '💡' },
            { code: '1F526', emoji: '🔦' },
            { code: '1F3EE', emoji: '🏮' },
            { code: '1FA94', emoji: '🪔' },
        ],
        'book-paper': [
            { code: '1F4D4', emoji: '📔' },
            { code: '1F4D5', emoji: '📕' },
            { code: '1F4D6', emoji: '📖' },
            { code: '1F4D7', emoji: '📗' },
            { code: '1F4D8', emoji: '📘' },
            { code: '1F4D9', emoji: '📙' },
            { code: '1F4DA', emoji: '📚' },
            { code: '1F4D3', emoji: '📓' },
            { code: '1F4D2', emoji: '📒' },
            { code: '1F4C3', emoji: '📃' },
            { code: '1F4DC', emoji: '📜' },
            { code: '1F4C4', emoji: '📄' },
            { code: '1F4F0', emoji: '📰' },
            { code: '1F5DE FE0F', emoji: '🗞️' },
            { code: '1F4D1', emoji: '📑' },
            { code: '1F516', emoji: '🔖' },
            { code: '1F3F7 FE0F', emoji: '🏷️' },
        ],
        'money': [
            { code: '1F4B0', emoji: '💰' },
            { code: '1FA99', emoji: '🪙' },
            { code: '1F4B4', emoji: '💴' },
            { code: '1F4B5', emoji: '💵' },
            { code: '1F4B6', emoji: '💶' },
            { code: '1F4B7', emoji: '💷' },
            { code: '1F4B8', emoji: '💸' },
            { code: '1F4B3', emoji: '💳' },
            { code: '1F9FE', emoji: '🧾' },
            { code: '1F4B9', emoji: '💹' },
        ],
        'mail': [
            { code: '2709 FE0F', emoji: '✉️' },
            { code: '1F4E7', emoji: '📧' },
            { code: '1F4E8', emoji: '📨' },
            { code: '1F4E9', emoji: '📩' },
            { code: '1F4E4', emoji: '📤' },
            { code: '1F4E5', emoji: '📥' },
            { code: '1F4E6', emoji: '📦' },
            { code: '1F4EB', emoji: '📫' },
            { code: '1F4EA', emoji: '📪' },
            { code: '1F4EC', emoji: '📬' },
            { code: '1F4ED', emoji: '📭' },
            { code: '1F4EE', emoji: '📮' },
            { code: '1F5F3 FE0F', emoji: '🗳️' },
        ],
        'writing': [
            { code: '270F FE0F', emoji: '✏️' },
            { code: '2712 FE0F', emoji: '✒️' },
            { code: '1F58B FE0F', emoji: '🖋️' },
            { code: '1F58A FE0F', emoji: '🖊️' },
            { code: '1F58C FE0F', emoji: '🖌️' },
            { code: '1F58D FE0F', emoji: '🖍️' },
            { code: '1F4DD', emoji: '📝' },
        ],
        'office': [
            { code: '1F4BC', emoji: '💼' },
            { code: '1F4C1', emoji: '📁' },
            { code: '1F4C2', emoji: '📂' },
            { code: '1F5C2 FE0F', emoji: '🗂️' },
            { code: '1F4C5', emoji: '📅' },
            { code: '1F4C6', emoji: '📆' },
            { code: '1F5D2 FE0F', emoji: '🗒️' },
            { code: '1F5D3 FE0F', emoji: '🗓️' },
            { code: '1F4C7', emoji: '📇' },
            { code: '1F4C8', emoji: '📈' },
            { code: '1F4C9', emoji: '📉' },
            { code: '1F4CA', emoji: '📊' },
            { code: '1F4CB', emoji: '📋' },
            { code: '1F4CC', emoji: '📌' },
            { code: '1F4CD', emoji: '📍' },
            { code: '1F4CE', emoji: '📎' },
            { code: '1F587 FE0F', emoji: '🖇️' },
            { code: '1F4CF', emoji: '📏' },
            { code: '1F4D0', emoji: '📐' },
            { code: '2702 FE0F', emoji: '✂️' },
            { code: '1F5C3 FE0F', emoji: '🗃️' },
            { code: '1F5C4 FE0F', emoji: '🗄️' },
            { code: '1F5D1 FE0F', emoji: '🗑️' },
        ],
        'lock': [
            { code: '1F512', emoji: '🔒' },
            { code: '1F513', emoji: '🔓' },
            { code: '1F50F', emoji: '🔏' },
            { code: '1F510', emoji: '🔐' },
            { code: '1F511', emoji: '🔑' },
            { code: '1F5DD FE0F', emoji: '🗝️' },
        ],
        'tool': [
            { code: '1F528', emoji: '🔨' },
            { code: '1FA93', emoji: '🪓' },
            { code: '26CF FE0F', emoji: '⛏️' },
            { code: '2692 FE0F', emoji: '⚒️' },
            { code: '1F6E0 FE0F', emoji: '🛠️' },
            { code: '1F5E1 FE0F', emoji: '🗡️' },
            { code: '2694 FE0F', emoji: '⚔️' },
            { code: '1F4A3', emoji: '💣' },
            { code: '1FA83', emoji: '🪃' },
            { code: '1F3F9', emoji: '🏹' },
            { code: '1F6E1 FE0F', emoji: '🛡️' },
            { code: '1FA9A', emoji: '🪚' },
            { code: '1F527', emoji: '🔧' },
            { code: '1FA9B', emoji: '🪛' },
            { code: '1F529', emoji: '🔩' },
            { code: '2699 FE0F', emoji: '⚙️' },
            { code: '1F5DC FE0F', emoji: '🗜️' },
            { code: '2696 FE0F', emoji: '⚖️' },
            { code: '1F9AF', emoji: '🦯' },
            { code: '1F517', emoji: '🔗' },
            { code: '26D3 FE0F 200D 1F4A5', emoji: '⛓️‍💥' },
            { code: '26D3 FE0F', emoji: '⛓️' },
            { code: '1FA9D', emoji: '🪝' },
            { code: '1F9F0', emoji: '🧰' },
            { code: '1F9F2', emoji: '🧲' },
            { code: '1FA9C', emoji: '🪜' },
            { code: '1FA8F', emoji: '🪏' },
        ],
        'science': [
            { code: '2697 FE0F', emoji: '⚗️' },
            { code: '1F9EA', emoji: '🧪' },
            { code: '1F9EB', emoji: '🧫' },
            { code: '1F9EC', emoji: '🧬' },
            { code: '1F52C', emoji: '🔬' },
            { code: '1F52D', emoji: '🔭' },
            { code: '1F4E1', emoji: '📡' },
        ],
        'medical': [
            { code: '1F489', emoji: '💉' },
            { code: '1FA78', emoji: '🩸' },
            { code: '1F48A', emoji: '💊' },
            { code: '1FA79', emoji: '🩹' },
            { code: '1FA7C', emoji: '🩼' },
            { code: '1FA7A', emoji: '🩺' },
            { code: '1FA7B', emoji: '🩻' },
        ],
        'household': [
            { code: '1F6AA', emoji: '🚪' },
            { code: '1F6D7', emoji: '🛗' },
            { code: '1FA9E', emoji: '🪞' },
            { code: '1FA9F', emoji: '🪟' },
            { code: '1F6CF FE0F', emoji: '🛏️' },
            { code: '1F6CB FE0F', emoji: '🛋️' },
            { code: '1FA91', emoji: '🪑' },
            { code: '1F6BD', emoji: '🚽' },
            { code: '1FAA0', emoji: '🪠' },
            { code: '1F6BF', emoji: '🚿' },
            { code: '1F6C1', emoji: '🛁' },
            { code: '1FAA4', emoji: '🪤' },
            { code: '1FA92', emoji: '🪒' },
            { code: '1F9F4', emoji: '🧴' },
            { code: '1F9F7', emoji: '🧷' },
            { code: '1F9F9', emoji: '🧹' },
            { code: '1F9FA', emoji: '🧺' },
            { code: '1F9FB', emoji: '🧻' },
            { code: '1FAA3', emoji: '🪣' },
            { code: '1F9FC', emoji: '🧼' },
            { code: '1FAE7', emoji: '🫧' },
            { code: '1FAA5', emoji: '🪥' },
            { code: '1F9FD', emoji: '🧽' },
            { code: '1F9EF', emoji: '🧯' },
            { code: '1F6D2', emoji: '🛒' },
        ],
        'other-object': [
            { code: '1F6AC', emoji: '🚬' },
            { code: '26B0 FE0F', emoji: '⚰️' },
            { code: '1FAA6', emoji: '🪦' },
            { code: '26B1 FE0F', emoji: '⚱️' },
            { code: '1F9FF', emoji: '🧿' },
            { code: '1FAAC', emoji: '🪬' },
            { code: '1F5FF', emoji: '🗿' },
            { code: '1FAA7', emoji: '🪧' },
            { code: '1FAAA', emoji: '🪪' },
        ],
        'transport-sign': [
            { code: '1F3E7', emoji: '🏧' },
            { code: '1F6AE', emoji: '🚮' },
            { code: '1F6B0', emoji: '🚰' },
            { code: '267F', emoji: '♿' },
            { code: '1F6B9', emoji: '🚹' },
            { code: '1F6BA', emoji: '🚺' },
            { code: '1F6BB', emoji: '🚻' },
            { code: '1F6BC', emoji: '🚼' },
            { code: '1F6BE', emoji: '🚾' },
            { code: '1F6C2', emoji: '🛂' },
            { code: '1F6C3', emoji: '🛃' },
            { code: '1F6C4', emoji: '🛄' },
            { code: '1F6C5', emoji: '🛅' },
        ],
        'warning': [
            { code: '26A0 FE0F', emoji: '⚠️' },
            { code: '1F6B8', emoji: '🚸' },
            { code: '26D4', emoji: '⛔' },
            { code: '1F6AB', emoji: '🚫' },
            { code: '1F6B3', emoji: '🚳' },
            { code: '1F6AD', emoji: '🚭' },
            { code: '1F6AF', emoji: '🚯' },
            { code: '1F6B1', emoji: '🚱' },
            { code: '1F6B7', emoji: '🚷' },
            { code: '1F4F5', emoji: '📵' },
            { code: '1F51E', emoji: '🔞' },
            { code: '2622 FE0F', emoji: '☢️' },
            { code: '2623 FE0F', emoji: '☣️' },
        ],
        'arrow': [
            { code: '2B06 FE0F', emoji: '⬆️' },
            { code: '2197 FE0F', emoji: '↗️' },
            { code: '27A1 FE0F', emoji: '➡️' },
            { code: '2198 FE0F', emoji: '↘️' },
            { code: '2B07 FE0F', emoji: '⬇️' },
            { code: '2199 FE0F', emoji: '↙️' },
            { code: '2B05 FE0F', emoji: '⬅️' },
            { code: '2196 FE0F', emoji: '↖️' },
            { code: '2195 FE0F', emoji: '↕️' },
            { code: '2194 FE0F', emoji: '↔️' },
            { code: '21A9 FE0F', emoji: '↩️' },
            { code: '21AA FE0F', emoji: '↪️' },
            { code: '2934 FE0F', emoji: '⤴️' },
            { code: '2935 FE0F', emoji: '⤵️' },
            { code: '1F503', emoji: '🔃' },
            { code: '1F504', emoji: '🔄' },
            { code: '1F519', emoji: '🔙' },
            { code: '1F51A', emoji: '🔚' },
            { code: '1F51B', emoji: '🔛' },
            { code: '1F51C', emoji: '🔜' },
            { code: '1F51D', emoji: '🔝' },
        ],
        'religion': [
            { code: '1F6D0', emoji: '🛐' },
            { code: '269B FE0F', emoji: '⚛️' },
            { code: '1F549 FE0F', emoji: '🕉️' },
            { code: '2721 FE0F', emoji: '✡️' },
            { code: '2638 FE0F', emoji: '☸️' },
            { code: '262F FE0F', emoji: '☯️' },
            { code: '271D FE0F', emoji: '✝️' },
            { code: '2626 FE0F', emoji: '☦️' },
            { code: '262A FE0F', emoji: '☪️' },
            { code: '262E FE0F', emoji: '☮️' },
            { code: '1F54E', emoji: '🕎' },
            { code: '1F52F', emoji: '🔯' },
            { code: '1FAAF', emoji: '🪯' },
        ],
        'zodiac': [
            { code: '2648', emoji: '♈' },
            { code: '2649', emoji: '♉' },
            { code: '264A', emoji: '♊' },
            { code: '264B', emoji: '♋' },
            { code: '264C', emoji: '♌' },
            { code: '264D', emoji: '♍' },
            { code: '264E', emoji: '♎' },
            { code: '264F', emoji: '♏' },
            { code: '2650', emoji: '♐' },
            { code: '2651', emoji: '♑' },
            { code: '2652', emoji: '♒' },
            { code: '2653', emoji: '♓' },
            { code: '26CE', emoji: '⛎' },
        ],
        'av-symbol': [
            { code: '1F500', emoji: '🔀' },
            { code: '1F501', emoji: '🔁' },
            { code: '1F502', emoji: '🔂' },
            { code: '25B6 FE0F', emoji: '▶️' },
            { code: '23E9', emoji: '⏩' },
            { code: '23ED FE0F', emoji: '⏭️' },
            { code: '23EF FE0F', emoji: '⏯️' },
            { code: '25C0 FE0F', emoji: '◀️' },
            { code: '23EA', emoji: '⏪' },
            { code: '23EE FE0F', emoji: '⏮️' },
            { code: '1F53C', emoji: '🔼' },
            { code: '23EB', emoji: '⏫' },
            { code: '1F53D', emoji: '🔽' },
            { code: '23EC', emoji: '⏬' },
            { code: '23F8 FE0F', emoji: '⏸️' },
            { code: '23F9 FE0F', emoji: '⏹️' },
            { code: '23FA FE0F', emoji: '⏺️' },
            { code: '23CF FE0F', emoji: '⏏️' },
            { code: '1F3A6', emoji: '🎦' },
            { code: '1F505', emoji: '🔅' },
            { code: '1F506', emoji: '🔆' },
            { code: '1F4F6', emoji: '📶' },
            { code: '1F6DC', emoji: '🛜' },
            { code: '1F4F3', emoji: '📳' },
            { code: '1F4F4', emoji: '📴' },
        ],
        'gender': [
            { code: '2640 FE0F', emoji: '♀️' },
            { code: '2642 FE0F', emoji: '♂️' },
            { code: '26A7 FE0F', emoji: '⚧️' },
        ],
        'math': [
            { code: '2716 FE0F', emoji: '✖️' },
            { code: '2795', emoji: '➕' },
            { code: '2796', emoji: '➖' },
            { code: '2797', emoji: '➗' },
            { code: '1F7F0', emoji: '🟰' },
            { code: '267E FE0F', emoji: '♾️' },
        ],
        'punctuation': [
            { code: '203C FE0F', emoji: '‼️' },
            { code: '2049 FE0F', emoji: '⁉️' },
            { code: '2753', emoji: '❓' },
            { code: '2754', emoji: '❔' },
            { code: '2755', emoji: '❕' },
            { code: '2757', emoji: '❗' },
            { code: '3030 FE0F', emoji: '〰️' },
        ],
        'currency': [
            { code: '1F4B1', emoji: '💱' },
            { code: '1F4B2', emoji: '💲' },
        ],
        'other-symbol': [
            { code: '2695 FE0F', emoji: '⚕️' },
            { code: '267B FE0F', emoji: '♻️' },
            { code: '269C FE0F', emoji: '⚜️' },
            { code: '1F531', emoji: '🔱' },
            { code: '1F4DB', emoji: '📛' },
            { code: '1F530', emoji: '🔰' },
            { code: '2B55', emoji: '⭕' },
            { code: '2705', emoji: '✅' },
            { code: '2611 FE0F', emoji: '☑️' },
            { code: '2714 FE0F', emoji: '✔️' },
            { code: '274C', emoji: '❌' },
            { code: '274E', emoji: '❎' },
            { code: '27B0', emoji: '➰' },
            { code: '27BF', emoji: '➿' },
            { code: '303D FE0F', emoji: '〽️' },
            { code: '2733 FE0F', emoji: '✳️' },
            { code: '2734 FE0F', emoji: '✴️' },
            { code: '2747 FE0F', emoji: '❇️' },
            { code: '00A9 FE0F', emoji: '©️' },
            { code: '00AE FE0F', emoji: '®️' },
            { code: '2122 FE0F', emoji: '™️' },
            { code: '1FADF', emoji: '🫟' },
        ],
        'keycap': [
            { code: '0023 FE0F 20E3', emoji: '#️⃣' },
            { code: '002A FE0F 20E3', emoji: '*️⃣' },
            { code: '0030 FE0F 20E3', emoji: '0️⃣' },
            { code: '0031 FE0F 20E3', emoji: '1️⃣' },
            { code: '0032 FE0F 20E3', emoji: '2️⃣' },
            { code: '0033 FE0F 20E3', emoji: '3️⃣' },
            { code: '0034 FE0F 20E3', emoji: '4️⃣' },
            { code: '0035 FE0F 20E3', emoji: '5️⃣' },
            { code: '0036 FE0F 20E3', emoji: '6️⃣' },
            { code: '0037 FE0F 20E3', emoji: '7️⃣' },
            { code: '0038 FE0F 20E3', emoji: '8️⃣' },
            { code: '0039 FE0F 20E3', emoji: '9️⃣' },
            { code: '1F51F', emoji: '🔟' },
        ],
        'alphanum': [
            { code: '1F520', emoji: '🔠' },
            { code: '1F521', emoji: '🔡' },
            { code: '1F522', emoji: '🔢' },
            { code: '1F523', emoji: '🔣' },
            { code: '1F524', emoji: '🔤' },
            { code: '1F170 FE0F', emoji: '🅰️' },
            { code: '1F18E', emoji: '🆎' },
            { code: '1F171 FE0F', emoji: '🅱️' },
            { code: '1F191', emoji: '🆑' },
            { code: '1F192', emoji: '🆒' },
            { code: '1F193', emoji: '🆓' },
            { code: '2139 FE0F', emoji: 'ℹ️' },
            { code: '1F194', emoji: '🆔' },
            { code: '24C2 FE0F', emoji: 'Ⓜ️' },
            { code: '1F195', emoji: '🆕' },
            { code: '1F196', emoji: '🆖' },
            { code: '1F17E FE0F', emoji: '🅾️' },
            { code: '1F197', emoji: '🆗' },
            { code: '1F17F FE0F', emoji: '🅿️' },
            { code: '1F198', emoji: '🆘' },
            { code: '1F199', emoji: '🆙' },
            { code: '1F19A', emoji: '🆚' },
            { code: '1F201', emoji: '🈁' },
            { code: '1F202 FE0F', emoji: '🈂️' },
            { code: '1F237 FE0F', emoji: '🈷️' },
            { code: '1F236', emoji: '🈶' },
            { code: '1F22F', emoji: '🈯' },
            { code: '1F250', emoji: '🉐' },
            { code: '1F239', emoji: '🈹' },
            { code: '1F21A', emoji: '🈚' },
            { code: '1F232', emoji: '🈲' },
            { code: '1F251', emoji: '🉑' },
            { code: '1F238', emoji: '🈸' },
            { code: '1F234', emoji: '🈴' },
            { code: '1F233', emoji: '🈳' },
            { code: '3297 FE0F', emoji: '㊗️' },
            { code: '3299 FE0F', emoji: '㊙️' },
            { code: '1F23A', emoji: '🈺' },
            { code: '1F235', emoji: '🈵' },
        ],
        'geometric': [
            { code: '1F534', emoji: '🔴' },
            { code: '1F7E0', emoji: '🟠' },
            { code: '1F7E1', emoji: '🟡' },
            { code: '1F7E2', emoji: '🟢' },
            { code: '1F535', emoji: '🔵' },
            { code: '1F7E3', emoji: '🟣' },
            { code: '1F7E4', emoji: '🟤' },
            { code: '26AB', emoji: '⚫' },
            { code: '26AA', emoji: '⚪' },
            { code: '1F7E5', emoji: '🟥' },
            { code: '1F7E7', emoji: '🟧' },
            { code: '1F7E8', emoji: '🟨' },
            { code: '1F7E9', emoji: '🟩' },
            { code: '1F7E6', emoji: '🟦' },
            { code: '1F7EA', emoji: '🟪' },
            { code: '1F7EB', emoji: '🟫' },
            { code: '2B1B', emoji: '⬛' },
            { code: '2B1C', emoji: '⬜' },
            { code: '25FC FE0F', emoji: '◼️' },
            { code: '25FB FE0F', emoji: '◻️' },
            { code: '25FE', emoji: '◾' },
            { code: '25FD', emoji: '◽' },
            { code: '25AA FE0F', emoji: '▪️' },
            { code: '25AB FE0F', emoji: '▫️' },
            { code: '1F536', emoji: '🔶' },
            { code: '1F537', emoji: '🔷' },
            { code: '1F538', emoji: '🔸' },
            { code: '1F539', emoji: '🔹' },
            { code: '1F53A', emoji: '🔺' },
            { code: '1F53B', emoji: '🔻' },
            { code: '1F4A0', emoji: '💠' },
            { code: '1F518', emoji: '🔘' },
            { code: '1F533', emoji: '🔳' },
            { code: '1F532', emoji: '🔲' },
        ],
        'flag': [
            { code: '1F3C1', emoji: '🏁' },
            { code: '1F6A9', emoji: '🚩' },
            { code: '1F38C', emoji: '🎌' },
            { code: '1F3F4', emoji: '🏴' },
            { code: '1F3F3 FE0F', emoji: '🏳️' },
            { code: '1F3F3 FE0F 200D 1F308', emoji: '🏳️‍🌈' },
            { code: '1F3F3 FE0F 200D 26A7 FE0F', emoji: '🏳️‍⚧️' },
            { code: '1F3F4 200D 2620 FE0F', emoji: '🏴‍☠️' },
        ],
        'country-flag': [
            { code: '1F1E6 1F1E8', emoji: '🇦🇨' },
            { code: '1F1E6 1F1E9', emoji: '🇦🇩' },
            { code: '1F1E6 1F1EA', emoji: '🇦🇪' },
            { code: '1F1E6 1F1EB', emoji: '🇦🇫' },
            { code: '1F1E6 1F1EC', emoji: '🇦🇬' },
            { code: '1F1E6 1F1EE', emoji: '🇦🇮' },
            { code: '1F1E6 1F1F1', emoji: '🇦🇱' },
            { code: '1F1E6 1F1F2', emoji: '🇦🇲' },
            { code: '1F1E6 1F1F4', emoji: '🇦🇴' },
            { code: '1F1E6 1F1F6', emoji: '🇦🇶' },
            { code: '1F1E6 1F1F7', emoji: '🇦🇷' },
            { code: '1F1E6 1F1F8', emoji: '🇦🇸' },
            { code: '1F1E6 1F1F9', emoji: '🇦🇹' },
            { code: '1F1E6 1F1FA', emoji: '🇦🇺' },
            { code: '1F1E6 1F1FC', emoji: '🇦🇼' },
            { code: '1F1E6 1F1FD', emoji: '🇦🇽' },
            { code: '1F1E6 1F1FF', emoji: '🇦🇿' },
            { code: '1F1E7 1F1E6', emoji: '🇧🇦' },
            { code: '1F1E7 1F1E7', emoji: '🇧🇧' },
            { code: '1F1E7 1F1E9', emoji: '🇧🇩' },
            { code: '1F1E7 1F1EA', emoji: '🇧🇪' },
            { code: '1F1E7 1F1EB', emoji: '🇧🇫' },
            { code: '1F1E7 1F1EC', emoji: '🇧🇬' },
            { code: '1F1E7 1F1ED', emoji: '🇧🇭' },
            { code: '1F1E7 1F1EE', emoji: '🇧🇮' },
            { code: '1F1E7 1F1EF', emoji: '🇧🇯' },
            { code: '1F1E7 1F1F1', emoji: '🇧🇱' },
            { code: '1F1E7 1F1F2', emoji: '🇧🇲' },
            { code: '1F1E7 1F1F3', emoji: '🇧🇳' },
            { code: '1F1E7 1F1F4', emoji: '🇧🇴' },
            { code: '1F1E7 1F1F6', emoji: '🇧🇶' },
            { code: '1F1E7 1F1F7', emoji: '🇧🇷' },
            { code: '1F1E7 1F1F8', emoji: '🇧🇸' },
            { code: '1F1E7 1F1F9', emoji: '🇧🇹' },
            { code: '1F1E7 1F1FB', emoji: '🇧🇻' },
            { code: '1F1E7 1F1FC', emoji: '🇧🇼' },
            { code: '1F1E7 1F1FE', emoji: '🇧🇾' },
            { code: '1F1E7 1F1FF', emoji: '🇧🇿' },
            { code: '1F1E8 1F1E6', emoji: '🇨🇦' },
            { code: '1F1E8 1F1E8', emoji: '🇨🇨' },
            { code: '1F1E8 1F1E9', emoji: '🇨🇩' },
            { code: '1F1E8 1F1EB', emoji: '🇨🇫' },
            { code: '1F1E8 1F1EC', emoji: '🇨🇬' },
            { code: '1F1E8 1F1ED', emoji: '🇨🇭' },
            { code: '1F1E8 1F1EE', emoji: '🇨🇮' },
            { code: '1F1E8 1F1F0', emoji: '🇨🇰' },
            { code: '1F1E8 1F1F1', emoji: '🇨🇱' },
            { code: '1F1E8 1F1F2', emoji: '🇨🇲' },
            { code: '1F1E8 1F1F3', emoji: '🇨🇳' },
            { code: '1F1E8 1F1F4', emoji: '🇨🇴' },
            { code: '1F1E8 1F1F5', emoji: '🇨🇵' },
            { code: '1F1E8 1F1F6', emoji: '🇨🇶' },
            { code: '1F1E8 1F1F7', emoji: '🇨🇷' },
            { code: '1F1E8 1F1FA', emoji: '🇨🇺' },
            { code: '1F1E8 1F1FB', emoji: '🇨🇻' },
            { code: '1F1E8 1F1FC', emoji: '🇨🇼' },
            { code: '1F1E8 1F1FD', emoji: '🇨🇽' },
            { code: '1F1E8 1F1FE', emoji: '🇨🇾' },
            { code: '1F1E8 1F1FF', emoji: '🇨🇿' },
            { code: '1F1E9 1F1EA', emoji: '🇩🇪' },
            { code: '1F1E9 1F1EC', emoji: '🇩🇬' },
            { code: '1F1E9 1F1EF', emoji: '🇩🇯' },
            { code: '1F1E9 1F1F0', emoji: '🇩🇰' },
            { code: '1F1E9 1F1F2', emoji: '🇩🇲' },
            { code: '1F1E9 1F1F4', emoji: '🇩🇴' },
            { code: '1F1E9 1F1FF', emoji: '🇩🇿' },
            { code: '1F1EA 1F1E6', emoji: '🇪🇦' },
            { code: '1F1EA 1F1E8', emoji: '🇪🇨' },
            { code: '1F1EA 1F1EA', emoji: '🇪🇪' },
            { code: '1F1EA 1F1EC', emoji: '🇪🇬' },
            { code: '1F1EA 1F1ED', emoji: '🇪🇭' },
            { code: '1F1EA 1F1F7', emoji: '🇪🇷' },
            { code: '1F1EA 1F1F8', emoji: '🇪🇸' },
            { code: '1F1EA 1F1F9', emoji: '🇪🇹' },
            { code: '1F1EA 1F1FA', emoji: '🇪🇺' },
            { code: '1F1EB 1F1EE', emoji: '🇫🇮' },
            { code: '1F1EB 1F1EF', emoji: '🇫🇯' },
            { code: '1F1EB 1F1F0', emoji: '🇫🇰' },
            { code: '1F1EB 1F1F2', emoji: '🇫🇲' },
            { code: '1F1EB 1F1F4', emoji: '🇫🇴' },
            { code: '1F1EB 1F1F7', emoji: '🇫🇷' },
            { code: '1F1EC 1F1E6', emoji: '🇬🇦' },
            { code: '1F1EC 1F1E7', emoji: '🇬🇧' },
            { code: '1F1EC 1F1E9', emoji: '🇬🇩' },
            { code: '1F1EC 1F1EA', emoji: '🇬🇪' },
            { code: '1F1EC 1F1EB', emoji: '🇬🇫' },
            { code: '1F1EC 1F1EC', emoji: '🇬🇬' },
            { code: '1F1EC 1F1ED', emoji: '🇬🇭' },
            { code: '1F1EC 1F1EE', emoji: '🇬🇮' },
            { code: '1F1EC 1F1F1', emoji: '🇬🇱' },
            { code: '1F1EC 1F1F2', emoji: '🇬🇲' },
            { code: '1F1EC 1F1F3', emoji: '🇬🇳' },
            { code: '1F1EC 1F1F5', emoji: '🇬🇵' },
            { code: '1F1EC 1F1F6', emoji: '🇬🇶' },
            { code: '1F1EC 1F1F7', emoji: '🇬🇷' },
            { code: '1F1EC 1F1F8', emoji: '🇬🇸' },
            { code: '1F1EC 1F1F9', emoji: '🇬🇹' },
            { code: '1F1EC 1F1FA', emoji: '🇬🇺' },
            { code: '1F1EC 1F1FC', emoji: '🇬🇼' },
            { code: '1F1EC 1F1FE', emoji: '🇬🇾' },
            { code: '1F1ED 1F1F0', emoji: '🇭🇰' },
            { code: '1F1ED 1F1F2', emoji: '🇭🇲' },
            { code: '1F1ED 1F1F3', emoji: '🇭🇳' },
            { code: '1F1ED 1F1F7', emoji: '🇭🇷' },
            { code: '1F1ED 1F1F9', emoji: '🇭🇹' },
            { code: '1F1ED 1F1FA', emoji: '🇭🇺' },
            { code: '1F1EE 1F1E8', emoji: '🇮🇨' },
            { code: '1F1EE 1F1E9', emoji: '🇮🇩' },
            { code: '1F1EE 1F1EA', emoji: '🇮🇪' },
            { code: '1F1EE 1F1F1', emoji: '🇮🇱' },
            { code: '1F1EE 1F1F2', emoji: '🇮🇲' },
            { code: '1F1EE 1F1F3', emoji: '🇮🇳' },
            { code: '1F1EE 1F1F4', emoji: '🇮🇴' },
            { code: '1F1EE 1F1F6', emoji: '🇮🇶' },
            { code: '1F1EE 1F1F7', emoji: '🇮🇷' },
            { code: '1F1EE 1F1F8', emoji: '🇮🇸' },
            { code: '1F1EE 1F1F9', emoji: '🇮🇹' },
            { code: '1F1EF 1F1EA', emoji: '🇯🇪' },
            { code: '1F1EF 1F1F2', emoji: '🇯🇲' },
            { code: '1F1EF 1F1F4', emoji: '🇯🇴' },
            { code: '1F1EF 1F1F5', emoji: '🇯🇵' },
            { code: '1F1F0 1F1EA', emoji: '🇰🇪' },
            { code: '1F1F0 1F1EC', emoji: '🇰🇬' },
            { code: '1F1F0 1F1ED', emoji: '🇰🇭' },
            { code: '1F1F0 1F1EE', emoji: '🇰🇮' },
            { code: '1F1F0 1F1F2', emoji: '🇰🇲' },
            { code: '1F1F0 1F1F3', emoji: '🇰🇳' },
            { code: '1F1F0 1F1F5', emoji: '🇰🇵' },
            { code: '1F1F0 1F1F7', emoji: '🇰🇷' },
            { code: '1F1F0 1F1FC', emoji: '🇰🇼' },
            { code: '1F1F0 1F1FE', emoji: '🇰🇾' },
            { code: '1F1F0 1F1FF', emoji: '🇰🇿' },
            { code: '1F1F1 1F1E6', emoji: '🇱🇦' },
            { code: '1F1F1 1F1E7', emoji: '🇱🇧' },
            { code: '1F1F1 1F1E8', emoji: '🇱🇨' },
            { code: '1F1F1 1F1EE', emoji: '🇱🇮' },
            { code: '1F1F1 1F1F0', emoji: '🇱🇰' },
            { code: '1F1F1 1F1F7', emoji: '🇱🇷' },
            { code: '1F1F1 1F1F8', emoji: '🇱🇸' },
            { code: '1F1F1 1F1F9', emoji: '🇱🇹' },
            { code: '1F1F1 1F1FA', emoji: '🇱🇺' },
            { code: '1F1F1 1F1FB', emoji: '🇱🇻' },
            { code: '1F1F1 1F1FE', emoji: '🇱🇾' },
            { code: '1F1F2 1F1E6', emoji: '🇲🇦' },
            { code: '1F1F2 1F1E8', emoji: '🇲🇨' },
            { code: '1F1F2 1F1E9', emoji: '🇲🇩' },
            { code: '1F1F2 1F1EA', emoji: '🇲🇪' },
            { code: '1F1F2 1F1EB', emoji: '🇲🇫' },
            { code: '1F1F2 1F1EC', emoji: '🇲🇬' },
            { code: '1F1F2 1F1ED', emoji: '🇲🇭' },
            { code: '1F1F2 1F1F0', emoji: '🇲🇰' },
            { code: '1F1F2 1F1F1', emoji: '🇲🇱' },
            { code: '1F1F2 1F1F2', emoji: '🇲🇲' },
            { code: '1F1F2 1F1F3', emoji: '🇲🇳' },
            { code: '1F1F2 1F1F4', emoji: '🇲🇴' },
            { code: '1F1F2 1F1F5', emoji: '🇲🇵' },
            { code: '1F1F2 1F1F6', emoji: '🇲🇶' },
            { code: '1F1F2 1F1F7', emoji: '🇲🇷' },
            { code: '1F1F2 1F1F8', emoji: '🇲🇸' },
            { code: '1F1F2 1F1F9', emoji: '🇲🇹' },
            { code: '1F1F2 1F1FA', emoji: '🇲🇺' },
            { code: '1F1F2 1F1FB', emoji: '🇲🇻' },
            { code: '1F1F2 1F1FC', emoji: '🇲🇼' },
            { code: '1F1F2 1F1FD', emoji: '🇲🇽' },
            { code: '1F1F2 1F1FE', emoji: '🇲🇾' },
            { code: '1F1F2 1F1FF', emoji: '🇲🇿' },
            { code: '1F1F3 1F1E6', emoji: '🇳🇦' },
            { code: '1F1F3 1F1E8', emoji: '🇳🇨' },
            { code: '1F1F3 1F1EA', emoji: '🇳🇪' },
            { code: '1F1F3 1F1EB', emoji: '🇳🇫' },
            { code: '1F1F3 1F1EC', emoji: '🇳🇬' },
            { code: '1F1F3 1F1EE', emoji: '🇳🇮' },
            { code: '1F1F3 1F1F1', emoji: '🇳🇱' },
            { code: '1F1F3 1F1F4', emoji: '🇳🇴' },
            { code: '1F1F3 1F1F5', emoji: '🇳🇵' },
            { code: '1F1F3 1F1F7', emoji: '🇳🇷' },
            { code: '1F1F3 1F1FA', emoji: '🇳🇺' },
            { code: '1F1F3 1F1FF', emoji: '🇳🇿' },
            { code: '1F1F4 1F1F2', emoji: '🇴🇲' },
            { code: '1F1F5 1F1E6', emoji: '🇵🇦' },
            { code: '1F1F5 1F1EA', emoji: '🇵🇪' },
            { code: '1F1F5 1F1EB', emoji: '🇵🇫' },
            { code: '1F1F5 1F1EC', emoji: '🇵🇬' },
            { code: '1F1F5 1F1ED', emoji: '🇵🇭' },
            { code: '1F1F5 1F1F0', emoji: '🇵🇰' },
            { code: '1F1F5 1F1F1', emoji: '🇵🇱' },
            { code: '1F1F5 1F1F2', emoji: '🇵🇲' },
            { code: '1F1F5 1F1F3', emoji: '🇵🇳' },
            { code: '1F1F5 1F1F7', emoji: '🇵🇷' },
            { code: '1F1F5 1F1F8', emoji: '🇵🇸' },
            { code: '1F1F5 1F1F9', emoji: '🇵🇹' },
            { code: '1F1F5 1F1FC', emoji: '🇵🇼' },
            { code: '1F1F5 1F1FE', emoji: '🇵🇾' },
            { code: '1F1F6 1F1E6', emoji: '🇶🇦' },
            { code: '1F1F7 1F1EA', emoji: '🇷🇪' },
            { code: '1F1F7 1F1F4', emoji: '🇷🇴' },
            { code: '1F1F7 1F1F8', emoji: '🇷🇸' },
            { code: '1F1F7 1F1FA', emoji: '🇷🇺' },
            { code: '1F1F7 1F1FC', emoji: '🇷🇼' },
            { code: '1F1F8 1F1E6', emoji: '🇸🇦' },
            { code: '1F1F8 1F1E7', emoji: '🇸🇧' },
            { code: '1F1F8 1F1E8', emoji: '🇸🇨' },
            { code: '1F1F8 1F1E9', emoji: '🇸🇩' },
            { code: '1F1F8 1F1EA', emoji: '🇸🇪' },
            { code: '1F1F8 1F1EC', emoji: '🇸🇬' },
            { code: '1F1F8 1F1ED', emoji: '🇸🇭' },
            { code: '1F1F8 1F1EE', emoji: '🇸🇮' },
            { code: '1F1F8 1F1EF', emoji: '🇸🇯' },
            { code: '1F1F8 1F1F0', emoji: '🇸🇰' },
            { code: '1F1F8 1F1F1', emoji: '🇸🇱' },
            { code: '1F1F8 1F1F2', emoji: '🇸🇲' },
            { code: '1F1F8 1F1F3', emoji: '🇸🇳' },
            { code: '1F1F8 1F1F4', emoji: '🇸🇴' },
            { code: '1F1F8 1F1F7', emoji: '🇸🇷' },
            { code: '1F1F8 1F1F8', emoji: '🇸🇸' },
            { code: '1F1F8 1F1F9', emoji: '🇸🇹' },
            { code: '1F1F8 1F1FB', emoji: '🇸🇻' },
            { code: '1F1F8 1F1FD', emoji: '🇸🇽' },
            { code: '1F1F8 1F1FE', emoji: '🇸🇾' },
            { code: '1F1F8 1F1FF', emoji: '🇸🇿' },
            { code: '1F1F9 1F1E6', emoji: '🇹🇦' },
            { code: '1F1F9 1F1E8', emoji: '🇹🇨' },
            { code: '1F1F9 1F1E9', emoji: '🇹🇩' },
            { code: '1F1F9 1F1EB', emoji: '🇹🇫' },
            { code: '1F1F9 1F1EC', emoji: '🇹🇬' },
            { code: '1F1F9 1F1ED', emoji: '🇹🇭' },
            { code: '1F1F9 1F1EF', emoji: '🇹🇯' },
            { code: '1F1F9 1F1F0', emoji: '🇹🇰' },
            { code: '1F1F9 1F1F1', emoji: '🇹🇱' },
            { code: '1F1F9 1F1F2', emoji: '🇹🇲' },
            { code: '1F1F9 1F1F3', emoji: '🇹🇳' },
            { code: '1F1F9 1F1F4', emoji: '🇹🇴' },
            { code: '1F1F9 1F1F7', emoji: '🇹🇷' },
            { code: '1F1F9 1F1F9', emoji: '🇹🇹' },
            { code: '1F1F9 1F1FB', emoji: '🇹🇻' },
            { code: '1F1F9 1F1FC', emoji: '🇹🇼' },
            { code: '1F1F9 1F1FF', emoji: '🇹🇿' },
            { code: '1F1FA 1F1E6', emoji: '🇺🇦' },
            { code: '1F1FA 1F1EC', emoji: '🇺🇬' },
            { code: '1F1FA 1F1F2', emoji: '🇺🇲' },
            { code: '1F1FA 1F1F3', emoji: '🇺🇳' },
            { code: '1F1FA 1F1F8', emoji: '🇺🇸' },
            { code: '1F1FA 1F1FE', emoji: '🇺🇾' },
            { code: '1F1FA 1F1FF', emoji: '🇺🇿' },
            { code: '1F1FB 1F1E6', emoji: '🇻🇦' },
            { code: '1F1FB 1F1E8', emoji: '🇻🇨' },
            { code: '1F1FB 1F1EA', emoji: '🇻🇪' },
            { code: '1F1FB 1F1EC', emoji: '🇻🇬' },
            { code: '1F1FB 1F1EE', emoji: '🇻🇮' },
            { code: '1F1FB 1F1F3', emoji: '🇻🇳' },
            { code: '1F1FB 1F1FA', emoji: '🇻🇺' },
            { code: '1F1FC 1F1EB', emoji: '🇼🇫' },
            { code: '1F1FC 1F1F8', emoji: '🇼🇸' },
            { code: '1F1FD 1F1F0', emoji: '🇽🇰' },
            { code: '1F1FE 1F1EA', emoji: '🇾🇪' },
            { code: '1F1FE 1F1F9', emoji: '🇾🇹' },
            { code: '1F1FF 1F1E6', emoji: '🇿🇦' },
            { code: '1F1FF 1F1F2', emoji: '🇿🇲' },
            { code: '1F1FF 1F1FC', emoji: '🇿🇼' },
        ],
        'subdivision-flag': [
            { code: '1F3F4 E0067 E0062 E0065 E006E E0067 E007F', emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
            { code: '1F3F4 E0067 E0062 E0073 E0063 E0074 E007F', emoji: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' },
            { code: '1F3F4 E0067 E0062 E0077 E006C E0073 E007F', emoji: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
        ],
    }
};
export default embeddedData;
